// 中文（简体）翻译 —— cdnX 管理后台。
// 与 en-US.ts 保持 key 结构完全一致 —— 加新文案两边都要补。
export default {
  common: {
    deleted: '已删除',
    loadFailed: '加载失败',
    save: '保存',
    cancel: '取消',
    confirm: '确定',
    delete: '删除',
    edit: '编辑',
    create: '新建',
    refresh: '刷新',
    submit: '提交',
    loading: '加载中…',
    empty: '暂无数据',
    actions: '操作',
    status: '状态',
    name: '名称',
    type: '类型',
    yes: '是',
    no: '否',
    on: '开启',
    off: '关闭',
    search: '搜索',
    copy: '复制',
    copied: '已复制',
    back: '返回',
    next: '下一步',
    more: '更多',
  },
  app: {
    switchLanguage: '切换到 English',
    fullscreen: '全屏',
    exitFullscreen: '退出全屏',
    console: '控制台',
    toggleNav: '收起/展开导航',
    openMenu: '打开菜单',
    collapseMenu: '收起菜单',
    expandMenu: '展开菜单',
    foldMenu: '收起',
    searchPlaceholder: '支持按页面名、站点域名、节点搜索',
    search: '搜索',
    searchPage: '页面',
    searchHint: '输入页面、站点或节点名称；按 / 随时打开',
    notifications: '消息通知',
    toDashboard: '查看仪表盘',
    pageSettings: '自定义设置',
    searchNoHit: '没有匹配的结果',
    searchSite: '站点',
    searchNode: '节点',
    title: 'cdnX 管理后台',
    logout: '退出登录',
  },
  navbar: {
    tasks: '任务',
    tickets: '工单',
    audit: '审计',
    roleAdmin: '管理员',
    roleOperator: '运营人员',
    accountIdFull: '账号 ID：{id}',
    lostNodes: '掉线节点',
    openTickets: '待处理工单',
    failedTasks: '失败任务',
    unread: '未读消息',
  },
  nav: {
    dashboard: '仪表盘',
    cnameZones: '接入域名',
    regions: '地区管理',
    securityEvents: '安全事件',
    accessLogs: '访问日志',
    analytics: '数据分析',
    accessStats: '访问统计',
    originStats: '回源统计',
    login: '登录',
    nodes: '节点列表',
    tasks: '任务队列',
    domains: '站点列表',
    lineGroups: '线路组',
    dnsProviders: 'DNS 提供商',
    users: '客户列表',
    userGroups: '客户分组',
  },
  auth: {
    welcomeBack: '欢迎回来',
    loginFailed: '登录失败',
    signInSubtitle: '登录到 {name} 管理后台',
    username: '用户名',
    password: '密码',
    usernamePlaceholder: '请输入用户名',
    passwordPlaceholder: '请输入密码',
    signIn: '登录',
    unauthorized: '未授权或会话已过期，请重新登录',
    mfaLabel: '动态码',
    mfaHint: '打开身份验证器应用，输入显示的 6 位动态码',
    mfaVerify: '验证',
    mfaBack: '返回重新登录',
    smsLabel: '短信验证码',
    smsHint: '验证码将发送至 {phone}',
    smsSentHint: '验证码已发送至 {phone}，{minutes} 分钟内有效',
    useSms: '改用短信验证码',
    useMfa: '改用 MFA 动态码',
    forgot: '忘记密码？',
    resetSubtitle: '通过已验证的手机号重置密码',
    resetCodeHint: '验证码会发送到这个账号已验证的手机号',
    resetSubmit: '重置密码',
    resetDone: '密码已重置，请使用新密码登录',
    resetFailed: '重置失败',
    backToSignIn: '返回登录',
  },
  security: {
    title: '安全事件',
    statBlocked: '拦截次数',
    statEvents: '共 {n} 条事件',
    statIps: '攻击来源',
    statWaf: 'WAF 拦截',
    statCc: 'CC 拦截',
    unitTimes: '次',
    unitIps: '个',
    listTitle: '事件明细',
    filterAllModules: '全部模块',
    filterAllActions: '全部处置',
    ipPlaceholder: '来源 IP',
    timeCol: '时间',
    hostCol: '域名',
    ipCol: '来源 IP',
    moduleCol: '模块',
    actionCol: '处置',
    ruleCol: '规则',
    uriCol: '请求',
    nodeCol: '节点',
    rulePlaceholder: '规则名称',
    topAttackers: '攻击来源排行',
    topHosts: '被攻击域名',
    modulesCol: '命中模块',
    domainsCol: '域名数',
    ipsCol: '来源 IP',
    blockedCol: '拦截',
    lastSeenCol: '最后出现',
    block: '拉黑',
    blockNote: '安全事件拉黑 · {window}',
    onlyThisIp: '只看此 IP',
    noBlocks: '这段时间没有拦截',
    detailTitle: '事件详情',
    scoreCol: '分值',
    statusCol: '状态码',
    categoryCol: '规则分类',
    uaCol: 'User-Agent',
    ja3Col: 'JA3 指纹',
    pageN: '第 {n} 页',
    prev: '上一页',
    next: '下一页',
    noLogs: '未接入日志存储，暂无安全事件',
    empty: '这段时间没有安全事件',
    module_waf: 'WAF',
    module_cc: 'CC',
    module_acl: 'ACL',
    module_bot: 'Bot',
    module_geo: '区域屏蔽',
    module_iplist: 'IP 名单',
    module_challenge: '人机验证',
    module_edge: '边缘',
    module_guard: '节点防护',
    module_site: '站点',
    module_quota: '套餐配额',
    module_upstream: '回源',
    action_pass: '放行',
    action_redirect_https: 'HTTPS 跳转',
    action_challenge: '人机验证',
    action_challenge_verify: '提交验证',
    action_block: 'IP 名单拦截',
    action_block_acl: 'ACL 拦截',
    action_block_waf: 'WAF 拦截',
    action_block_bot: 'Bot 拦截',
    action_block_cc: 'CC 拦截',
    action_block_ban: '封禁拦截',
    action_block_geo: '区域拦截',
    action_log_geo: '区域观察',
    action_block_cross_site: '跨站拦截',
    action_ban: '验证失败封禁',
    action_suspended: '站点暂停',
    action_conn_limit: '连接数超限',
    action_shed: '回源过载',
    action_websocket_off: 'WebSocket 已关闭',
  },
  geoBlock: {
    title: '区域屏蔽',
    mode: '屏蔽模式',
    modes: { off: '关闭', block: '屏蔽所选地区', allow: '仅允许所选地区' },
    modeHint_off: '不按国家或地区限制访问。',
    modeHint_block: '来自所选国家或地区的访问按下方方式处置，其它地区正常访问。',
    modeHint_allow: '只有所选国家或地区可以正常访问，其它地区一律按下方方式处置。例如只勾选「中国」即为屏蔽海外。',
    action: '处置方式',
    actions: {
      drop: '丢弃连接（444）',
      deny: '拦截（403）',
      challenge_js: 'JS 验证',
      challenge_slider: '滑动验证',
      ban_kernel: '内核级封禁',
      log: '仅记录',
    },
    actionHint_drop: '不返回任何内容，直接断开连接。比 403 省资源，也不向对方透露任何信息。',
    actionHint_deny: '返回 403 状态码，访客能看到被拒绝了。',
    actionHint_ban_kernel: '第一次访问断开连接，同时把这个 IP 交给节点防火墙（nftables）。之后它的数据包在内核里直接丢弃，不再占用代理任何资源。',
    actionHint_challenge_js: '先通过 JS 验证才能访问，通过后在免验时长内不再验证。',
    actionHint_challenge_slider: '先拖动滑块通过验证才能访问，通过后在免验时长内不再验证。',
    actionHint_log: '不拦截，只在安全事件里记录。适合正式开启前先观察会影响多少访问。',
    banSeconds: '封禁时长（秒）',
    banSecondsHint: '60 秒到 30 天。到期后自动解除，在封禁日志里可以提前解除。',
    kernelWarn: '内核级封禁作用于整台节点：防火墙分不清数据包是访问哪个站点的，被封的 IP 在这台节点上的所有站点都打不开，不只是本站。只有这台节点上的站点都应当拒绝这些地区时再用。',
    regionsBlock: '要屏蔽的地区',
    regionsAllow: '允许访问的地区',
    levelCountry: '国家/地区（{count}）',
    levelProvince: '中国省份（{count}）',
    levelCity: '城市（{count}）',
    rowCountries: '国家/地区（{count}）',
    rowProvinces: '中国省份（{count}）',
    rowCities: '城市（{count}）',
    allProvinces: '中国内地全部 {count} 个省份',
    useCountryInstead: '改为整体选择「中国」（不依赖城市库，更准确）',
    unfold: '展开全部 {count} 个',
    fold: '收起',
    levelProvinceAll: '中国省份（全部）',
    provincesCovered: '已整体选择「中国」，所有省份都已包含。只想针对部分省份时，先在「国家/地区」里取消中国。',
    cityCovered: '已整体选择「{country}」，它的所有城市都已包含，不需要再单独添加。',
    summaryAllow: '只有来自 {places} 的访客可以访问，其他地区一律按「{action}」处置。',
    summaryBlock: '来自 {places} 的访客按「{action}」处置，其他地区正常访问。',
    summaryMore: '{list} 等 {count} 处',
    nothingSelected: '还没有选择任何地区',
    provinceHint: '中国内地 31 个省、自治区、直辖市。香港、澳门、台湾在「国家/地区」里选。',
    cityPlaceholder: '城市名，如 深圳 或 Shenzhen',
    addCity: '添加',
    cityHint: '按 GeoIP 数据库里的中文或英文城市名匹配，「市」「地区」等后缀写不写都可以。同名城市按所选国家区分。最多 200 个。',
    searchPlaceholder: '搜索国家/地区名称或代码',
    addGreaterChina: '+ 中国内地及港澳台',
    selectAll: '全选',
    clearAll: '清空',
    selectContinent: '全选本洲',
    clearContinent: '清空本洲',
    noMatch: '没有匹配的国家或地区',
    continents: { AS: '亚洲', EU: '欧洲', NA: '北美洲', SA: '南美洲', AF: '非洲', OC: '大洋洲', AN: '南极洲' },
    notesTitle: '说明',
    noteUnknown: '按访客 IP 判断所在国家或地区。无法判断的 IP（节点未安装 GeoIP 数据库、内网地址等）一律放行，不论哪种模式。',
    noteCityDb: '省份和城市需要节点装有 GeoLite2-City 数据库，没有时判断不出访客在哪个省市，这些条目一律放行；「仅允许」模式下就相当于只按国家判断。',
    noteWhitelist: 'IP 白名单中的地址不受区域屏蔽限制，可以用来放行被屏蔽地区里的合作方。',
    noteOrder: '区域屏蔽在强制验证和 CC、WAF 等规则之前执行，被拦截的访问不会再进入后续检查。',
    saved: '区域屏蔽设置已保存',
    saveFailed: '保存区域屏蔽设置失败',
  },
  ccProtection: {
    title: 'CC 防护',
    level: '防护等级',
    levels: { off: '关闭', loose: '宽松', normal: '正常', strict: '严格', attack: '攻击紧急' },
    levelHint_off: '不启用内置防护，只执行下方的自定义规则。',
    levelHint_loose: '单 IP 10 秒内超过 600 次请求弹出 JS 验证。几乎不会误伤，适合流量大、接口多的站点。',
    levelHint_normal: '单 IP 10 秒内超过 300 次请求，5 分钟内的请求都需要通过 JS 验证；反复触发 5 次封禁 10 分钟。',
    levelHint_strict: '单 IP 10 秒内超过 120 次请求，10 分钟内都需要通过 JS 验证；反复触发 3 次内核级封禁 30 分钟。',
    levelHint_attack: '全站强制 JS 验证；单 IP 10 秒内超过 60 次请求，15 分钟内都需要滑块验证；反复触发 2 次内核级封禁 1 小时。',
    attackWarn: '攻击紧急模式会让所有访客先通过验证，API 和无法执行 JS 的客户端会受影响，攻击结束后请及时调回。',
    auto: '自适应 CC',
    autoHint_off: '不会自动开启。遭受 CC 攻击时，需要手动把防护等级切到「攻击紧急」。',
    autoHint_loose: '请求量达到平时的 6 倍、同时源站一半请求失败或明显变慢时，自动对新访客开启验证。适合流量波动大的站点。',
    autoHint_normal: '请求量达到平时的 4 倍、同时源站开始报错或变慢时，自动对新访客开启验证；请求量恢复正常 5 分钟后自动关闭。',
    autoHint_strict: '请求量达到平时的 2.5 倍、同时源站稍有异常时，就对新访客开启验证。适合源站承载能力较弱的站点。',
    autoCommon: '各节点按本站平时的请求量和源站响应速度判断。已通过验证的访客、豁免路径和搜索引擎不受影响。',
    autoMode: '验证方式',
    autoActiveTitle: '自动防护中',
    autoActive: '{nodes} 个节点从 {since} 起对新访客开启了验证，触发原因：{reason}。目前每秒 {rps} 个请求，平时约 {baseline} 个。请求量恢复正常 5 分钟后自动关闭。',
    autoReason_failing: '源站请求大量失败',
    autoReason_slow: '源站响应明显变慢',
    autoMoot: '防护等级为「攻击紧急」或已开启强制验证时，所有新访客都会先验证，自适应 CC 不会再额外起作用。',
    failBan: '验证失败封禁',
    failBanDesc: '同一 IP 在统计周期内验证失败达到次数后，加入黑名单：节点直接下发内核级拦截，并记录到封禁日志。对强制验证和 CC 规则弹出的验证都生效。',
    failMax: '失败次数',
    failMaxHint: '拿到验证页却不通过、或提交错误答案都计一次，通过后清零。',
    failWindow: '统计周期（秒）',
    failBanSec: '封禁时长（秒）',
    failBanSecHint: '最长 30 天。',
    saved: 'CC 防护设置已保存',
    saveFailed: '保存 CC 防护设置失败',
  },
  challenge: {
    title: '强制验证',
    desc: '开启后，所有访问者必须先通过人机验证才能访问站点。已通过的访问者在有效期内不再重复验证。',
    warn: '这会改变每一个访问者看到的第一个页面。开启前请确认下方的搜索引擎放行和路径豁免配置正确，否则可能影响收录或打断 API 调用。',
    mode: '验证方式',
    mode_wait: '5 秒盾',
    mode_js: 'JS 验证',
    mode_click: '点击验证',
    mode_slider: '滑动验证',
    modeHint_wait: '显示"正在检查浏览器"，后台完成计算后自动放行，访问者无需操作。',
    modeHint_js: '同 5 秒盾，但显示计算进度。',
    modeHint_click: '访问者需要点击一次按钮。计算在页面加载时完成，点击只是确认。',
    modeHint_slider: '访问者需要把滑块拖到最右侧。',
    ttl: '免验时长（秒）',
    ttlHint: '通过后多久内不再要求验证。默认 1800 秒（30 分钟）。',
    difficulty: '计算难度',
    difficultyHint: '每提高 1，机器人的计算成本翻倍。默认 16，现代浏览器约几十毫秒。低于 12 几乎没有防护效果，高于 20 低端手机会明显卡顿。',
    bypassSpiders: '放行搜索引擎',
    bypassSpidersHint: '通过反查 DNS 验证真实身份的搜索引擎蜘蛛直接放行（伪造 UA 的仍会被拦）。关闭此项会导致站点从搜索引擎索引中消失，因为爬虫不执行 JS。',
    exemptPaths: '豁免路径',
    exemptPathsHint: '每行一个路径前缀，命中的请求跳过验证。API 接口、支付回调、健康检查必须加在这里——它们不是浏览器，永远通不过验证。按路径段匹配：/api 会豁免 /api/orders，但不会豁免 /apiary。',
    saved: '已保存并下发',
    saveFailed: '保存失败',
  },
  logs: {
    distribution: '日志分布',
    total: '共 {n} 条',
    noRows: '没有符合条件的日志',
    pickHint: '点击查看这一时段',
    list: '日志列表',
    export: '导出本页',
    requestCol: '请求',
    clientCol: '客户端',
    pageInfo: '第 {n} 页 · 本页 {rows} 条',
    pivot: '快速筛选',
    byIp: '此 IP',
    byUrl: '此 URL',
    byUa: '此 UA',
    byJa4: '此 JA4',
    byStatus: '此状态码',
    bytesUpCol: '请求大小',
    argsCol: '查询参数',
    noUpstream: '未回源',
    actionCol: '处置',
    action_pass: '放行',
    action_redirect_https: 'HTTPS 跳转',
    action_challenge: '人机校验',
    action_block_acl: 'ACL 拦截',
    action_block_waf: 'WAF 拦截',
    action_block_bot: 'Bot 拦截',
    action_block_cc: 'CC 拦截',
    action_block_ban: '封禁拦截',
    action_block_geo: '区域拦截',
    action_log_geo: '区域观察',
    action_block_cross_site: '跨站拦截',
    action_suspended: '站点暂停',
    requestIdCol: '请求 ID',
    geoCol: '地理位置',
    ispCol: '运营商',
    contentTypeCol: '内容类型',
    upstreamStatusCol: '回源状态',
    protoCol: '协议',
    portCol: '端口',
    tlsVersionCol: 'TLS 版本',
    tlsCipherCol: '密码套件',
    plaintext: '明文（非 TLS）',
    ja3Pending: '该连接无指纹（明文 HTTP，或握手未采集到）',
    ja4Hint: '扩展顺序排序后再哈希，同一浏览器多次访问保持一致（JA3 会变）',
    grpRequest: '请求',
    grpClient: '客户端',
    grpTls: 'TLS',
    grpResponse: '响应与回源',
    grpHeaders: '完整请求头',
    redactHint: 'Cookie、Authorization 等凭据类请求头的值已脱敏，只保留长度——日志页面不应该能读到客户的登录令牌。',
    headersTruncated: '请求头过多或过大，已截断，下方不是完整列表。',
    search: '查询',
    reset: '重置',
    detail: '详情',
    prev: '上一页',
    next: '下一页',
    pageN: '第 {n} 页',
    rangeLabel: '时间范围',
    timeCol: '时间',
    domainCol: '域名',
    uriCol: '路径',
    statusCol: '状态码',
    clientIpCol: '客户端 IP',
    rtCol: '耗时',
    upstreamTime: '回源',
    bytesCol: '流量',
    nodeCol: '节点',
    upstreamCol: '回源地址',
    cacheCol: '缓存',
    unavailable: '日志存储（ClickHouse）未配置，查询不可用。实时指标等其他功能不受影响。',
    action_websocket_off: 'WebSocket 已关闭',
  },
  analytics: {
    rangeBeyondLogs: '访问日志只保留 {n} 天',
    site: '站点',
    allSites: '全部站点',
    refresh: '刷新',
    updatedAt: '数据更新于 {time}',
    noLogs: '未配置日志存储（ClickHouse），无法统计访问数据。配置后，新的访问会出现在这里。',
    noLogsShort: '未配置日志存储',
    noData: '暂无数据',
    loadFailed: '加载失败',
    overview: '流量概览',
    requests: '请求数',
    traffic: '流量',
    bandwidth: '峰值带宽',
    hitRate: '缓存命中率',
    unitTimes: '次',
    trend: '流量趋势',
    tab_bandwidth: '带宽',
    tab_requests: '请求数',
    tab_traffic: '流量',
    tab_hitRate: '命中率',
    tab_errors: '错误',
    tab_latency: '响应时间',
    step_60: '每分钟一个点',
    step_600: '每 10 分钟一个点',
    step_3600: '每小时一个点',
    step_86400: '每天一个点',
    customer: '客户',
    allCustomers: '全部客户',
    subscription: '套餐订单',
    allSubscriptions: '全部套餐订单',
    expiresOn: '{date} 到期',
    time: '时间',
    from: '开始时间',
    to: '结束时间',
    reset: '重置',
    current_custom: '所选时段',
    prev_custom: '上一周期',
    vs_custom: '较上一周期',
    prev_days: '{n} 天前同期',
    vs_days: '较 {n} 天前同期',
    prev_1h: '上一小时',
    prev_today: '昨日同时段',
    prev_yesterday: '前日',
    prev_7d: '前 7 天',
    prev_30d: '前 30 天',
    status: '状态码分布',
    status_1xx: '信息',
    status_2xx: '成功',
    status_3xx: '重定向',
    status_4xx: '客户端错误',
    status_5xx: '服务端错误',
    totalRequests: '总请求',
    cache: '缓存命中',
    cache_HIT: '命中',
    cache_MISS: '未命中',
    cache_STALE: '过期命中',
    cache_BYPASS: '绕过缓存',
    cache_NONE: '未经缓存',
    protocol: '协议分布',
    device: '终端分布',
    device_desktop: '桌面端',
    device_mobile: '移动端',
    device_tablet: '平板',
    device_bot: '爬虫',
    device_tool: '脚本工具',
    device_unknown: '未知',
    region: '访问地区',
    regionCountry: '国家/地区',
    regionProvince: '国内省份',
    isp: '运营商',
    carrier_telecom: '中国电信',
    carrier_unicom: '中国联通',
    carrier_mobile: '中国移动',
    carrier_cernet: '教育网',
    carrier_tencent: '腾讯云',
    carrier_alibaba: '阿里云',
    carrier_huawei: '华为云',
    rank: '访问排行',
    rank_domain: '域名',
    rank_url: 'URL',
    rank_ip: 'IP',
    rank_referer: '来源',
    rank_node: '节点',
    colRank: '排名',
    colRequests: '请求数',
    colRequestShare: '请求占比',
    colTraffic: '流量',
    colTrafficShare: '流量占比',
    direct: '直接访问',
    unknown: '未知',
  },
  access: {
    viewLogs: '查看日志',
    grp_visitor: '访问者',
    grp_client: '客户端',
    grp_tls: 'TLS 与协议',
    grp_request: '请求',
    grp_response: '响应',
    dim_ip: 'IP',
    dim_ip24: 'IP 段 /24',
    dim_country: '国家/地区',
    dim_province: '省份',
    dim_city: '城市',
    dim_isp: '运营商',
    dim_asn: 'ASN',
    dim_ua: 'User-Agent',
    short_ua: 'UA',
    dim_browser: '浏览器',
    dim_os: '操作系统',
    dim_device: '设备类型',
    dim_ja4: 'JA4',
    dim_ja3: 'JA3',
    dim_tls: 'TLS 版本',
    dim_protocol: 'HTTP 版本',
    dim_scheme: 'HTTP / HTTPS',
    dim_host: '域名',
    dim_url: 'URL',
    dim_method: '请求方法',
    dim_referer: '来源站点',
    dim_referer_url: '来源页面',
    dim_content_type: '内容类型',
    dim_request_id: '请求 ID',
    dim_status: '状态码',
    dim_status_class: '状态码类别',
    dim_cache: '缓存状态',
    dim_action: '安全处置',
    dim_node: '节点',
    op_eq: '等于',
    op_ne: '不等于',
    op_contains: '包含',
    op_not_contains: '不包含',
    op_prefix: '开头是',
    op_cidr: '属于网段',
    filters: '条件',
    addFilter: '添加条件',
    editFilter: '修改条件',
    removeFilter: '移除条件',
    clearFilters: '清空条件',
    valuePlaceholder: '输入或从列表选择',
    cidrPlaceholder: '如 203.0.113.0/24',
    needValue: '请填写要匹配的值',
    badCidr: '网段格式不对，例如 203.0.113.0/24',
    apply: '应用',
    cancel: '取消',
    emptyUa: '（空）',
    noFingerprint: '无（明文 HTTP）',
    plaintext: '明文 HTTP',
    none: '无',
    other: '其他',
    added: '已添加条件：{cond}',
    logs: '查看日志',
    profile: '访问详情',
    summaryTop: '下面是前 {n} 个',
    selected: '已选 {n} 个',
    blockSelected: '拉黑所选',
    clearSelection: '取消选择',
    searchRows: '在结果中查找',
    topN: '前 {n} 个',
    export: '导出 CSV',
    colRequests: '请求数',
    colPeak: '峰值/分钟',
    colErrors: '错误',
    colBlocked: '已拦截',
    colTraffic: '流量',
    colUrls: 'URL 数',
    colIps: 'IP 数',
    colLast: '最近访问',
    colActions: '操作',
    perMinute: '次/分钟',
    seen: '首次 — 最近访问',
    block: '拉黑',
    denied: '已拉黑',
    deniedSome: '部分拉黑',
    deniedBy: '已在黑名单中：{entry}',
    deniedByRule: '已由{rule}拉黑',
    deniedEverywhere: '对所有站点生效',
    deniedOnSites: '范围内 {n} 个站点均已生效',
    deniedOnSome: '{rule}已在 {n}/{of} 个站点生效',
    deniedRest: '拉黑可补齐其余 {n} 个站点',
    ruleRef: '规则「{name}」',
    ruleRefMore: '规则「{name}」等 {n} 条',
    signal_burst: '高频',
    signal_errors: '高错误率',
    signal_scan: '疑似扫描',
    signal_blocked: '多数已拦截',
    signalHint_burst: '最忙的一分钟请求过多：单个 IP 超过 300 次，/24 网段超过 3000 次',
    signalHint_errors: '一半以上的请求返回 4xx 或 5xx',
    signalHint_scan: '访问了 100 个以上不同的路径，且三成以上返回 4xx',
    signalHint_blocked: '一半以上的请求已被防护规则拦截',
    ago_now: '刚刚',
    ago_min: '{n} 分钟前',
    ago_hour: '{n} 小时前',
    ago_day: '{n} 天前',
    blockTitle: '拉黑 {n} 个{dim}',
    blockConfirm: '确认拉黑',
    andMore: '等共 {n} 个',
    cannotBlockSome: '其中 {n} 个是空值或未知，无法拉黑，已略过',
    blockScope: '生效范围',
    scopeSystem: '全平台（所有站点）',
    scopeUser: '仅客户 {name} 的站点',
    scopeUserNone: '仅某个客户的站点（先在筛选中选择客户或站点）',
    enforcement: '拦截方式',
    enforcementHint: '普通封禁在边缘返回 403；内核级封禁在节点防火墙直接丢包，最省资源，但对整台节点生效。',
    note: '备注',
    blockNote: '访问统计拉黑 · {window} · {dim}',
    blockedOnList: '已加入黑名单：{n} 个{dim}',
    blockedSkipped: '已加入黑名单：{n} 个{dim}；另有 {s} 个原本就在名单中',
    blockSites: '生效站点',
    blockSitesHint: '将为 {n} 个站点各添加一条访问控制规则，并立即发布到节点。',
    blockSitesDone: '另有 {n} 个站点已拉黑，未选中。',
    siteDenied: '{name}（已拉黑）',
    pickSites: '请选择要生效的站点',
    nameRule: '请填写规则名称',
    blockAction: '处置方式',
    action_deny403: '拒绝访问 (403)',
    action_deny444: '直接断开连接',
    action_log: '仅记录',
    ruleName: '规则名称',
    blockRuleName: '访问统计拉黑 · {dim}',
    blockedByRule: '已在 {n} 个站点添加规则并发布',
    blockedPartly: '{n} 个站点已生效，{f} 个失败：{sites}',
    summaryKeys: '共 {keys} 个{dim}',
    summaryRequests: '合计 {requests} 次请求',
  },
  origin: {
    overview: '回源概览',
    requests: '回源请求数',
    traffic: '回源流量',
    bandwidth: '回源峰值带宽',
    failRate: '回源失败率',
    noCompare: '无同期对比',
    noCompareTip: '访问日志只保留 30 天，前一周期的数据已不完整，因此不做同期对比。',
    estimated: '{pct} 的回源请求来自尚未升级的节点，未上报回源字节，其回源流量与带宽按发往客户端的字节估算。',
    trend: '回源趋势',
    tab_bandwidth: '回源带宽',
    tab_requests: '回源请求',
    tab_traffic: '回源流量',
    tab_rate: '回源率',
    tab_status: '状态码',
    tab_latency: '回源耗时',
    status: '回源状态码',
    status_fail: '无响应',
    status_fail_note: '连接失败、超时或无法解析',
    status_fail_short: '连接失败或超时',
    totalRequests: '回源请求',
    codes: '状态码明细',
    cause: '回源原因',
    cause_MISS: '缓存未命中',
    cause_NONE: '未配置缓存',
    cause_BYPASS: '绕过缓存',
    cause_STALE: '过期副本',
    time: '回源耗时分布',
    rank: '回源排行',
    rank_domain: '域名',
    rank_origin: '源站',
    rank_url: 'URL',
    rank_node: '节点',
    colRequests: '回源请求数',
    colShare: '请求占比',
    colTraffic: '回源流量',
    colFailRate: '失败率',
    colAvgTime: '平均耗时',
    failSplit: '5xx {s5xx} 次 · 无响应 {failed} 次',
  },
  serving: {
    col: '配置生效',
    title: '配置生效',
    intro: '对比节点实际服务的配置与主控发布的配置：边缘自己上报加载结果，agent 每分钟逐站点探测一次，主控每 15 秒判定一次。',
    status_ok: '已生效',
    status_syncing: '同步中',
    status_partial: '部分生效',
    status_risk: '有风险',
    status_probe_failed: '探测异常',
    status_not_effective: '未生效',
    status_unknown: '未知',
    reason_inactive: '节点未启用',
    reason_offline: '节点离线，暂无法判断',
    reason_no_report: 'agent 版本较旧，未上报生效状态',
    reason_edge_without_state: '边缘版本较旧，未上报生效状态',
    reason_state_broken: '边缘状态文件无法读取',
    reason_state_stale: '边缘进程已停止更新状态，可能已停止，或不是正在服务的进程',
    reason_behind: '边缘仍在服务旧版本配置',
    reason_load_failed: '边缘加载新配置失败',
    reason_root: '边缘无法读取配置目录',
    reason_delivery_failed: '新配置未能下发到节点',
    reason_skipped: '部分站点被边缘跳过，这些站点在该节点上无法访问',
    reason_parts: '部分全局配置未应用',
    reason_probe: '站点探测持续失败',
    reason_outside_unit: '边缘进程不在 cdnx-edge.service 中运行，升级与重启无法管理它',
    reason_grace: '新配置正在下发',
    code_tls: 'TLS 握手失败，节点不认识该域名',
    code_cert_mismatch: '节点下发的证书与配置不一致',
    code_unknown_host: '节点未服务该域名',
    code_stale_bundle: '节点服务的配置版本不对',
    code_connect: '无法连接边缘',
    code_bad_answer: '边缘应答异常',
    code_bundle_cert: '配置中的证书无法读取',
    code_skipped: '已被边缘跳过',
    code_part: '未应用',
    part_ip_lists: 'IP 名单',
    part_protection: '节点防护',
    part_pages: '默认页面',
    part_quota: '套餐配额',
    part_l4: '应用加速',
    part_branding: '品牌信息',
    latest: '应服务版本',
    serving: '实际服务版本',
    none: '无',
    sites: '加载站点',
    sitesOf: '{loaded} / {expected}',
    bundleRoot: '配置目录',
    process: '边缘进程',
    processOf: 'PID {pid} · {version}',
    inUnit: '服务单元',
    inUnitYes: '在 cdnx-edge.service 中',
    inUnitNo: '不在服务单元中',
    stateAge: '状态更新',
    agoSec: '{n} 秒前',
    probe: '最近探测',
    probeOf: '{probed} / {total} 个站点 · {age}前',
    probeNone: '尚未探测',
    applied: '最近下发',
    effective_effective: '边缘已加载',
    effective_partial: '边缘已加载，部分未生效',
    effective_not_effective: '边缘未加载',
    effective_unknown: '边缘未上报',
    problems: '异常',
    otherProblems: '其他异常',
    noProblem: '节点正在服务最新发布的配置',
    colSite: '站点',
    colProblem: '问题',
    colDetail: '详情',
    colFor: '持续',
    skippedTitle: '被跳过的站点',
    warningsTitle: '未生效的规则',
    warningsHint: '站点照常服务，但这些规则没有生效',
    probeTitle: '探测失败的站点',
    alertsTitle: '告警记录',
    colKind: '告警',
    colOpened: '开始时间',
    colResolved: '恢复时间',
    open: '未恢复',
    moreSites: '另有 {n} 个',
    failure: '最近一次加载失败',
    versionsLine: '应服务版本 {latest}，实际服务版本 {serving}',
    partLine: '{name}：{problem}',
    siteNodes: '生效节点',
    siteNodesOf: '{serving} / {nodes}',
    siteNodesHint: '正在服务这个站点最新配置的节点数 / 应服务的节点数',
    siteNodesUnknown: '其中 {n} 台节点版本较旧，无法判断',
    siteNodesHintUnknown: '正在服务这个站点最新配置的节点数 / 应服务的节点数；其中 {n} 台节点版本较旧，无法判断',
    dh: '{d} 天 {h} 小时',
    hm: '{h} 小时 {m} 分钟',
    m: '{m} 分钟',
    s: '{s} 秒',
    since: '自 {time}',
    viewNode: '查看节点',
  },
  nodes: {
    manage: '管理',
    backToList: '返回节点列表',
    ipCol: 'IP 地址',
    edgeCol: '边缘版本',
    osCol: '操作系统',
    cpuCoresCol: 'CPU 核心',
    uptimeCol: '运行时长',
    sectionOverview: '概览',
    sectionIPs: 'IP 管理',
    liveMetrics: '实时指标',
    history: '历史曲线',
    historyUnavailable: '历史曲线需要 ClickHouse，当前未配置。实时指标不受影响。',
    noSamplesYet: '暂无采样数据',
    metricsStale: '该节点已超过 30 秒没有上报指标，下面显示的是最后一次采样值。',
    specs: '硬件规格',
    cpuUsage: 'CPU',
    memUsage: '内存',
    diskUsage: '磁盘',
    network: '网络',
    netIn: '入站流量',
    netOut: '出站流量',
    pktIn: '入站包速率',
    pktOut: '出站包速率',
    connChart: '并发连接',
    dropChart: '连接丢弃',
    loadAvg: '负载',
    cores: '核',
    uptimeDHM: '{d} 天 {h} 小时 {m} 分',
    uptimeHM: '{h} 小时 {m} 分',
    addIP: '添加 IP',
    ipAdded: 'IP 已添加',
    ipAddFailed: '添加失败',
    ipDeleted: 'IP 已删除',
    ipDeleteFailed: '删除失败',
    ipDeleteTitle: '删除 IP',
    ipDeleteConfirm: '确定要删除 {ip} 吗？如果它正在参与解析，删除后会从 DNS 记录中移除。',
    ipDnsUpdated: '解析设置已更新',
    ipUpdateFailed: '更新失败',
    ipFamilyCol: '类型',
    ipInDnsCol: '参与解析',
    ipNoteCol: '备注',
    ipPrimary: '主 IP',
    ipPrimaryLocked: '主 IP 由心跳自动发现和维护，不能删除。如需停止解析，请关闭「参与解析」。',
    ipDnsHint: '开启「参与解析」的 IP 才会被下发到 DNS 的 A 记录中。关闭后该 IP 仍归属此节点，但不会有用户流量进来。',
    ipPublicOnlyHint: '必须是公网可路由地址。内网地址（10.x、192.168.x、127.0.0.1 等）会被拒绝——把它们写进公网解析会导致用户无法访问。',
    title: '节点',
    nameCol: '节点标识',
    statusCol: '状态',
    publicIpCol: '公网 IP',
    aliasCol: '昵称',
    aliasHint: '给这台机器起的名字，只影响控制台显示；「节点标识」列是节点注册时上报的、不可更改的名称。',
    aliasPlaceholder: '例如 杭州一号机',
    editModalTitle: '编辑节点 - {name}',
    editSuccess: '节点已更新',
    editFailed: '更新失败',
    regionHint: '只能选「地区管理」里已登记的地区。留空表示还没分配。',
    regionPlaceholder: '选择地区（可留空）',
    noRegionsHint: '还没有地区，请先到「地区管理」页面添加',
    ispCol: '运营商',
    ispPlaceholder: '例如 电信',
    networkCol: '网络',
    netUp: '上行',
    netDown: '下行',
    connCol: '连接',
    connConcurrent: '并发连接',
    connDropped: '连接丢弃',
    pktDropped: '丢包',
    regionCol: '地区',
    agentCol: 'Agent',
    versionCol: 'Agent 版本',
    lastHeartbeatCol: '最近心跳',
    issueToken: '签发注册令牌',
    issueTokenDesc: '把下面的命令复制到边缘机器上执行',
    tokenTtl: '有效期（秒）',
    tokenIssued: '令牌已签发，复制后立即在边缘节点使用',
    tokenModalTitle: '一次性注册令牌',
    tokenWarn: '令牌仅显示一次，请立即复制——之后无法再查看。',
    tokenExpiresAt: '过期时间',
    tokenInstallHint: '在新节点上执行这一条命令即可（需 root）：',
    tokenInstallNote: '脚本、二进制和配置公钥都由主控机下发，节点只需要能访问上面这个地址。令牌过期后这条命令就失效了。',
    activate: '激活',
    init: '完成初始化',
    initSuccess: '节点已激活',
    initFailed: '激活失败',
    issueFailed: '签发令牌失败',
    statusPendingInit: '待初始化',
    statusActive: '运行中',
    statusDisabled: '已禁用',
    statusMaintenance: '维护中',
    statusOffline: '离线',
    sendCommand: '下发指令',
    commandSent: '指令已下发',
    commandFailed: '下发失败',
    taskType: {
      resync_nftables: '重新同步防火墙规则',
      reload_config: '立即拉取配置',
    },
    upgradeAll: '全部更新（{n}）',
    upgrade: '更新',
    upgradeQueued: '已下发 {n} 个更新任务',
    upgradeTo: '更新到 {v}',
    upgrade_running: '更新中',
    upgrade_outdated: '可更新',
    upgrade_failed: '更新失败',
    upgradeReason_agentTooOld: '节点程序版本过旧，不支持在线更新：请先在节点上执行一次「系统更新」页里的节点初始化命令',
    upgradeReason_noUpdater: '节点尚未安装更新服务：请先在节点上执行一次「系统更新」页里的节点初始化命令',
    upgradeReason_noAnswer: '节点 30 分钟内没有回应，可以重新更新',
  },
  tasks: {
    timeCol: '时间',
    lastRunShort: '最近',
    nextRunShort: '下次',
    createdShort: '创建',
    finishedShort: '完成',
    attemptOf: '第 {n}/{max} 次',
    type_auto_renew: '套餐自动续费',
    type_cert_renew: '续期证书',
    type_clickhouse_cleanup: '清理 ClickHouse 数据',
    filterAllTypes: '全部类型',
    searchTarget: '搜索对象',
    detail_names: '证书域名',
    detail_expires: '原证书到期',
    detail_new_cert_id: '新证书 ID',
    detail_updated: '更新',
    detail_lines: '线路',
    detail_dropped: '删除内容',
    detail_freed: '释放空间',
    detail_disk: '磁盘使用',
    detail_trigger: '触发方式',
    type_cert_issue: '申请证书',
    type_control_cert_issue: '申请主控证书',
    type_console_cert_issue: '申请主控域名证书',
    detail_site: '控制台',
    detail_domain: '域名',
    detail_issuer: '颁发者',
    detail_not_after: '到期时间',
    detail_error: '错误',
    detail_email: '邮箱',
    detail_ca: '证书颁发机构',
    detail_cert_id: '证书 ID',
    detail_line: '解析线路',
    detail_ttl: 'TTL',
    type_line_publish: '发布线路解析',
    detail_node_group_id: '线路组 ID',
    detail_addresses: '节点 IP',
    detail_created: '新增',
    detail_deleted: '删除',
    tabSystem: '系统任务',
    tabNode: '节点任务',
    targetCol: '对象',
    resultCol: '结果',
    nextRunCol: '下次执行',
    lastRunCol: '最近执行',
    actionsCol: '操作',
    retry: '重试',
    retried: '已重新排队',
    autoRefresh: '每 10 秒自动刷新',
    rawMessage: '原始信息',
    detail: '详情',
    warningWith: '警告：{message}',
    type_cname_publish: '发布 CNAME 记录',
    type_cname_verify: '验证站点解析',
    type_cname_remove: '删除站点 CNAME 记录',
    type_alias_verify: '验证别名解析',
    type_l4_cname_publish: '发布应用加速解析',
    type_resync_nftables: '同步防火墙规则',
    type_reload_config: '重载配置',
    type_release_ban: '解除封禁',
    type_cache_purge: '刷新缓存',
    type_cache_prefetch: '预热缓存',
    detail_site_id: '站点 ID',
    detail_rule_id: '规则 ID',
    detail_host: 'CNAME 主机名',
    detail_zone: '接入域名',
    detail_dns_provider_id: 'DNS 账号 ID',
    detail_target: '指向',
    detail_action: '动作',
    detail_record_id: '服务商记录 ID',
    detail_expected: '期望指向',
    detail_resolved: '实际解析',
    systemHint: '控制面自己执行的自动化工作：站点和线路的解析、证书申请与续期、ClickHouse 清理、套餐自动续费。失败会按间隔自动重试，每次尝试的原因都记录在这里；线路解析每 10 分钟核对一次，没有变化时只更新同一条记录。已结束的任务保留 30 天。',
    title: '任务队列',
    idCol: 'ID',
    nodeCol: '节点',
    typeCol: '类型',
    statusCol: '状态',
    createdAtCol: '创建时间',
    finishedAtCol: '完成时间',
    errorCol: '错误信息',
    filterAllNodes: '全部节点',
    filterAllStatus: '全部状态',
    statusPending: '待执行',
    statusLeased: '已下发',
    statusSuccess: '成功',
    statusFailed: '失败',
    statusCancelled: '已取消',
    loadFailed: '加载任务列表失败',
    type_system_update: '更新主控',
    type_upgrade: '更新节点组件',
  },
  domains: {
    aliasDeleteConfirm: '删除域名 {host}？节点将不再响应它。',
    originDeleteConfirm: '删除源站 {addr}？',
    originAddrRequired: '请填写源站地址',
    deleteSite: '删除站点',
    changePackageAction: '更换套餐',
    listTitle: '全部站点',
    listCount: '共 {n} 个',
    listFiltered: '筛选后 {n} 个',
    searchPlaceholder: '搜索主域名或 CNAME',
    filterAllOwners: '全部用户',
    filterAllPackages: '全部套餐',
    filterAllStatus: '全部状态',
    filterAllSsl: '全部 SSL 模式',
    filterSuspended: '已暂停',
    resetFilters: '重置',
    statTotal: '站点总数',
    statToday: '今日 +{n}',
    statActive: '生效中',
    statDraft: '配置中',
    statDisabled: '已禁用',
    statSuspended: '{n} 个已暂停',
    statDraftNote: '等待客户解析 CNAME',
    siteCol: '站点',
    createdAtCol: '创建时间',
    updatedAtCol: '最近修改',
    more: '更多',
    ssl_off: '关闭',
    ssl_flexible: '灵活',
    ssl_full: '完全',
    ssl_strict: '完全（严格）',
    ssl_force_https: '强制 HTTPS',
    sslHint_off: '访客只能用 HTTP 访问，节点不监听 HTTPS。',
    sslHint_flexible: '访客到节点 HTTPS，节点到源站 HTTP。源站没有证书时用。',
    sslHint_full: '访客到节点、节点到源站都走 HTTPS，不校验源站证书，自签证书也可以。',
    sslHint_strict: '全程 HTTPS，并校验源站证书必须有效且与回源 Host 匹配。',
    sslHint_force_https: '全程 HTTPS，HTTP 访问 301 跳转到 HTTPS；回源不校验源站证书。',
    proxy_proxy: '代理加速',
    proxy_dns_only: '仅 DNS',
    proxyHint_proxy: '流量经过节点，缓存、防护规则和证书都在节点上生效。',
    proxyHint_dns_only: '只保留解析记录，流量直达源站，节点上的配置不生效。',
    realIpHeaderHint: '节点把访客真实 IP 放进这个请求头转给源站，源站按它取客户端地址。',
    hostCol: '域名',
    hostTypeCol: '类型',
    primaryTag: '主域名',
    aliasTag: '附加域名',
    aliasCount: '共 {n} 个域名',
    hostVerifyCol: '解析验证',
    hostVerified: '已验证',
    hostPending: '待验证',
    hostForced: '强制生效',
    hostForcedTip: '管理员跳过了 CNAME 验证，直接生效',
    hostPendingTip: '把 {host} 的 CNAME 指向 {target}，系统会自动检查；改好后也可以点「验证」立即检查。',
    hostPrimaryPendingTip: '主域名在「概览」的 CNAME 解析里验证。',
    hostNoTargetTip: '站点还没有 CNAME 地址，暂时无法验证。',
    aliasVerify: '验证',
    aliasVerified: '{host} 已通过验证，节点开始加速',
    aliasVerifyMismatch: 'CNAME 还没有指向本站',
    aliasVerifyFailed: '验证失败',
    aliasForceFailed: '操作失败',
    aliasForce: '强制生效',
    aliasForceConfirm: '跳过 CNAME 验证，让节点直接加速 {host}？请先确认这个域名确实属于该客户。',
    aliasForced: '{host} 已强制生效',
    addOrigin: '添加源站',
    addOriginTitle: '添加源站',
    originScheme: '协议',
    originPort: '端口',
    originWeight: '权重',
    originRole: '角色',
    originPrimary: '主源站',
    originBackup: '备用源站',
    originBackupLabel: '作为备用源站',
    originBackupHint: '只有主源站全部不可用时才会用到它。',
    originWeightHint: '多个主源站之间按权重分配请求。',
    originSni: 'SNI',
    originAddrPlaceholder: 'IP 或域名，例如 10.0.0.8 或 origin.example.com',
    originStatus_active: '启用',
    originStatus_disabled: '停用',
    originCount: '共 {n} 个源站',
    basicSettings: '基础设置',
    facts: '基本信息',
    switchCnameTitle: 'CNAME 地址已更新',
    switchCnameChangedAdmin: '新套餐使用不同的线路，{name} 的 CNAME 已改为 {new}，记录已提交发布。客户需要把 DNS 里的 CNAME 改成新地址；在那之前，旧地址 {old} 继续可用。',
    packageBound: '已更换套餐',
    packageBindFailed: '更换套餐失败',
    noPackage: '未绑定',
    changePackage: '更换',
    bindPackageTitle: '绑定套餐：{name}',
    heldUntil: '有效期至 {at}',
    noPackageHint: '不受套餐到期暂停影响，适合内部或测试站点',
    ownerHoldsNothing: '该客户当前没有有效的套餐，只能选择「未绑定」。',
    goSubscriptions: '去分配套餐',
    bindPackageNote: '只能选择该客户当前持有的套餐，需要其他套餐请先在「已售套餐」里分配。如果新套餐使用不同的线路，会生成新的 CNAME 地址，旧地址继续可用，客户把 DNS 改成新地址后才走新线路。',
    suspended_plan_expired: '已暂停：套餐到期',
    suspended_traffic_exceeded: '已暂停：流量超限',
    suspended_requests_exceeded: '已暂停：请求数超限',
    suspendedTip: '该客户的套餐已到期，访问者看到「套餐到期」页面。重新分配套餐后一分钟内自动恢复；到期处理在「系统管理 → 默认页面 → 套餐到期」中设置。',
    status_active: '运行中',
    status_draft: '草稿',
    status_disabled: '已禁用',
    navPerformance: '性能与缓存',
    navAnalytics: '分析和日志',
    siteId: '站点 ID',
    sectionTitle_overview: '站点概览',
    sectionDesc_overview: '站点的基本行为：HTTPS 强制跳转、SSL 模式、协议开关。改动会自动下发到所有节点。',
    sectionTitle_domains: '域名管理',
    sectionDesc_domains: '同一套配置下可以挂多个域名，它们共用源站、证书和全部防护规则。',
    'sectionTitle_cache-prefetch': '缓存预热',
    'sectionDesc_cache-prefetch': '提前把内容拉到各节点，让首次访问就命中缓存。支持即时执行和定时执行。',
    'sectionTitle_cache-jobs': '缓存刷新',
    'sectionDesc_cache-jobs': '让节点丢弃已缓存的内容，下次访问重新回源。任务会下发到所有节点。',
    sectionTitle_origins: '源站配置',
    sectionDesc_origins: '回源地址。配置多个时按权重轮询，备用源站仅在主源站不可用时启用。',
    sectionTitle_certificates: '证书管理',
    sectionDesc_certificates: '为站点签发或上传 HTTPS 证书。支持 Let\'s Encrypt 和 ZeroSSL 自动签发。',
    navBasics: '基础配置',
    navProtection: '防护配置',
    title: '站点',
    add: '新建站点',
    addModalTitle: '新建站点',
    addPlaceholder: '例如 cdn.example.com',
    nameLabel: '主域名',
    nameCol: '主域名',
    manage: '管理',
    detailTitle: '站点详情',
    backToList: '← 返回站点列表',
    syncStatusLabel: '同步状态',
    syncFailedTitle: '同步失败（已达最大重试次数，需人工处理）',
    syncRetryingTitle: '同步失败，正在重试（第 {attempt}/{max} 次）',
    syncNextRetry: '下次重试：{at}',
    syncNodeCol: '节点',
    syncAttemptCol: '尝试次数',
    syncErrorCol: '错误信息',
    syncNow: '立即同步',
    syncNodes: '{synced}/{total} 节点已同步',
    syncState_never: '未同步',
    syncState_pending: '待同步',
    syncState_syncing: '同步中',
    syncState_synced: '已同步',
    syncState_failed: '同步失败',
    forceHttpsLabel: '强制 HTTPS',
    forceHttpsHint: '开启后，HTTP 访问会自动 301 跳转到 HTTPS（证书申请的验证请求不受影响）',
    sectionOverview: '概览',
    sectionDomains: '域名',
    upstreamLimitTitle: '回源并发上限',
    upstreamLimitHelp: '每个节点同时向源站发起的请求数上限。超出的请求在边缘直接返回 503,不会转发。这是唯一不依赖任何过滤判断是否准确的防护——无论边缘挨多少打,源站同时看到的请求数都不会超过这个值。填 0 表示不限制。',
    upstreamLimitOff: '0 = 不限制',
    upstreamLimitOn: '当前:每节点最多 {n} 个并发回源,超出部分在边缘返回 503。',
    upstreamLimitOffHint: '当前不限制:边缘收到多少就转发多少,源站负载完全取决于攻击量。建议按源站实测能力设置。',
    sectionOrigins: '源站',
    sectionCertificates: '证书',
    aliases: '附加域名',
    aliasesHint: '一个站点下的所有域名共用同一份源站配置和规则。新加的域名把 CNAME 指向本站、验证通过后才会被加速。',
    aliasHostnameCol: '域名',
    aliasesEmpty: '暂无附加域名',
    aliasesPlaceholder: '例如 www.example.com',
    aliasAdd: '添加',
    aliasAddSuccess: '已添加',
    aliasAddFailed: '添加失败',
    ownerCol: '所属用户',
    cnameTargetCol: 'CNAME 目标',
    statusCol: '状态',
    sslCol: 'SSL',
    sslModeCol: 'SSL 模式',
    proxyModeCol: '代理模式',
    publishCol: '版本',
    liveVersionCol: '已发布版本',
    rules: '规则',
    origins: '源站',
    protocolsLabel: '协议支持',
    realIpHeaderLabel: '真实 IP 请求头',
    originAddr: '源站地址',
    originHostHeader: '回源 Host',
    originHostHeaderPlaceholder: '回源 Host（留空用站点域名）',
    originSniPlaceholder: 'SNI（留空同回源 Host）',
    originTlsHint: 'HTTPS 回源时，只有 SSL 模式为「strict」才校验源站证书；其它模式不校验，源站可以用自签证书或 IP 证书。回源 Host 是发给源站的 Host 头，源站是虚拟主机或对象存储时填它自己的域名。',
    originsEmpty: '暂无源站',
    originAddSuccess: '源站已添加',
    originAddFailed: '添加源站失败',
    publish: '发布',
    publishSuccess: '发布成功',
    publishedTo: '已发布 {version}，下发到 {n} 个节点',
    publishedToPlain: '已发布 {version}',
    saveFailed: '保存失败',
    publishFailed: '发布失败',
    nameRequired: '请选择所属用户并填写域名',
    packageLabel: '所属套餐',
    packagePlaceholder: '选择该用户当前生效中的套餐',
    packageRequired: '请选择套餐',
    noActivePackageHint: '该用户暂无生效中的套餐',
    requestSSL: '申请证书',
    createSuccess: '站点已创建',
    createFailed: '创建站点失败',
    saveSuccess: '已保存',
    deleteModalTitle: '删除站点',
    deleteModalContent: '确定删除站点「{name}」吗？此操作不可撤销。',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    loadFailed: '加载站点列表失败',
    emptyHint: '暂无站点',
    statusDraft: '配置中',
    statusPendingVerify: '待验证',
    statusActive: '生效中',
    statusPaused: '已暂停',
    statusDisabled: '已禁用',
    disable: '禁用',
    enable: '启用',
    disableConfirmTitle: '禁用站点',
    disableConfirmContent: '确定禁用「{name}」吗？禁用后节点将不再代理该域名的流量。',
    disableSuccess: '已禁用',
    disableFailed: '禁用失败',
    enableSuccess: '已启用',
    enableFailed: '启用失败',
    notInPackage: '套餐不含',
    hostnameQuota: '套餐域名 {used} / {max}',
    apexQuota: '主域名 {used} / {max}',
    notInPackageTipOps: '该站点的套餐「{package}」不包含 {feature}：可以设置，但不会生效。',
  },
  rules: {
    customRules: '自定义规则',
    ruleCount: '共 {n} 条',
    kindDesc_acl: '按 IP、网段、地区、ASN、User-Agent、TLS 指纹等条件放行或拦截请求。白名单优先于其他所有规则。',
    kindDesc_geo: '按访客所在的国家或地区拦截、验证或放行。在其它防护规则之前执行。',
    kindDesc_cc: '按访问频率限流。同一来源在时间窗口内超过阈值时，可以限速、拦截、弹人机校验或临时封禁。',
    kindDesc_waf: '匹配 SQL 注入、XSS、命令执行等攻击特征。命中后累加分值，超过站点阈值才拦截，避免单条误判直接影响业务。',
    kindDesc_bot: '识别伪造搜索引擎的爬虫和已知扫描器。真实蜘蛛通过反向 DNS 校验放行。',
    kindDesc_cache: '按后缀、目录、路径或状态码匹配，设置节点缓存多久、是否强制缓存。',
    backToDomain: '返回站点',
    title: '规则',
    backToDomains: '← 返回站点列表',
    pageTitle: '站点 #{id} — 规则',
    selectKind: '选择规则类型',
    kindAcl: '访问控制（ACL）',
    kindGeo: '区域屏蔽',
    kindWaf: 'WAF',
    kindCc: 'CC 防护',
    kindBot: '机器人',
    kindCache: '缓存配置',
    add: '新增规则',
    publish: '发布',
    priority: '优先级',
    priorityHint: '数字越小，优先级越高，越先匹配。',
    enabledHint: '规则已启用，下次发布时会生效。',
    disabledHint: '规则已保存但不会生效。',
    action: '动作',
    typeCol: '类型',
    categoryCol: '类别',
    statusCol: '状态',
    addModalTitle: '新建{kind}规则',
    editModalTitle: '编辑{kind}规则',
    deleteModalTitle: '删除规则？',
    deleteModalContent: '规则 #{id}（{name}）将被删除。需重新发布域名才会在边缘生效。',
    deleteConfirm: '确定删除这条规则？',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    addSuccess: '规则已添加',
    addFailed: '添加失败',
    updateSuccess: '规则已更新',
    validationFailed: '请检查标红的字段',
    loadFailed: '加载规则失败',
    invalidJson: 'JSON 格式错误',
    publishedTo: '已发布 {version}，下发到 {n} 个节点',
    publishedToPlain: '已发布 {version}',
    publishFailed: '发布失败',
    emptyHint: '暂无规则，点「新增规则」开始添加。',
    actions: {
      allow: '放行',
      log: '仅记录',
      rate_limit429: '限速（429）',
      challenge_js: 'JS 验证',
      challenge_slider: '滑块验证',
      challenge_click: '点击验证',
      deny403: '拦截（403）',
      deny444: '拦截（444，静默丢弃）',
      ban: '封禁 IP',
      deny: '拒绝（自定义状态码）',
      ban_kernel: '内核级封禁',
    },
    acl: {
      matchCol: '匹配条件',
      namePlaceholder: '例如 block-known-scanners',
      types: {
        ip: 'IP 地址',
        cidr: 'IP 段（CIDR）',
        geo: '国家/地区',
        asn: 'ASN',
        ua: 'User-Agent',
        referer: 'Referer',
        header: '请求头',
        ja4: 'JA4 指纹',
        ja3: 'JA3 指纹',
      },
      matchValues: '值',
      matchCountries: '国家/地区代码',
      matchAsn: 'ASN 编号',
      matchContains: '包含（不区分大小写）',
      headerName: '请求头名称',
      placeholderIp: '例如 203.0.113.7，回车添加',
      placeholderCidr: '例如 203.0.113.0/24，回车添加',
      placeholderCountry: '例如 CN、US，回车添加',
      placeholderAsn: '例如 13335，回车添加',
      placeholderSubstring: '例如 curl/，回车添加',
      placeholderJa4: '例如 t13d1516h2_8daaf6152771_02713d6af862，回车添加',
      placeholderJa3: '例如 773906b0efdefa24a7f2b8eb6985bf37，回车添加',
      fingerprintHint: 'TLS 客户端指纹，按访问日志里显示的值精确匹配（不区分大小写）；明文 HTTP 请求没有指纹，不会命中。',
    },
    cc: {
      namePlaceholder: '例如 login-bruteforce',
      matchTitle: '匹配条件',
      methods: '请求方法',
      methodsPlaceholder: '不限',
      path: '请求路径',
      pathPlaceholder: '不填则匹配全部路径，例如 /api/login',
      pathModes: { prefix: '前缀匹配', exact: '精确匹配', contains: '包含' },
      countStatus: '按响应状态码计数',
      countStatusPlaceholder: '例如 401,403 或 5xx，留空则所有请求都计数',
      countStatusHint: '只统计响应为这些状态码的请求。防撞库填 401,403；防刷不存在的页面填 404。',
      countTitle: '统计方式',
      dimensions: '统计维度',
      dimensionsHint: '按这些维度分组计数，最多 3 个。例如 IP + 请求路径会对每个访客的每个接口分别计数；按请求头可以给每个 API Key 单独限额。',
      fingerprintHint: '同一版本的浏览器 TLS 指纹相同，只按指纹统计会把这些访客都算作一个，适合限制自带指纹的脚本和工具，或与请求路径一起用。明文 HTTP 请求没有指纹，会合并计数。Chrome 每次连接都会打乱 JA3，优先用 JA4。',
      dims: {
        ip: '客户端 IP',
        uri: '请求路径',
        ua: 'User-Agent',
        host: '访问域名',
        ja4: 'TLS 指纹（JA4）',
        ja3: 'TLS 指纹（JA3）',
        country: '国家/地区',
        header: '请求头',
        cookie: 'Cookie',
      },
      dimNamePlaceholder_header: '请求头名称，如 X-Api-Key',
      dimNamePlaceholder_cookie: 'Cookie 名称，如 session_id',
      addDimension: '+ 添加维度',
      windowSeconds: '统计周期（秒）',
      threshold: '请求数阈值',
      thresholdCol: '阈值/周期',
      matchCol: '匹配条件',
      anyRequest: '全部请求',
      statusOnly: '仅计 {status}',
      actionTitle: '处置',
      statusCode: '响应状态码',
      mitigation: '处置方式',
      mitigations: { throttle: '限流', penalty: '惩罚' },
      mitigationHint_throttle: '只处置超出阈值的那部分请求，频率降下来就恢复正常。',
      mitigationHint_penalty: '一旦触发，该来源在持续时间内的所有请求都按上面的动作处置。',
      ttlSeconds: '持续时间（秒）',
      ttlHint: '验证通过后的免验证时长，或封禁、惩罚的持续时长。',
      escalationTitle: '阶梯处置（可选）',
      addTier: '+ 添加一级',
      escalationHint: '同一来源反复触发时，按累计次数升级为更严厉的动作，最多 5 级。',
      escalationEmpty: '未配置，每次触发都按上面的动作处置。',
      afterViolations: '累计触发',
      thenAction: '次后升级为',
      forSeconds: '持续（秒）',
    },
    waf: {
      namePlaceholder: '例如 block-sqlmap-signature',
      categories: {
        sqli: 'SQL 注入',
        xss: '跨站脚本（XSS）',
        rce: '远程代码执行',
        traversal: '路径穿越',
        scanner: '扫描器/探测',
        webshell: 'Webshell',
        custom: '自定义',
      },
      targets: '检测位置',
      targetsCol: '检测位置',
      targetsPlaceholder: '可多选',
      targetLabels: { uri: 'URL 路径', args: '查询字符串', cookie: 'Cookie 头', method: 'HTTP 方法' },
      alsoInspectHeader: '同时检测指定请求头',
      pattern: '匹配规则（正则）',
      patternHint: '对所有选中的检测位置做不区分大小写的匹配。',
      score: '分值',
      scoreHint: '命中后累加到该域名的总分——总分达到 WAF 阈值时才会真正拦截。',
    },
    bot: {
      namePlaceholder: '例如 block-scraping-tool',
      matchMode: '匹配方式',
      modeSimple: '包含（简单）',
      modeAdvanced: '正则（高级）',
      uaContains: 'User-Agent 包含',
      uaContainsHint: '不区分大小写的子串匹配，不需要正则语法。',
      uaRegex: 'User-Agent 正则',
      uaRegexHint: '完整正则表达式，不区分大小写匹配。',
      patternCol: '匹配内容',
    },
    cache: {
      matchCol: '匹配条件',
      matchSuffix: '文件后缀',
      matchDir: '路径前缀',
      matchUri: '精确路径',
      matchStatus: '状态码',
      ttlSeconds: 'TTL（秒）',
      forceCache: '强制缓存（忽略源站缓存头）',
      bypassCookies: '按 Cookie 名称绕过缓存',
      varyQuery: '按查询参数区分缓存',
    },
    notInPackage_waf: '当前套餐「{package}」不包含 WAF：这个站点不执行任何 WAF 规则（包括平台内置规则），也不能新增或修改。换到含 WAF 的套餐后，下面的规则自动恢复生效。',
    notInPackageOps_waf: '该站点的套餐「{package}」不包含 WAF：节点不执行它的任何 WAF 规则（包括平台内置规则）。下面的规则会保留，站点换到含 WAF 的套餐后自动生效。',
    notInPackage_cc: '当前套餐「{package}」不包含自定义 CC 规则：上面的防护等级和强制验证照常生效；下面的规则不会生效，也不能新增或修改。',
    notInPackageOps_cc: '该站点的套餐「{package}」不包含自定义 CC 规则：下面的规则保留但不会生效，防护等级和强制验证照常。',
    notInPackageShort: '当前套餐不包含此功能',
    quotaUsed: '本站规则 {used} / {max}',
    quotaFull: '已达到套餐的规则上限：每个站点最多 {max} 条',
  },

  // What keeps a site from being served properly (SiteReadiness.vue,
  // utils/readiness.ts).
  readiness: {
    noOrigin: '还没有配置源站，所有访问都会返回 502「源站连接失败」。',
    noCert: '{hosts} 没有可用的证书，HTTPS 访问会直接失败，浏览器提示「不支持的协议」。',
    certMismatch: '{hosts} 的证书与域名不匹配，浏览器会提示连接不安全。',
    addOrigin: '添加源站',
    getCert: '申请证书',
    changeCert: '更换证书',
    nameSep: '、',
    andMore: '{names} 等 {total} 个域名',
    shortNoOrigin: '未配置源站',
    shortNoCert: '缺少证书',
    shortMismatch: '证书不匹配',
    aliasPending: '{hosts} 还没有通过 CNAME 验证，暂时不会被加速。',
    verifyAlias: '去验证',
    shortAliasPending: '别名待验证',
    listHint: '该站点还不能正常访问',
  },
  domainDetail: {
    back: '← 返回',
    overview: '概览',
    rules: '规则',
    origins: '源站',
    certificates: '证书',
    addOrigin: '添加源站',
    issueCert: '申请证书',
    cnameGenerating: '生成中…',
  },
  siteCerts: {
    daysLeft: '剩余 {n} 天',
    expiresToday: '今天到期',
    expiredDays: '已过期 {n} 天',
    hostCount: '共 {n} 个域名',
    intro: '每个域名可以单独配置证书。免费证书由平台自动签发、自动续期；自定义证书需要在证书管理页面上传，过期前自行更换。',
    applyFree: '申请免费证书',
    blockedUnverified: '域名通过 CNAME 验证后才能申请证书',
    blockedSiteOff: '站点已停用，暂时不能申请证书',
    useExisting: '选择已有证书',
    hostCol: '域名',
    certCol: '证书',
    typeCol: '类型',
    statusCol: '状态',
    expiresCol: '到期时间',
    primary: '主域名',
    typeFree: '免费证书',
    typeCustom: '自定义证书',
    stateOk: '正常',
    stateExpiring: '即将过期',
    stateExpired: '已过期',
    stateMismatch: '证书不匹配',
    stateNone: '未配置',
    issuing: '签发中',
    issueFailed: '签发失败',
    issueCancelled: '已取消签发',
    issuingAttempt: '正在签发（第 {n}/{max} 次尝试）',
    nextRun: '下次重试：{t}',
    retryNow: '立即重试',
    apply: '申请证书',
    change: '更换',
    choose: '选择证书',
    unbind: '解除绑定',
    unbindTitle: '解除证书绑定',
    unbindContent: '解除后 {host} 会自动改用站点里覆盖它的最新证书；没有的话 HTTPS 将无法访问。',
    issuer: '颁发机构',
    validity: '有效日期',
    algorithm: '证书算法',
    source: '来源',
    source_bound: '手动指定',
    source_auto: '自动匹配（站点内覆盖该域名的最新证书）',
    source_fallback: '没有覆盖该域名的证书，临时使用站点最新证书',
    source_none: '—',
    mismatchHint: '当前没有覆盖 {host} 的证书，节点暂时用站点的其他证书响应，浏览器会提示证书错误。请为它申请或选择一张证书。',
    noCert: '还没有证书，点击「申请证书」或「选择证书」',
    pickHost: '请选择域名',
    pickCert: '请选择证书',
    bindHint: '只列出覆盖这个域名、并且仍然有效的证书。证书在证书管理页面上传。',
    noBindable: '没有覆盖这个域名的有效证书',
    bound: '已应用',
    issueQueued: '已加入签发队列，状态会显示在列表里',
    issueQueueHint: '签发在后台队列执行，可以关闭这个窗口。失败原因会显示在对应域名的展开行里。',
    notInPackage: '套餐不支持上传证书',
  },
  certificates: {
    stateCancelled: '已取消',
    attachTitle: '使用已有证书',
    issueCancelled: '已取消',
    issueRetryNow: '立即重试',
    uploadMoved: '上传证书请到证书管理页面：',
    attachSuccess: '已应用到本站点',
    attachPlaceholder: '从已有证书中选择',
    attach: '使用这张证书',
    pemRequired: '请填写证书和私钥',
    siteRequired: '请选择站点',
    sitePlaceholder: '选择站点',
    siteHint: '证书会绑定到这个站点并下发到节点。同一张证书可以在站点详情里改绑到别的站点。',
    siteLabel: '应用到站点',
    noSite: '未绑定',
    siteCol: '所属站点',
    emailHint: '用于向证书颁发机构注册账号和接收到期提醒。申请即代表接受该机构的服务条款。',
    stateNextRun: '下次重试：{t}',
    stateFailed: '签发失败',
    stateSuccess: '证书已签发',
    statePending: '正在签发…（第 {n}/{max} 次尝试）',
    issueRetry: '重新申请',
    issueQueueHint: '签发在后台队列里执行，可以离开这个页面。失败原因会显示在上方，管理员也能在「任务队列 → 系统任务」看到每次尝试的详细报错。',
    issueQueued: '已加入签发队列，结果会显示在上面',
    title: '证书管理',
    sectionTitle: '证书管理',
    domain: '所属域名',
    typeUpload: '上传',
    typeAcme: 'ACME',
    commonNameCol: '主域名',
    issuerCol: '签发者',
    notBeforeCol: '生效',
    notAfterCol: '过期',
    statusCol: '状态',
    fingerprintCol: '指纹',
    expiringDays: '{n} 天后过期',
    expired: '已过期',
    issueAcme: '通过 ACME 申请',
    emailLabel: '邮箱',
    emailRequired: '请填写邮箱',
    caLabel: '证书颁发机构',
    issueFailed: '证书签发失败',
    uploadCert: '上传证书',
    uploadSuccess: '证书已上传',
    uploadFailed: '上传证书失败',
    refresh: '刷新',
    empty: '该域名暂无证书',
    aboutExpire: '即将过期',
    statTotal: '证书总数',
    statValid: '有效',
    statExpiring: '即将到期',
    statExpiringNote: '{n} 天内',
    statExpired: '已过期',
    statRevoked: '{n} 张已吊销',
    listTitle: '全部证书',
    listCount: '共 {n} 张',
    listFiltered: '筛选后 {n} 张',
    searchPlaceholder: '搜索证书域名或颁发机构',
    filterAllSites: '全部站点',
    filterAllTypes: '全部类型',
    filterAllStatus: '全部状态',
    state_valid: '有效',
    state_expiring: '即将到期',
    state_expired: '已过期',
    state_revoked: '已吊销',
    certCol: '证书',
    moreNames: '+{n} 个域名',
    typeCol: '类型',
    expiresCol: '到期时间',
    emptyHint: '还没有证书。在站点的 SSL 页面可以申请免费证书，也可以在这里上传。',
    certPem: '证书（PEM）',
    certPemHint: '先粘服务器证书，再粘中间证书：整条证书链一起。',
    keyPem: '私钥（PEM）',
    keyPemHint: '私钥加密保存，只用于节点上的 HTTPS 握手。',
    filterAllOwners: '全部用户',
  },
  lineDns: {
    linesUnavailableTitle: '暂时读取不到这个接入域名支持的线路',
    showDetail: '查看完整错误',
    hideDetail: '收起',
    poolDown: '无可用地址',
    poolDownHint: '这条线路没有可用的地址，解析记录暂时保持原样，等有地址恢复可用后再更新。',
    poolEmpty: '暂无地址',
    ttlSeconds: '{n} 秒',
    plan: '解析套餐',
    boundSummary: '共 {total} 台 · {usable} 台可用',
    candidatesSummary: '共 {n} 个',
    checkedCount: '已选 {n} 个',
    pickPoolFirst: '先在右侧选择一条线路',
    poolsSummary: '共 {n} 条',
    poolLive: '解析中 {live}/{total}',
    manageNodes: '管理节点',
    nodeOk: '正常',
    group_other: '其他线路',
    group_search: '搜索引擎',
    group_region: '地域',
    group_isp: '运营商',
    group_default: '默认',
    calibrateQueued: '已开始校准，结果可在「任务队列 → 系统任务」查看',
    calibrateHint: '按当前配置检查并修正 DNS 记录。平时不用点：每次改动都会自动生效，这个按钮是用来纠正外部改动或补上失败的写入的。',
    calibrate: '校准解析',
    back: '返回线路组',
    intro: '这里决定线路组的解析值在每条运营商线路上返回哪些节点 IP。左边挑地址，右边放进线路池——每一步改动都会立刻生效，不需要额外点发布。',
    zone: '接入域名',
    loadFailed: '加载失败',
    saved: '已保存，正在重新发布解析',
    noResolveValue: '这个线路组还没有配置解析值，请先在线路组里填写解析值和接入域名。',
    noPoolsHint: '还没有线路池。当前会把线路组里所有可用节点的 IP 发布到线路组自己的线路上；新建线路池之后就按线路池来。',
    linesUnavailable: '暂时读取不到这个接入域名支持的线路：',
    boundNodes: '已绑定节点',
    noNodes: '这个线路组还没有绑定节点',
    stale: '失联',
    candidates: '待添加解析的 IP',
    noCandidates: '没有可添加的地址了',
    alreadyInLines: '已在 {n} 条线路',
    notUsable: '不可用',
    addAsPrimary: '添加为主用',
    addAsBackup: '添加为备用',
    pools: '线路池',
    addPool: '新建线路池',
    noPools: '还没有线路池',
    poolSummary: '生效 {live} / 共 {total} 个地址',
    off: '已停用',
    onBackup: '备用接管中',
    poolDetail: '线路「{line}」解析明细',
    disablePool: '停用该线路',
    enablePool: '启用该线路',
    deletePool: '删除线路池',
    poolOffHint: '该线路已停用，它的解析记录会在下次发布时被删除。',
    failoverHint: '这条线路没有可用的主用地址，已经由备用地址接管。',
    deletePoolTitle: '删除线路池',
    deletePoolContent: '确定删除「{line}」线路池吗？这条线路上的解析记录会一起删掉。',
    poolAdded: '线路池已创建',
    poolDeleted: '线路池已删除',
    noPoolSelected: '请先选择一个线路池',
    pickAddress: '请先勾选要添加的 IP',
    addressesAdded: '已添加',
    ipCol: 'IP 地址',
    nodeCol: '所属节点',
    manualIP: '手工添加',
    roleCol: '类型',
    primary: '主用',
    backup: '备用',
    stateCol: '当前状态',
    live: '解析中',
    paused: '已暂停',
    nodeDown: '节点不可用',
    standby: '待命',
    makeBackup: '设为备用',
    makePrimary: '取消备用',
    pause: '暂停解析',
    resume: '恢复解析',
    removeMemberTitle: '移除地址',
    removeMemberContent: '确定把 {ip} 从这条线路里移除吗？',
    memberRemoved: '已移除',
    noMembers: '这条线路还没有地址，从左边勾选 IP 添加进来',
    line: '解析线路',
    lineHint: '按接入域名当前解析套餐实际支持的线路列出，分组和阿里云控制台一致：默认、运营商、地域、搜索引擎。',
    pickLine: '请选择解析线路',
    publishQueued: '已加入任务队列',
  },
  lineGroups: {
    unit: '个',
    statTotal: '线路组',
    statOk: '正常',
    statAbnormal: '异常',
    statUnset: '未配置',
    statLines: '共 {n} 条解析线路',
    statDown: '{n} 个无可用节点',
    health_ok: '正常',
    health_degraded: '部分节点不可用',
    health_down: '无可用节点',
    health_unset: '未配置',
    listTitle: '全部线路组',
    listCount: '共 {n} 个',
    listFiltered: '筛选后 {n} 个',
    searchPlaceholder: '搜索名称、描述或解析值',
    filterAllStatus: '全部状态',
    filterAllZones: '全部接入域名',
    filterAbnormal: '异常（含部分不可用）',
    resetFilters: '重置',
    groupCol: '线路组',
    nodesCol: '节点',
    nodesUsable: '{usable}/{total} 可用',
    nodesNone: '未绑定',
    linesCol: '解析线路',
    linesCount: '{n} 条',
    linesDisabled: '{n} 条停用',
    linesDefault: '线路组线路',
    linesDefaultTip: '还没有线路池：所有可用节点的 IP 都发布在线路组自己的线路（{line}）上。',
    statusCol: '状态',
    more: '更多',
    deleteGroup: '删除线路组',
    emptyHint: '还没有线路组',
    membersSelected: '已选 {n} 台',
    membersSearch: '搜索节点名称或 IP',
    membersNoMatch: '没有匹配的节点',
    nodeState_usable: '可用',
    nodeState_stale: '失联',
    nodeState_pending: '待初始化',
    nodeState_off: '已停用',
    publishResolve: '校准解析',
    publishQueued: '已开始校准，稍后可在「任务队列 → 系统任务」查看结果',
    publishAlreadyQueued: '已经有一个待执行的校准任务了',
    publishFailed: '提交失败',
    title: '线路组',
    add: '新建线路组',
    nameCol: '名称',
    descCol: '描述',
    memberCountCol: '节点数',
    zoneCol: '接入域名',
    zoneHint: '解析值会挂在这个主域名下。域名在「接入域名」页面管理。',
    zonePlaceholder: '选择一个接入域名',
    noZonesHint: '还没有接入域名，请先到「接入域名」页面添加',
    zoneRequired: '请选择接入域名',
    resolveValueRequired: '请填写解析值',
    resolveLabelPlaceholder: '例如 line1',
    resolveLabelInvalid: '解析值只能包含字母、数字和短横线',
    resolvePreview: '完整解析值：',
    resolveValueRandom: '随机生成',
    resolveValueNotUnderZone: '解析值必须是 {domain} 的子域名',
    pickZoneFirst: '请先选择接入域名',
    resolveValueCol: '解析值',
    resolveValueHint: '该线路对外的解析地址。平台会把线路组里节点的公网 IP 发布成这个地址的 A 记录，客户站点的 CNAME 再指向这里。',
    resolveValuePlaceholder: '例如 line1.niaodns.com',
    manageMembers: '绑定节点',
    addModalTitle: '新建线路组',
    editModalTitle: '编辑线路组',
    namePlaceholder: '例如：线路一',
    descPlaceholder: '选填',
    deleteModalTitle: '删除线路组',
    deleteModalContent: '确定删除线路组「{name}」吗？',
    loadFailed: '加载线路组失败',
    addSuccess: '创建成功',
    addFailed: '创建失败',
    updateSuccess: '更新成功',
    updateFailed: '更新失败',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    membersModalTitle: '绑定节点 - {name}',
    membersHint: '勾选要绑定到该线路组的节点。同一个节点可以同时绑定到多个线路组。',
    noNodesHint: '暂无节点，请先在「节点」页面添加节点',
    saveMembersSuccess: '节点绑定已更新',
    saveMembersFailed: '更新节点绑定失败',
    records: {
      manage: '管理解析',
    },
  },
  cnameZones: {
    ttlCol: 'TTL',
    ttlHint: '平台在这个域名下写的所有记录（站点 CNAME、线路 A 记录）都用这个 TTL。阿里云免费版下限 600 秒。',
    ttlHintPlan: '解析套餐「{plan}」最低支持 {min} 秒。平台在这个域名下写的所有记录（站点 CNAME、线路 A 记录）都用这个 TTL。',
    ttlRange: 'TTL 只能填 {min} 到 {max} 秒之间',
    intro: '接入域名是平台自己持有的主域名，客户站点通过 CNAME 指到这里。线路组的解析值必须是其中某个域名的子域名。',
    add: '添加接入域名',
    addModalTitle: '添加接入域名',
    editModalTitle: '编辑接入域名',
    deleteModalTitle: '删除接入域名',
    deleteModalContent: '确定删除「{name}」吗？仍被线路组使用时无法删除。',
    domainCol: '主域名',
    providerCol: 'DNS 账户',
    remarkCol: '备注',
    statusCol: '状态',
    statusActive: '启用',
    statusDisabled: '停用',
    groupCountCol: '线路组',
    domainHint: '只填主域名，例如 niaodns.com；子域名由线路组自动分配。',
    domainPlaceholder: '例如 niaodns.com',
    providerHint: '用于在该域名下写解析记录的 DNS 账户。',
    providerPlaceholder: '选择一个 DNS 账户',
    remarkPlaceholder: '选填',
    searchPlaceholder: '搜索域名或备注',
    domainInvalid: '请填写合法的域名，不要带协议、路径或端口',
    domainNotApex: '只填主域名（例如 niaodns.com），不要填它的子域名',
    providerRequired: '请选择 DNS 账户',
    empty: '还没有接入域名，先添加一个',
    noProvidersHint: '还没有 DNS 账户，请先到「DNS 提供商」页面添加一个。',
    addSuccess: '添加成功',
    updateSuccess: '更新成功',
    addFailed: '保存失败',
    deleteFailed: '删除失败',
  },
  dnsProviders: {
    title: 'DNS 提供商',
    add: '添加 DNS 提供商',
    typeCol: '类型',
    nameCol: '名称',
    akPreviewCol: '密钥预览',
    statusCol: '状态',
    createdAtCol: '创建时间',
    addModalTitle: '添加 DNS 提供商',
    editModalTitle: '编辑 DNS 提供商',
    keepUnchangedPlaceholder: '留空则不修改',
    type: '提供商类型',
    typeAliyun: '阿里云',
    typeTencent: '腾讯云',
    typeCloudflare: 'Cloudflare',
    comingSoon: '即将支持',
    name: '名称',
    namePlaceholder: '例如：主账号',
    accessKey: 'AccessKey',
    accessSecret: 'AccessSecret',
    accessKeyPlaceholder: '请输入 AccessKey',
    accessSecretPlaceholder: '请输入 AccessSecret',
    encryptionHint: '密钥使用 AES-256-GCM 加密后存储，仅展示预览，无法回显明文。',
    deleteModalTitle: '删除 DNS 提供商',
    deleteModalContent: '确定删除「{name}」吗？关联的 DNS 线路将无法同步。',
    loadFailed: '加载 DNS 提供商失败',
    addSuccess: '添加成功',
    addFailed: '添加失败',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    emptyHint: '暂无 DNS 提供商',
    test: '连通性检测',
    testSuccess: '连接成功，凭证有效',
    testFailed: '测试失败',
    testFailedWithReason: '测试失败：{reason}',
  },
  regions: {
    intro: '地区只是给节点起的分类名，方便按位置筛选和统计；真正决定 DNS 解析到哪些节点的是「线路组」。',
    add: '新建地区',
    addModalTitle: '新建地区',
    editModalTitle: '编辑地区',
    deleteModalTitle: '删除地区',
    deleteModalContent: '确定删除地区「{name}」吗？',
    codeCol: '地区代码',
    nameCol: '地区名称',
    remarkCol: '备注',
    nodeCountCol: '节点数',
    codeHint: '节点注册时上报的就是这个代码。已有节点在用时也能改，确认后这些节点会一并迁到新代码。',
    codePlaceholder: '例如 cn-east',
    namePlaceholder: '例如 华东',
    remarkPlaceholder: '选填',
    codeInvalid: '地区代码只能包含字母、数字、短横线和下划线，长度 1-32',
    updateSuccessMoved: '已保存，{count} 个节点已迁到新代码',
    migrateModalTitle: '确认修改地区代码',
    migrateConfirm: '一并迁移',
    searchPlaceholder: '搜索代码、名称或备注',
    empty: '还没有地区，新建一个来给节点分组',
    addSuccess: '地区已创建',
    updateSuccess: '地区已更新',
    addFailed: '保存失败',
    deleteFailed: '删除失败',
  },
  userGroups: {
    title: '用户分组',
    add: '新建分组',
    nameCol: '名称',
    descCol: '描述',
    memberCountCol: '用户数',
    addModalTitle: '新建用户分组',
    editModalTitle: '编辑用户分组',
    namePlaceholder: '例如：VIP 客户',
    descPlaceholder: '选填',
    deleteModalTitle: '删除用户分组',
    deleteModalContent: '确定删除分组「{name}」吗？',
    loadFailed: '加载用户分组失败',
    addSuccess: '创建成功',
    addFailed: '创建失败',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
  },
  users: {
    add: '新建用户',
    pfAddress: '通信地址',
    pfBackup: '备用联系人',
    pfCompany: '公司名称',
    pfIndustry: '所属行业',
    pfIndustry_ecommerce: '电子商务',
    pfIndustry_education: '教育',
    pfIndustry_finance: '金融',
    pfIndustry_gaming: '游戏',
    pfIndustry_government: '政府/公共事业',
    pfIndustry_healthcare: '医疗健康',
    pfIndustry_internet: '互联网/软件',
    pfIndustry_manufacturing: '制造业',
    pfIndustry_media: '视频/直播/媒体',
    pfIndustry_other: '其他',
    pfNever: '客户还没有填写账户资料',
    pfCountry: '所属国家/地区',
    pfNickname: '昵称',
    pfTeam: '团队规模',
    pfTeam_1000plus: '1000 人以上',
    pfTeam_10_49: '10–49 人',
    pfTeam_1_9: '1–9 人',
    pfTeam_200_999: '200–999 人',
    pfTeam_50_199: '50–199 人',
    pfUpdated: '客户于 {time} 更新',
    pfUsage: '网站用途',
    pfWechat: '微信号',
    searchPlaceholder: '搜索用户名/邮箱/手机号',
    filterStatus: '账号状态',
    tabProfile: '账户资料',
    usernameCol: '用户名',
    emailCol: '邮箱',
    phoneCol: '手机号',
    groupCol: '用户分组',
    vipCol: 'VIP',
    lvCol: '等级',
    vipOnly: '只看 VIP',
    vipCellTip: '成长值 {n} · 点击调整',
    lvCellTip: '经验 {n} · 点击调整',
    memberField: '会员等级',
    memberAdjust: '调整',
    statusCol: '账号状态',
    realnameCol: '实名状态',
    remark: '备注',
    qq: 'QQ 号码',
    country: '国家',
    addModalTitle: '新建用户',
    editModalTitle: '编辑用户',
    tabBasic: '基本信息',
    tabSecurity: '安全设置',
    tabRealname: '实名认证',
    password: '登录密码',
    passwordKeepHint: '留空则不修改',
    passwordRequiredHint: '新建用户需要设置登录密码',
    operationPassword: '操作密码',
    operationPasswordHint: '用于确认敏感操作的二次密码，与登录密码相互独立',
    securityQuestion: '密保问题',
    securityAnswer: '密保答案',
    realnameType: '认证类型',
    realnameStatus: '认证状态',
    realName: '姓名',
    enterpriseName: '企业名称',
    idCardNumber: '身份证号',
    socialCreditCode: '统一社会信用代码',
    currentPreview: '当前',
    idCardEncryptionHint: '身份证号 / 统一社会信用代码使用 AES-256-GCM 加密存储，页面只显示打码预览；管理员可点「查看完整号码」，每次查看都记入审计日志。',
    statusActive: '正常',
    statusBanned: '封禁',
    statusClosed: '关闭',
    statusDisabled: '禁用',
    statusLocked: '锁定',
    realnameUnverified: '未认证',
    realnamePending: '审核中',
    realnameVerified: '已认证',
    realnameRejected: '已驳回',
    realnameIndividual: '个人',
    realnameEnterprise: '企业',
    deleteModalTitle: '删除用户',
    deleteModalContent: '确定删除用户「{name}」吗？此操作不可撤销。',
    loadFailed: '加载用户列表失败',
    addSuccess: '创建成功',
    addFailed: '创建失败',
    updateSuccess: '更新成功',
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    emptyHint: '暂无用户',
    mfaOn: '已绑定，绑定于 {time}。客户丢失设备时，可以重置。',
    mfaOff: '未绑定',
    resetMfa: '重置 MFA',
    resetMfaTitle: '重置 MFA 设备',
    resetMfaConfirm: '解除 {name} 绑定的 MFA 设备？解除后，该客户登录只需要密码，可以在安全中心重新绑定。请先确认是客户本人申请。',
    resetMfaDone: '已重置 MFA 设备',
    sessions: '登录会话',
    sessionsDesc: '客户怀疑账号被盗用时，可以让该账号的所有登录立即失效。',
    endSessions: '强制下线',
    endSessionsTitle: '强制下线',
    endSessionsConfirm: '{name} 在所有设备上的登录都会立即失效，需要重新登录。确定继续吗？',
    endSessionsDone: '已强制下线',
    actionFailed: '操作失败',
    phoneProof: '手机号',
    phoneNone: '未绑定',
    phoneProved: '已通过短信验证（{time}），可用于短信登录保护和找回密码。',
    phoneUnproved: '未验证。客户在安全中心验证后，才能用于短信登录保护和找回密码。',
    loginSms: '短信登录保护',
    loginSmsOn: '已开启，客户登录时需要输入短信验证码。客户换了手机号收不到短信时，可以关闭。',
    loginSmsOff: '未开启',
    resetLoginSms: '关闭',
    resetLoginSmsTitle: '关闭短信登录保护',
    resetLoginSmsConfirm: '关闭 {name} 的短信登录保护？关闭后，该客户登录只需要密码。请先确认是客户本人申请。',
    resetLoginSmsDone: '已关闭短信登录保护',
  },
  packageGroups: {
    nameRequired: '请填写分组名称',
    add: '新建分组',
    nameCol: '分组名称',
    descCol: '描述',
    countCol: '套餐数',
    namePlaceholder: '例如 零售套餐',
    descPlaceholder: '选填',
    addModalTitle: '新建套餐分组',
    editModalTitle: '编辑套餐分组',
    deleteModalTitle: '删除套餐分组',
    deleteModalContent: '确认删除分组「{name}」？分组下还有套餐时无法删除。',
    addSuccess: '分组已创建',
    updateSuccess: '分组已保存',
    deleteSuccess: '分组已删除',
    saveFailed: '保存失败',
    deleteFailed: '删除失败',
    empty: '还没有分组',
    hint: '分组只是给套餐起的归类名，方便在套餐多起来之后筛选；配额、价格和权益仍然由套餐本身决定。',
  },
  payment: {
    title: '支付配置',
    figAlipay: '支付宝',
    state_ready: '已启用',
    state_incomplete: '配置不完整',
    state_off: '未启用',
    noAppId: '未填写 AppID',
    figProducts: '已开通产品',
    productShort_page: '电脑网站',
    productShort_wap: '手机网站',
    productShort_qr: '当面付',
    noProducts: '未开通任何产品',
    figMode: '接口加签方式',
    mode_key: '公钥',
    mode_cert: '公钥证书',
    sandbox: '沙箱环境',
    production: '正式环境',
    figAmounts: '单笔充值金额',
    presetCount: '{n} 个快捷金额',
    noEncryption: '主控没有配置加密密钥（control.yaml 的 secrets.encryption_key），应用私钥无法保存。配置后重启主控即可。',
    topUpTitle: '充值设置',
    baseURL: '用户台访问地址',
    baseURLHelp: '支付宝的异步通知和付款后的跳转都发往这个地址，必须能从公网访问，建议使用 HTTPS。',
    suggest: '使用主控域名中的用户台地址：',
    plainHttp: '当前是 HTTP 地址：通知有签名保护，但买家付款后的跳转走明文链路，建议改用 HTTPS。',
    notifyURL: '异步通知地址',
    returnURL: '付款返回地址',
    derivedNote: '下单时自动带给支付宝，无需在支付宝开放平台填写。',
    subject: '订单标题',
    subjectHelp: '显示在买家的支付宝账单上。',
    subjectPlaceholder: '账户充值',
    amountRange: '单笔金额',
    amountRangeHelp: '客户每笔充值的最低和最高金额。',
    to: '至',
    presets: '快捷金额',
    presetsHelp: '用户台充值页可一键选择的金额，最多 {n} 个，需在单笔金额范围内。',
    presetPlaceholder: '金额',
    addPreset: '添加',
    saved: '已保存',
    copyFailed: '复制失败，请手动复制',
    fileTooBig: '文件太大，密钥和证书文件通常只有几 KB',
    alipayTitle: '支付宝',
    testSavedFirst: '请先保存修改：测试使用的是已保存的配置',
    test: '测试连接',
    test_ok: '连接正常',
    test_invalidSignature: '支付宝拒绝了请求签名',
    test_invalidAppId: 'AppID 无效',
    test_answerSignature: '无法验证支付宝的应答',
    test_unreachable: '无法连接支付宝网关',
    test_notReady: '配置不完整',
    test_other: '支付宝返回错误',
    testHint_ok: 'AppID、应用私钥和支付宝公钥均已通过验证（{gateway}）。',
    testHint_invalidSignature: '应用私钥与支付宝开放平台上设置的应用公钥（或应用公钥证书）不匹配。',
    testHint_invalidAppId: '支付宝找不到这个应用，或应用尚未上线。注意正式环境和沙箱环境的 AppID 不通用。',
    testHint_answerSignature: '支付宝应答的签名验证失败，请检查支付宝公钥（或支付宝公钥证书、根证书）是否正确。',
    testHint_unreachable: '主控无法访问 {gateway}，请检查主控的网络和 DNS。',
    testHint_notReady: '请先启用支付宝，填写完整的 AppID、密钥（或证书）并开启支付产品，保存后再测试。',
    testHint_other: '支付宝返回了以下错误：',
    alipayIntro: '在支付宝开放平台创建应用并签约所需产品，在「开发设置」中设置接口加签方式（RSA2），再把 AppID、应用私钥和支付宝公钥（或三个证书）填到这里。',
    enable: '启用支付宝',
    enableHelp: '开启后，客户可以在用户台的充值中心用支付宝在线充值。',
    appIdHelp: '支付宝开放平台应用详情中的 APPID。',
    signMode: '接口加签方式',
    environment: '环境',
    modeNote_key: '公钥模式：在开放平台上传应用公钥，再把开放平台给出的支付宝公钥填到下方。',
    modeNote_payouts: '提现的自动转账只支持公钥证书模式。',
    modeNote_cert: '公钥证书模式：在开放平台选择证书方式加签，下载应用公钥证书、支付宝公钥证书和支付宝根证书三个文件。',
    privateKey: '应用私钥',
    privateKeyKeep: '已保存。如需更换，粘贴新的应用私钥',
    privateKeyPlaceholder: 'MIIEvQIBADANBgkqhkiG9w0BAQEFAASC… 或 -----BEGIN PRIVATE KEY-----',
    privateKeySet: '已加密保存，不会再显示',
    privateKeyHelp: '用支付宝开放平台密钥工具生成的 RSA2 应用私钥，保存后加密存储。',
    fromFile: '从文件读取',
    alipayKey: '支付宝公钥',
    alipayKeyHelp: '上传应用公钥后，开放平台显示的支付宝公钥。',
    appCert: '应用公钥证书',
    alipayCert: '支付宝公钥证书',
    rootCert: '支付宝根证书',
    products: '支付产品',
    productsHelp: '只开启已在支付宝开放平台签约的产品，未签约的产品下单会失败。',
    product_page: '电脑网站支付',
    product_wap: '手机网站支付',
    product_qr: '当面付',
    productSub_page: '电脑浏览器跳转支付宝收银台',
    productSub_wap: '手机浏览器唤起支付宝 App',
    productSub_qr: '页面展示二维码，扫码付款',
    noEncryptionShort: '主控未配置加密密钥，支付宝设置暂时无法保存',
  },
  topups: {
    title: '充值订单',
    statTotal: '累计充值',
    statToday: '今日充值',
    statOrders: '订单总数',
    statPending: '待支付',
    unitYuan: '元',
    unitOrders: '笔',
    count: '共 {n} 笔',
    all: '全部',
    state_paid: '已支付',
    state_pending: '待支付',
    state_expired: '已过期',
    state_closed: '已关闭',
    customer: '客户',
    clear: '清除筛选',
    noMatch: '没有符合条件的订单',
    empty: '还没有充值订单',
    method_page: '支付宝 · 电脑网站',
    method_wap: '支付宝 · 手机网站',
    method_qr: '支付宝 · 当面付',
    colOrderNo: '订单号',
    colCustomer: '客户',
    colAmount: '金额',
    colMethod: '支付方式',
    colCreated: '创建时间',
    colPaid: '支付时间',
    details: '详情',
    check: '查询',
    detailTitle: '订单详情',
    tradeNo: '支付宝交易号',
    buyer: '付款账号',
    expires: '支付截止',
    checkAlipay: '向支付宝查询',
    viewBalance: '客户余额',
    checkHelp: '向支付宝查询这笔交易的当前状态；如果买家已付款但没有入账（例如通知没有送达），会立即补入客户余额。',
    checkMismatch: '支付宝实收 ¥{paid}，与订单金额 ¥{amount} 不符，没有入账。请核实后在客户余额中手动调整。',
    checkCredited: '已确认付款，¥{amount} 已存入 {user} 的余额',
    checkPaid: '支付宝确认这笔订单已付款',
    checkWaiting: '交易已创建，等待买家付款',
    checkRefunded: '支付宝显示交易已关闭：这笔已入账的订单可能已全额退款，请核实后手动扣减客户余额',
    checkClosed: '交易已关闭：超时未付款',
    checkNotExist: '支付宝没有这笔交易：买家没有打开收银台，也没有扫码',
  },
  // 财务管理: the review pages, 套餐订单 and 财务设置.
  finDoc: {
    details: '详情',
    reject: '驳回',
    rejectReason: '驳回原因',
    rejectReasonHelp: '客户会在单据中看到这个原因',
    rejectPlaceholder: '请说明驳回原因',
    rejected: '已驳回',
    rejectedFor: '驳回原因：{note}',
    reviewNote: '备注',
    notePlaceholder: '选填，客户可以看到',
    reviewedAt: '处理时间',
    check: '查询',
    noMatch: '没有符合条件的记录',
    copyFailed: '复制失败，请手动选择复制',
    remit: {
      pending: '待确认',
      approved: '已入账',
      rejected: '已驳回',
      cancelled: '已撤销',
    },
    withdraw: {
      pending: '待审核',
      processing: '打款中',
      success: '已打款',
      failed: '打款失败',
      rejected: '已驳回',
      cancelled: '已撤销',
    },
    invoice: {
      pending: '待开票',
      issued: '已开票',
      rejected: '已驳回',
      cancelled: '已撤销',
    },
    refund: {
      pending: '待审核',
      processing: '退款中',
      success: '已退款',
      failed: '退款失败',
      rejected: '已驳回',
      cancelled: '已撤销',
    },
  },
  remits: {
    title: '线下汇款',
    statRemitted: '已入账金额',
    statWaitingAmount: '待确认金额',
    statPending: '待确认',
    statApproved: '已入账',
    listTitle: '汇款记录',
    empty: '还没有客户提交汇款',
    colNo: '汇款单号',
    colAmount: '汇款金额',
    colPayer: '汇款人',
    colDate: '汇款日期',
    colSubmitted: '提交时间',
    colTo: '收款账户',
    payerAccount: '汇款账号',
    reference: '银行流水号',
    note: '客户备注',
    receipt: '汇款凭证',
    openReceipt: '新窗口打开',
    pdfReceipt: 'PDF 凭证，点击查看',
    noReceipt: '没有凭证',
    approve: '确认入账',
    approveTitle: '确认入账？',
    approveContent: '确认已在收款账户收到 {payer} 汇来的 ¥{amount}？金额将存入 {user} 的账户余额，确认后不能撤回。',
    approved: '已入账：¥{amount} 存入 {user} 的余额',
    approveHelp: '请先在银行账户中核对到账金额、汇款户名和日期，再确认入账。',
    detailTitle: '汇款详情',
    rejectTitle: '驳回汇款',
    rejectPlaceholder: '例如：未查到这笔汇款，请核对金额和户名后重新提交',
  },
  withdrawals: {
    title: '提现审核',
    statPaidOut: '已打款金额',
    statWaitingAmount: '待审核金额',
    statPending: '待审核',
    statFailed: '打款失败',
    listTitle: '提现申请',
    empty: '还没有提现申请',
    notReady: '支付宝当前没有使用公钥证书加签，无法自动打款。请在支付配置中改用公钥证书方式，并在支付宝开放平台开通「转账到支付宝账户」。',
    toPayment: '去支付配置',
    colNo: '提现单号',
    colAmount: '提现金额',
    colNet: '到账金额',
    colTo: '收款账户',
    colApplied: '申请时间',
    pay: '确认打款',
    retry: '重新打款',
    payTitle: '确认打款',
    retryTitle: '重新打款',
    payee: '收款人',
    fee: '手续费',
    transfer: '转账金额',
    noteHelp: '客户可以在提现记录中看到',
    payConfirm: '确认后立即通过支付宝向该账户转账，到账后不能撤回。请确保平台支付宝账户余额充足。',
    paid: '已向 {user} 打款 ¥{amount}',
    payFailed: '支付宝拒绝了这笔转账：{reason}',
    payPending: '支付宝暂未返回结果，系统会每分钟自动查询',
    stillProcessing: '支付宝仍在处理这笔转账',
    checked: '查询完成：{state}',
    rejected: '已驳回，¥{amount} 已退回客户余额',
    rejectTitle: '驳回提现',
    rejectHint: '驳回后 ¥{amount} 将退回 {user} 的账户余额。',
    detailTitle: '提现详情',
    failedFor: '支付宝拒绝转账：{reason}。核实后可以重新打款，或驳回将金额退回客户余额。',
    processingNote: '已提交支付宝，等待结果；系统每分钟自动查询一次。',
    realName: '真实姓名',
    account: '支付宝账号',
    attempts: '打款次数',
    orderId: '支付宝转账单号',
    finishedAt: '完成时间',
    checkAlipay: '向支付宝查询',
    payHelp: '确认打款会立即通过支付宝转账；转账失败时可以重新打款或驳回。',
    rejectPlaceholder: '例如：支付宝实名与提现账户不一致，请核对后重新申请',
  },
  invoices: {
    title: '发票管理',
    statIssuedAmount: '已开票金额',
    statWaitingAmount: '待开票金额',
    statPending: '待开票',
    statIssued: '已开票',
    unit: '张',
    listTitle: '发票申请',
    count: '共 {n} 张',
    empty: '还没有发票申请',
    colApplied: '申请时间',
    colKind: '发票类型',
    colAmount: '金额',
    colNumber: '发票号码',
    colNo: '申请单号',
    header: '发票抬头',
    titleKind: '抬头类型',
    kind_company: '企业',
    kind_personal: '个人',
    type_normal: '普票',
    type_special: '专票',
    typeLong_normal: '增值税普通发票',
    typeLong_special: '增值税专用发票',
    medium_electronic: '电子发票',
    medium_paper: '纸质发票',
    taxNo: '纳税人识别号',
    address: '注册地址',
    phone: '注册电话',
    bank: '开户银行',
    bankAccount: '银行账号',
    email: '接收邮箱',
    recipient: '收件人',
    mailAddress: '邮寄地址',
    express: '快递',
    issuedAt: '开票时间',
    issue: '开票',
    issueTitle: '开具发票',
    numberHelp: '8–24 位数字或字母，客户可以看到',
    numberPlaceholder: '发票上的号码',
    file: '电子发票文件',
    fileHelp: 'PDF 或图片，不超过 10 MB；客户可以在发票记录中下载',
    filePick: '上传文件',
    fileReplace: '重新上传',
    fileTooLarge: '文件不能超过 10 MB',
    expressCompany: '快递公司',
    expressCompanyPlaceholder: '例如 顺丰速运',
    expressNo: '快递单号',
    issued: '已为 {user} 开票',
    download: '下载',
    detailTitle: '发票详情',
    rejectTitle: '驳回发票申请',
    rejectHint: '驳回后，这笔金额恢复为客户的可开票金额。',
    rejectPlaceholder: '例如：抬头与付款方不一致，请核对后重新申请',
  },
  refunds: {
    title: '退款审核',
    statRefunded: '已退款金额',
    statWaitingAmount: '待审核金额',
    statPending: '待审核',
    statFailed: '退款失败',
    listTitle: '退款申请',
    empty: '还没有退款申请',
    notReady: '支付宝未配置，充值订单暂时无法原路退款；套餐订单退款退回余额，不受影响。',
    colNo: '退款单号',
    colOrder: '原订单',
    colAmount: '退款金额',
    colApplied: '申请时间',
    target_topup: '充值',
    target_package: '套餐',
    approve: '确认退款',
    retry: '重新退款',
    approveTitle: '确认退款',
    retryTitle: '重新退款',
    asked: '申请金额',
    paid: '退款金额',
    paidHelp: '不超过申请金额 ¥{max}',
    revokeLabel: '扣减该订单购买的套餐时长',
    revokeHelp: '取消勾选则客户保留套餐时长，只退回金额。',
    topUpNote: '¥{amount} 将原路退回客户付款的支付宝账户（这笔金额已在申请时从余额扣除）。',
    doneTopUp: '已原路退回 ¥{amount}（{user}）',
    donePackage: '已退回 ¥{amount} 到 {user} 的余额',
    refundFailed: '支付宝退款失败：{reason}',
    refundPending: '支付宝暂未返回结果，系统会每分钟自动查询',
    stillProcessing: '支付宝仍在处理这笔退款',
    checked: '查询完成：{state}',
    detailTitle: '退款详情',
    failedFor: '支付宝退款失败：{reason}。核实后可以重新退款，或驳回将金额退回客户余额。',
    processingNote: '已提交支付宝，等待结果；系统每分钟自动查询一次。',
    where: '退款去向',
    where_topup: '原路退回支付宝',
    where_package: '账户余额',
    revoke: '套餐时长',
    revokeYes: '已扣减',
    revokeNo: '未扣减',
    reason: '退款原因',
    finishedAt: '完成时间',
    rejectTitle: '驳回退款',
    rejectHintTopUp: '驳回后 ¥{amount} 将退回客户的账户余额。',
    rejectPlaceholder: '例如：该订单的服务已在使用中，不符合退款条件',
  },
  finOrders: {
    title: '套餐订单',
    statSales: '套餐销售额',
    statRefunded: '已退款金额',
    statOrders: '订单总数',
    statRefunds: '待审核退款',
    listTitle: '套餐订单',
    empty: '还没有套餐订单',
    colOrderNo: '订单号',
    colPackage: '套餐',
    colAmount: '金额',
    refundedAmount: '已退款 ¥{amount}',
    colSpan: '服务期',
    colCreated: '下单时间',
    kind_buy: '新购',
    kind_renew: '续费',
    period_month: '1 个月',
    period_quarter: '3 个月',
    period_year: '1 年',
    state_paid: '已支付',
    state_partly_refunded: '部分退款',
    state_refunded: '已退款',
  },
  finSettings: {
    title: '财务设置',
    saved: '财务设置已保存',
    storeTitle: '在线购买套餐',
    storeIntro: '开启后，客户可以在用户台用账户余额购买新套餐、续费已有套餐。只有在售且启用了人民币价格的套餐才会出售。',
    onSale: '当前可出售 {n} 个套餐',
    toPackages: '去套餐管理设置价格',
    remitTitle: '线下汇款',
    remitIntro: '开启后，客户可以向下方的收款账户转账并上传银行回单；财务在「线下汇款」中核对到账后确认入账。',
    accounts: '收款账户',
    accountsCount: '{n} / {max}',
    acctName: '户名',
    acctBank: '开户行',
    acctNo: '账号',
    acctNote: '备注',
    acctNamePlaceholder: '公司全称',
    acctBankPlaceholder: '例如 招商银行杭州分行',
    acctNoPlaceholder: '银行账号',
    acctNotePlaceholder: '选填，例如 同行实时到账',
    addAccount: '添加收款账户',
    remitMin: '单笔最低金额',
    remitMinHelp: '低于这个金额的汇款不能提交',
    remitNote: '汇款说明',
    remitNoteHelp: '显示在用户台线下汇款页的顶部，例如附言要求、到账时间',
    withdrawTitle: '提现',
    withdrawIntro: '开启后，客户可以把余额提现到自己的支付宝账户：申请时金额从余额扣除，审核通过后通过支付宝自动转账。已开票的金额不能提现。',
    transferNotReady: '支付宝当前无法自动转账。开启提现前请先完成：',
    transferStep1: '在「支付配置」中把接口加签方式改为公钥证书，并上传三份证书；',
    transferStep2: '在支付宝开放平台为应用开通「转账到支付宝账户」产品。',
    transferReady: '支付宝已使用公钥证书加签，审核通过的提现会自动转账。请确保平台支付宝账户余额充足。',
    withdrawRange: '单笔提现金额',
    withdrawRangeHelp: '支付宝单笔转账最低 ¥0.10',
    fee: '手续费',
    feeAtLeast: '最低',
    feeHelp: '按提现金额的千分比收取，不低于最低手续费。例：提现 ¥{amount}，手续费 ¥{fee}，实际到账 ¥{net}。',
    invoiceTitle: '发票',
    invoiceIntro: '开启后，客户可以按实付金额申请发票（充值和汇款入账，扣除已退款、已提现和已开票的部分），由财务在「发票管理」中开具。',
    invoiceTypes: '发票类型',
    invoiceMedia: '开票方式',
    invoiceMediaHelp: '电子发票上传文件供客户下载；纸质发票填写快递单号',
    invoiceMin: '单张最低金额',
    invoiceNote: '开票说明',
    invoiceNoteHelp: '显示在用户台发票申请页的顶部，例如发票内容、开票时间',
    refundTitle: '退款',
    refundIntro: '开启后，客户可以在期限内申请退款：充值订单原路退回付款的支付宝账户，套餐订单退回账户余额并扣减套餐时长。退款需要审核，已开票的金额不能退款。',
    refundNotReady: '支付宝未配置，充值订单的退款暂时无法原路退回。',
    topupDays: '充值订单可退天数',
    topupDaysHelp: '支付后多少天内可以申请，0 为不可退',
    packageDays: '套餐订单可退天数',
    packageDaysHelp: '购买后多少天内可以申请，0 为不可退',
    days: '天',
  },
  balance: {
    col: '余额',
    kind_realname: '实名认证',
    kind_realname_back: '实名认证退回',
    open: '查看收支明细、调整余额',
    title: '账户余额 · {user}',
    current: '当前余额',
    adjustTitle: '调整余额',
    credit: '增加',
    debit: '扣减',
    amount: '金额',
    notePlaceholder: '调整原因（客户可在收支明细中看到）',
    apply: '确认调整',
    adjustHelp: '例如线下转账、补偿或退款。扣减后余额不能低于 0。',
    confirmCredit: '确认给 {user} 增加 ¥{amount}？',
    confirmDebit: '确认从 {user} 扣减 ¥{amount}？',
    credited: '已给 {user} 增加 ¥{amount}',
    debited: '已从 {user} 扣减 ¥{amount}',
    ledgerTitle: '收支明细',
    ledgerCount: '共 {n} 条',
    noLedger: '还没有收支记录',
    kind_topup: '在线充值',
    kind_adjust: '余额调整',
    ledgerTopUp: '支付宝充值',
    after: '余额 ¥{amount}',
    colTime: '时间',
    colKind: '类型',
    colChange: '金额',
    colAfter: '余额',
    colNote: '说明',
    kind_remittance: '线下汇款',
    kind_withdraw: '提现',
    kind_withdraw_back: '提现退回',
    kind_refund: '充值退款',
    kind_refund_back: '退款退回',
    kind_purchase: '套餐消费',
    kind_order_refund: '套餐退款',
    desc_remittance: '银行汇款入账',
    desc_withdraw: '提现至支付宝',
    desc_withdraw_back: '提现未完成，退回余额',
    desc_refund: '充值原路退回支付宝',
    desc_refund_back: '退款未完成，退回余额',
    desc_purchase: '套餐「{name}」',
    desc_order_refund: '套餐「{name}」退款',
  },
  subscriptions: {
    autoFailed: '续费失败',
    autoFailed_insufficientBalance: '最近一次自动续费未成功：客户余额不足',
    autoFailed_other: '最近一次自动续费未成功：暂不支持在线续费',
    autoFailed_periodUnavailable: '最近一次自动续费未成功：所选续费时长已停售',
    title: '已售套餐',
    intro: '客户已购买的套餐。套餐到期（加上默认页面中设置的宽限期）后，该套餐下的站点会暂停服务；续期、修改到期时间或恢复后，一分钟内自动恢复。',
    tabAll: '全部',
    state_active: '有效',
    state_expiring: '即将到期',
    state_expired: '已到期',
    state_cancelled: '已取消',
    searchPlaceholder: '搜索用户名或套餐',
    allPackages: '全部套餐',
    assign: '分配套餐',
    userCol: '用户',
    packageCol: '套餐',
    stateCol: '状态',
    startedCol: '开始时间',
    expiresCol: '到期时间',
    remainingCol: '剩余',
    sitesCol: '站点',
    autoRenewCol: '自动续费',
    autoRenewHelp: '开启后，套餐到期前 3 天自动从客户余额扣费续费（时长按客户的设置，默认 1 个月），余额不足时提醒客户。需在「财务设置」开启在线购买。',
    daysLeft: '{n} 天',
    hoursLeft: '{n} 小时',
    expiredAgo: '已过期 {n} 天',
    renew: '续期',
    edit: '修改',
    cancel: '取消',
    resume: '恢复',
    pickUser: '选择用户',
    pickPackage: '选择套餐',
    pickUserAndPackage: '请选择用户和套餐',
    pickDate: '请选择到期时间',
    validity: '有效期',
    byDays: '按时长',
    byDate: '指定到期时间',
    nDays: '{n} 天',
    days: '天',
    assigned: '已分配',
    renewTitle: '续期',
    renewFor: '为 {user} 的「{pkg}」续期',
    renewPreview: '续期后到期时间：{at}。还没到期时从原到期时间往后顺延，已经到期的从现在开始计算。',
    renewed: '已续期，相关站点一分钟内恢复服务',
    editTitle: '修改套餐',
    editEndsNow: '到期时间早于现在：保存后这个套餐立即结束，它下面的 {n} 个站点会暂停服务。',
    updated: '已保存',
    cancelTitle: '取消这个套餐？',
    cancelWithSites: '取消后，该客户在这个套餐下的 {n} 个站点会在一分钟内暂停服务。在原到期时间之前可以恢复。',
    cancelNoSites: '这个套餐下没有站点。在原到期时间之前可以恢复。',
    cancelOk: '确定取消',
    cancelled: '已取消',
    resumed: '已恢复',
    actionFailed: '操作失败',
  },
  packages: {
    accessNote: '客户建站时按这里的配置自动生成 CNAME 并写入 DNS',
    cnameZoneLabel: '接入域名',
    cnameZonePlaceholder: '选择接入域名',
    lineGroupLabel: '线路组',
    lineGroupPlaceholder: '选择线路组',
    cnameValueLabel: 'CNAME 解析值',
    cnameValuePlaceholder: '例如 cdn',
    cnameCol: 'CNAME',
    cnameNone: '不自动生成',
    chainTitle: '生成的解析链路',
    chainSharedNote: '按套餐生成：该套餐下所有站点共用这一条记录。',
    chainPerSiteNote: '按站点生成：开头的 d 后面接站点 ID，每个站点一条记录。',
    chainIncomplete: '接入域名、线路组、CNAME 解析值需要都填上才会生成 CNAME。',
    secPricing: '定价',
    pricingNote: '按币种分别定价，留空或填 0 表示免费',
    cnyPricing: '人民币定价',
    usdPricing: '美元定价',
    termMonthly: '月付',
    termQuarterly: '季付',
    termYearly: '年付',
    unitMillion: '百万',
    unitCount: '个',
    unitRules: '条',
    pendingTag: '未实现',
    sectionZeroNote: '0 = 不限',
    secBasic: '基本信息',
    secCapacity: '资源配额',
    secQuotas: '数量限制',
    secProtection: '防护能力',
    secFeatures: '功能开关',
    secAccess: '接入方式',
    descLabel: '套餐描述',
    descPlaceholder: '一句话说明这个套餐卖什么，选填',
    bandwidthLabel: '带宽上限',
    connectionsLabel: '并发连接数',
    siteQuotaLabel: '站点数',
    siteQuotaHint: '一个站点就是站点列表里的一条',
    domainQuotaHint: '含子域名，一级二级都算',
    apexQuotaLabel: '主域名数',
    apexQuotaHint: '只算一级域名，子域名不计',
    customPortLabel: '自定义端口数',
    l4PortLabel: '应用加速规则数',
    l4PortHint: '需同时打开「应用加速」开关',
    ruleQuotaLabel: '规则条数',
    ccCapacityLabel: 'CC 防护',
    ddosCapacityLabel: 'DDoS 防护',
    logRetentionLabel: '日志保留',
    days: '天',
    allowCustomCc: '自定义 CC 规则',
    allowWebsocket: 'WebSocket',
    allowHttp3: 'HTTP/3',
    allowWaf: 'WAF',
    allowL2Origin: 'L2 汇聚回源',
    allowCustomCert: '自定义证书',
    allowOpenapi: 'OpenAPI',
    allowL4: '应用加速',
    cnameModeLabel: 'CNAME 生成模式',
    cnamePerSite: '按站点生成',
    cnamePerPackage: '按套餐生成（共享）',
    unlimited: '不限',
    zeroMeansUnlimited: '填 0 表示不限',
    capacityHint: '展示用的防护能力值，不是限流阈值',
    notBuiltYet: '该功能尚未实现，此处仅登记',
    enforcement: '这里的设置都会执行。功能开关：套餐不含的功能在它的站点上不生效，配置保留，站点换到含该功能的套餐后自动恢复；已上传的证书继续可用。数量配额：到上限后客户不能再新增站点、域名或规则，已有的不受影响，管理员不受限制。流量和请求数按开通日每月重置，用完后站点暂停；带宽和连接数是所有节点的合计上限。标「未实现」的暂不生效。',
    tabPackages: '套餐列表',
    tabGroups: '套餐分组',
    groupCol: '分组',
    groupLabel: '所属分组',
    groupPlaceholder: '不选则为未分组',
    groupHint: '分组只影响控制台的归类和筛选，不改变套餐的配额和价格。',
    groupFilter: '按分组筛选',
    groupFilterAll: '全部分组',
    ungrouped: '未分组',
    title: '套餐管理',
    sectionTitle: '套餐管理',
    nameCol: '名称',
    priceCol: '月费',
    trafficCol: '月流量(GB)',
    requestCol: '月请求(百万)',
    domainQuotaCol: '域名数',
    statusCol: '状态',
    statusActive: '上架',
    statusDisabled: '下架',
    create: '新建套餐',
    edit: '编辑',
    delete: '删除',
    deleteConfirmTitle: '删除套餐',
    deleteConfirm: '确定删除套餐「{name}」吗？该操作不可撤销。',
    nameLabel: '套餐名',
    trafficLabel: '月流量',
    requestLabel: '月请求量',
    domainQuotaLabel: '域名数',
    saveSuccess: '已保存',
    saveFailed: '保存失败',
    deleteSuccess: '已删除',
    deleteFailed: '删除失败',
    assignToUser: '分配给用户',
    userIdLabel: '用户 ID',
    expiresAtLabel: '到期时间 (RFC3339)',
    assignSuccess: '已分配',
    assignFailed: '分配失败',
  },
  systemUpdate: {
    title: '系统更新',
    controlTitle: '主控版本',
    controlIntro: '主控每小时向授权站的版本仓库检查新版本。点击更新后，由主控机上的更新服务先备份数据库，再替换文件、重启并迁移；新版本没有正常启动时自动恢复到当前版本。',
    check: '检查更新',
    stateRunning: '正在更新',
    stateCheckFailed: '检查失败',
    stateAvailable: '有新版本',
    stateLatest: '已是最新',
    stateUnchecked: '未检查',
    noReleaseKey: '当前运行的不是正式发布版本（没有内置发布公钥），无法校验更新。请先按发布流程安装一次。',
    noUpdaterTitle: '主控机尚未安装更新服务',
    noUpdater: '在主控机上执行一次下面的命令（需要 root），之后在这里点击更新即可：',
    current: '当前版本',
    latest: '最新版本',
    releasedAt: '发布于 {time}',
    checkedAt: '上次检查',
    never: '从未检查',
    updater: '更新服务',
    updaterInstalled: '已安装（{time}）',
    updaterMissing: '未安装',
    checkError_noRelease: '版本仓库里还没有发布任何版本',
    checkError_badSignature: '版本仓库的版本信息签名校验失败',
    checkError_badManifest: '版本仓库的版本信息格式不正确',
    checkError_unreachable: '无法连接版本仓库',
    foundNew: '发现新版本 {v}',
    upToDate: '已是最新版本',
    incoming: '更新内容',
    comp_control: '主控',
    comp_agent: '节点程序',
    comp_edge: '边缘程序',
    confirmTitle: '更新主控到 {v}？',
    confirmBody: '将先备份数据库，再替换主控文件并重启，期间控制台约 1–2 分钟无法访问；新版本没有正常启动时会自动恢复到当前版本。',
    confirmOk: '开始更新',
    phase_download: '下载校验',
    phase_backup: '备份数据',
    phase_swap: '替换文件',
    phase_build: '构建镜像',
    phase_restart: '重启主控',
    phase_migrate: '迁移数据',
    phase_check: '启动检查',
    restarting: '主控正在重启，控制台暂时无法访问，完成后页面会自动刷新…',
    run_succeeded: '已于 {time} 从 {from} 更新到 {to}',
    run_rolled_back: '更新到 {to} 失败，已恢复到 {from}',
    run_failed: '更新到 {to} 失败，主控没有变化',
    backupAt: '数据库备份：{path}',
    updateTo: '更新到 {v}',
    updateHint: '会先备份数据库，失败自动恢复',
    done: '主控已更新到 {v}，即将刷新页面',
    nodesTitle: '节点版本',
    nodesIntro: '节点从主控取得新版本：主控检查到新版本后，先从版本仓库下载节点程序和边缘程序并校验。各节点再自己校验和替换；边缘程序会把连接交给新进程，更新过程中不会断流。',
    latestNode: '最新版本',
    nodesOutdated: '可更新节点',
    nodesCount: '{n} 台（共 {total} 台）',
    toNodes: '前往节点列表',
    upgradeAll: '全部更新（{n}）',
    nodesConfirmTitle: '更新 {n} 台节点？',
    nodesConfirmBody: '每台节点下载并校验新版本后依次替换：先边缘程序（不断流），后节点程序。离线的节点会在上线后更新。',
    nodesConfirmOk: '开始更新',
    nodesQueued: '已下发 {n} 个更新任务',
    nodeFirstTime: '节点第一次通过这里更新前，需要在每台节点上执行一次（需要 root）：',
    settingsTitle: '更新设置',
    settingsIntro: '版本由仓库机构建、用发布密钥签名后发布到授权站，主控和节点只接受校验通过的版本。版本仓库只对有授权的主控开放。',
    autoCheck: '自动检查更新',
    autoCheckHelp: '每小时检查一次，有新版本时菜单上会出现提示',
    saved: '已保存',
    historyTitle: '版本记录',
    historySub: '版本仓库里的版本',
    historyEmpty: '还没有检查过版本仓库',
    colVersion: '版本',
    colReleased: '发布时间',
    colChanged: '变更',
    colNotes: '说明',
    runsTitle: '更新记录',
    runsEmpty: '还没有更新过',
    colTime: '时间',
    colVersions: '版本',
    colResult: '结果',
    result_success: '成功',
    result_failed: '失败',
    stateNoLicense: '未激活授权',
    noRepository: '主控还没有激活授权：版本仓库只对有授权的主控开放。',
    repoTokenExpired: '版本仓库的下载令牌已过期：授权很久没有续期了。',
    toLicense: '前往授权页',
    repository: '版本仓库',
    repositoryHelp: '由授权站随授权下发，不能在这里修改',
    repositoryNone: '激活授权后显示',
    checkError_unauthorized: '版本仓库拒绝了下载令牌：授权未生效或已停用',
    nodeArtifacts: '节点版本文件',
    nodeArtifactsReady: '已下载并校验，节点可以更新',
    nodeArtifactsPreparing: '正在从版本仓库下载…',
    nodeArtifactsFailed: '下载失败：{reason}',
    nodeArtifactsNone: '检查到新版本后自动下载',
    tokenNote: '命令从授权站的版本仓库下载，需要下载令牌：先在授权站控制台生成令牌，执行 export CDNX_REPO_TOKEN=你的令牌，再执行上面的命令。',
  },
  systemSettings: {
    skin: '主题色',
    skinHelp: '全平台统一的主题颜色，用户控制台、管理后台和登录页同时生效，用户不能自行更改。可选推荐颜色，也可自定义任意颜色',
    uiSection: '界面',
    navbarHeight: '导航栏默认高度',
    menuWidth: '菜单默认宽度',
    layoutHelp: '用户没有在自定义设置里自行调整时使用；用户仍可在自定义设置中改为自己的尺寸',
    title: '系统配置',
    intro: '平台级设置。名称与图标会用在两个控制台和边缘的人机验证页上。',
    brandingSection: '品牌',
    systemName: '系统名称',
    systemNameHelp: '平台的对外名称。显示在两个控制台的左上角和登录页；浏览器标签页显示为「页面名 - 系统名称」。',
    challengeBrand: '验证页安全名称',
    challengeBrandHelp: '人机验证页上显示的品牌名，由节点渲染，保存后需等待配置下发到节点才生效。',
    favicon: 'favicon 图标',
    faviconHelp: '仅支持 .ico 文件，最大 256KB。用作两个控制台和验证页的浏览器标签页图标；未上传 LOGO 时也作为 LOGO 显示。',
    noFavicon: '未上传',
    uploadFavicon: '上传 .ico',
    faviconUploaded: '图标已更新',
    faviconFailed: '图标上传失败',
    registrationSection: '注册与登录',
    allowRegistration: '开放自助注册',
    allowRegistrationHelp: '关闭后，注册接口本身会直接拒绝请求，不只是隐藏入口。同一 IP 每小时最多注册 5 次。',
    defaultPackage: '默认套餐',
    defaultPackageHelp: '新注册用户自动分配的套餐，可以不选：不分配时，用户需自行购买套餐后才能添加站点。',
    noEmailVerification: '系统当前没有邮件能力，注册填写的邮箱地址未经验证，请勿当作已验证的联系方式使用。',
    saved: '已保存',
    saveFailed: '保存失败',
    websiteUrl: '官网地址',
    websiteUrlHelp: '用户台登录、注册页右上角的「返回官网」和页脚的「官方网站」链接到这里，留空则不显示。',
    verifyEmail: '注册验证邮箱',
    verifyEmailHelp: '注册时向邮箱发送验证码，验证通过才能注册。',
    verifyPhone: '注册验证手机',
    verifyPhoneHelp: '注册时须填写手机号并通过短信验证码验证，验证后的手机号可直接用于登录。',
    serviceOff: '需要先启用{name}。',
    mailService: '邮件服务',
    smsService: '短信服务',
    goSetUp: '去配置',
    noVerification: '未开启注册验证：注册时填写的邮箱和手机号都未经验证，请勿当作已验证的联系方式使用。',
    verifyServiceDown: '已开启的注册验证或验证码登录所需的服务当前不可用，用户收不到验证码。',
    agreementsSection: '用户协议',
    agreementsIntro: '用户台登录页显示「登录即表示您已阅读并同意」，注册时须勾选同意。没有内容的协议不会显示。默认内容是通用模板，正式使用前请结合实际业务修改。',
    agreement_terms: '用户使用条款',
    agreement_privacy: '隐私政策',
    agreementMode: '提供方式',
    agreementContent: '编辑内容',
    agreementLink: '外链地址',
    agreementUrl: '协议地址',
    agreementUrlHelp: '用户点击协议名称时在新窗口打开这个地址。',
    agreementText: '协议内容',
    agreementTextHelp: '用户点击协议名称时在弹窗中查看。英文界面显示英文内容，未填写英文时显示中文。',
    agreementPlaceholder: '输入协议内容，可从文档中直接粘贴',
    agreementPlaceholderEn: 'Paste or write the English version',
    noDefaultPackage: '不分配套餐',
    loginBySms: '短信验证码登录',
    loginBySmsHelp: '用户台登录页提供「验证码登录」，向账号已验证的手机号发送验证码。',
    loginByEmail: '邮箱验证码登录',
    loginByEmailHelp: '用户台登录页提供「验证码登录」，向账号的邮箱发送验证码。',
    authPagesSection: '登录与注册页面',
    authPagesIntro: '用户台登录页、注册页顶部的公告和底部的页脚。两个页面的公告各自独立，样式相同；页脚两个页面共用。',
    login_notice: '登录页公告',
    register_notice: '注册页公告',
    noticeShow: '显示公告',
    noticeShowHelp: '显示在页面顶部，访客可以点右侧的 × 关闭；公告内容修改后会重新显示。',
    noticeText: '公告内容',
    noticeTextHelp: '可以加粗和添加链接，链接在新窗口打开。英文界面显示英文内容，未填写英文时显示中文。',
    noticePlaceholder: '例如：【重要】平台将于今晚 23:00 至 24:00 进行升级维护，期间控制台可能无法访问',
    noticePlaceholderEn: 'e.g. [Important] Maintenance tonight from 23:00 to 24:00: the console may be unavailable',
    restoreDefault: '恢复默认',
    restoreDefaultConfirm: '用默认内容替换当前的中文和英文内容？保存页面后生效。',
    restoreFooterConfirm: '用默认的页脚链接和版权信息替换当前内容？保存页面后生效。',
    footerTab: '页脚',
    backgroundTab: '背景图片',
    background: '登录与注册页背景',
    backgroundHelp: '铺满整个页面，按比例裁切。建议 2560×1440 以上的 JPG 或 WebP，最大 {max} MB；未上传时显示内置插画，深色主题未上传时沿用浅色背景。',
    backgroundBuiltIn: '内置插画',
    backgroundUploaded: '背景图片已更新',
    backgroundRemoved: '已恢复内置插画',
    backgroundFailed: '背景图片上传失败',
    removeBackgroundConfirm: '删除这张背景图片？',
    footerShow: '显示页脚',
    footerShowHelp: '显示在登录页和注册页底部，最左侧是系统名称和图标。',
    footerLinks: '页脚链接',
    footerLinksHelp: '「官方网站」跟随上方的官网地址，未设置时不显示；协议链接打开对应的协议内容，协议没有内容时不显示。最多 20 个。',
    linkKind: '类型',
    linkKind_url: '自定义链接',
    linkKind_website: '官方网站',
    linkKind_terms: '用户使用条款',
    linkKind_privacy: '隐私政策',
    linkText: '名称',
    linkTextEn: '英文名称',
    linkUrl: '链接地址',
    linkFollowsWebsite: '跟随官网地址：{url}',
    linkNoWebsite: '未设置官网地址，暂不显示',
    linkOpensAgreement: '打开协议内容',
    linkActions: '操作',
    moveUp: '上移',
    moveDown: '下移',
    removeLink: '删除',
    addLink: '添加链接',
    footerCopyright: '版权信息',
    footerCopyrightEn: '英文版权信息',
    footerCopyrightHelp: '{year} 显示为当前年份，{name} 显示为系统名称；英文界面显示英文版权信息，未填写时显示中文。',
    logo: 'LOGO',
    logoHelp: '显示在两个控制台左上角和用户台登录、注册页。浅色、深色主题各一张（深色主题和深色导航栏使用深色那张），只上传一张时两种主题都用它。支持 PNG、JPG、WebP、GIF、SVG，最大 512KB，建议透明背景、高度不低于 64 像素；SVG 上传时会去掉脚本、外部链接等不安全的内容。未上传时使用 favicon 图标。',
    uploadLogo: '上传 LOGO',
    removeLogo: '删除',
    removeLogoConfirm: '删除这张 LOGO？',
    logoUploaded: 'LOGO 已更新',
    logoRemoved: 'LOGO 已删除',
    logoFailed: 'LOGO 上传失败',
    logoMini: '收起菜单 LOGO',
    logoMiniHelp: '左侧菜单收起时左上角显示的图标，建议使用正方形、不含文字的图形。未上传时使用 favicon 图标。',
    logoLight: '浅色主题',
    logoDark: '深色主题',
    logoUpload: '上传',
    logoReplace: '更换',
    showBrandName: '显示系统名称',
    showBrandNameHelp: '在 LOGO 右侧显示系统名称。LOGO 本身已包含文字时可以关闭；未上传 LOGO 时始终显示名称。',
  },
  banLogs: {
    title: '封禁日志',
    intro: 'CC 防护、验证失败封禁和节点防护自动封禁的地址。当前封禁已下发到节点内核，到期后自动清除；开启全网联动封禁后，会同步到所有节点。',
    tabActive: '当前封禁',
    tabHistory: '历史封禁',
    showingLatest: '共 {total} 条，这里显示最近的 {shown} 条。要找更早的记录，可以按 IP、站点或规则搜索。',
    searchPlaceholder: '搜索 IP、域名或规则',
    ipCol: 'IP',
    domainCol: '域名',
    ruleCol: '触发规则',
    nodeCol: '节点',
    bannedAtCol: '封禁时间',
    expiresCol: '到期时间',
    remainingCol: '剩余',
    outcomeCol: '结束方式',
    inMinutes: '{n} 分钟',
    inHours: '{n} 小时',
    release: '解封',
    released: '手动解封',
    expired: '自动到期',
    releaseQueued: '已解封,正在通知节点移除',
    releaseQueuedAll: '已解封，正在通知 {n} 个节点移除',
    releaseRecorded: '已记录解封,但未能通知节点,内核封禁将在到期后自动清除',
    releaseFailed: '解封失败',
    noMatch: '没有匹配的记录',
    emptyActive: '当前没有被封禁的地址',
    emptyHistory: '暂无历史记录',
    nodeWide: '整个节点',
    rule_conn_flood: '连接速率超限',
    rule_tls_fail: 'TLS 握手失败过多',
    rule_unbound_access: '访问未绑定域名 / 节点 IP',
    rule_error_pages: '频繁触发默认页面',
    rule_block_kernel: '拉黑（内核级）',
    rule_block_escalation: '拉黑次数过多，转内核',
    rule_block_surge: '遭受攻击，拉黑转内核',
  },
  defaultPages: {
    title: '默认页面',
    intro: '边缘节点自己回应请求时显示的页面：拦截、封禁、源站故障、站点暂停、域名未接入等。所有站点共用这一套，保存后自动发布到所有节点。',
    name_blocked: '拉黑页面',
    name_forbidden: '403 禁止访问',
    name_waf: 'WAF 拦截',
    name_geo_blocked: '区域屏蔽',
    name_bad_request: '400 请求无效',
    name_rate_limited: '请求数超限',
    name_conn_limited: '连接数超限',
    name_bad_gateway: '502 源站错误',
    name_gateway_timeout: '504 源站超时',
    name_internal_error: '500 内部错误',
    name_plan_expired: '套餐到期',
    name_traffic_exceeded: '流量超限',
    name_requests_exceeded: '请求数超限（配额）',
    name_unbound: '域名未绑定',
    name_direct_ip: '节点 IP 访问',
    when_blocked: '访问者的 IP 被拉黑或封禁时显示：IP 名单黑名单、CC 封禁、验证失败封禁。',
    when_forbidden: '访问控制规则、机器人规则或 CC 规则拒绝访问时显示。',
    when_waf: 'WAF 判定请求是攻击并拦截时显示。',
    when_geo_blocked: '站点的区域屏蔽拒绝访问者所在地区时显示。',
    when_bad_request: '请求不完整或无法解析时显示，例如缺少 Host。',
    when_rate_limited: 'CC 规则限速（返回 429）时显示。',
    when_conn_limited: '站点的回源并发数达到上限、节点暂时拒绝新请求时显示。',
    when_bad_gateway: '节点无法从源站拿到有效响应时显示：源站拒绝连接、SSL 握手失败、证书无效、连接中断等，页面会写明原因。',
    when_gateway_timeout: '连接源站或等待源站响应超时时显示，页面会写明原因。',
    when_internal_error: '节点处理请求时出现内部错误时显示。',
    when_plan_expired: '站点所属的套餐到期后，访问该站点的所有请求都显示这个页面。证书续期不受影响。',
    when_traffic_exceeded: '站点所属套餐本周期的流量用完时，访问该站点的所有请求都显示这个页面，直到下个周期、续费或管理员加量。',
    when_requests_exceeded: '站点所属套餐本周期的请求数用完时显示，规则同流量超限。',
    when_unbound: '访问的域名指向了节点，但没有添加到平台（或者已停用）时显示。',
    when_direct_ip: '直接用节点 IP 访问时显示。',
    mode: '显示方式',
    modeDefault: '默认页面（中英双语）',
    modeText: '自定义文字（使用默认样式）',
    modeHtml: '自定义 HTML',
    modeDrop: '直接断开连接，不返回内容',
    status: '状态码',
    statusHelp: '默认 {n}。',
    titleLabel: '标题',
    messageLabel: '说明文字',
    htmlLabel: 'HTML',
    htmlHelp: '完整的 HTML 页面，最大 {kb} KB。请不要引用外部资源：源站或网络出问题时它们可能也加载不出来。',
    htmlPlaceholder: '<!doctype html> ...',
    useTemplate: '以默认页面为模板',
    placeholdersTitle: '可用变量（会自动转义）',
    ph_status: '状态码',
    ph_request_id: '请求 ID，可在访问日志中搜索',
    ph_client_ip: '访问者 IP',
    ph_host: '访问的域名',
    ph_time: '时间（UTC）',
    ph_brand: '品牌名称（系统设置中的验证页品牌）',
    ph_reason: '源站故障原因（仅 502 / 504 页面）',
    dropNote: '直接断开连接，不返回任何内容（相当于 444），比返回页面更省资源，适合扫描器多的场景。',
    expirySection: '到期处理',
    suspend: '套餐到期后暂停站点',
    suspendHelp: '站点所属套餐到期（加上宽限期）后，站点暂停服务并显示上面的页面；重新分配套餐后一分钟内自动恢复。',
    grace: '宽限期',
    graceHelp: '到期后再保持服务多长时间，0 表示到期立即暂停。',
    hours: '小时',
    trafficNote: '流量超限的自动暂停还没有上线：目前套餐里的流量配额只用于展示，这个页面要等配额执行上线后才会出现。现在可以先把页面配置好。',
    blockedNote: '被拉黑的 IP 是看到这个页面、被直接断开，还是转内核级封禁，由「防火墙 → 拉黑方式」决定；这里只设置页面的内容。',
    countedNote: '每次回应这个页面都会计入「防火墙 → 节点防护 → 默认页面触发次数」，同一 IP 超过次数后会被封禁。',
    preview: '预览',
    previewDrop: '断开连接时不返回任何页面',
    previewFailed: '预览失败',
    resetPage: '恢复此页默认',
    saved: '已保存，正在发布到所有节点',
    saveFailed: '保存失败',
  },
  consoleDomains: {
    title: '主控域名',
    intro: '设置前台（客户控制台）和后台（管理控制台）的访问域名。绑定后直接用域名访问，不用加端口：http://域名 走 80 端口，配置证书后 https://域名 走 443 端口。原来的访问方式（http://IP 和 IP:8000）照常可用。节点连接主控用的通信域名在「主控通信」页面设置。',
    addresses: '访问地址',
    addressHttp: '（保存后即可使用，不用加端口）',
    addressHttpsPending: '配置有效证书后还可以用 HTTPS 访问',
    commonSection: '通用设置',
    httpsPort: 'HTTPS 端口',
    httpsPortHelp: '浏览器访问控制台 HTTPS 的端口。主控在容器内的 8443 端口提供 HTTPS，docker-compose 已映射到 443，需要在云服务器安全组放行 443。',
    email: '证书联系邮箱',
    emailHelp: '证书颁发机构用于发送到期提醒；两个域名的证书申请和自动续期都使用这个邮箱。',
    ca: '证书颁发机构',
    site_customer: '前台（客户控制台）',
    site_admin: '后台（管理控制台）',
    domain: '访问域名',
    domainPlaceholder_customer: '例如 console.example.com',
    domainPlaceholder_admin: '例如 admin.example.com',
    domainHelp: '需要解析到主控服务器的 IP。申请证书时，证书颁发机构通过 80 端口访问 http://域名/.well-known/acme-challenge/ 验证。',
    url: 'HTTPS 访问地址',
    urlNotReady: '配置有效证书后可用',
    unsaved: '有未保存的改动，请先保存，再申请或上传证书',
    redirect: 'HTTP 自动跳转到 HTTPS',
    redirectHelp: '开启后，通过这个域名用 HTTP 访问会跳转到 HTTPS。需要先有对该域名有效的证书；证书过期时自动停止跳转，避免打不开。',
    adminOnly: '只允许通过后台域名访问后台',
    adminOnlyHelp: '开启后，通过 IP:8000 或其他域名访问后台都会返回 404，只有后台域名能打开，可以隐藏后台入口。默认关闭。',
    adminOnlyWrongHost: '当前是通过 {host} 打开的后台。需要先通过 {domain} 打开后台，才能开启这个开关，确保开启后你还能进来。',
    adminOnlyRecover: '如果后台域名失效、进不来了，在主控机执行下面的命令解除限制（一分钟内生效）：',
    adminOnlyConfirmTitle: '只允许通过后台域名访问后台',
    adminOnlyConfirm: '开启后，只有 {domain} 能打开后台，通过 IP:8000 等其他方式访问都会返回 404。确定开启吗？',
    saved: '已保存',
    saveFailed: '保存失败',
  },
  clickhouse: {
    title: 'ClickHouse',
    connState: '连接状态',
    intro: '访问日志、安全日志和节点监控历史都存在 ClickHouse 里。这里可以修改连接、设置每张表保留多少天；磁盘快满时，系统会从最旧的一天开始自动删除。',
    connection: '连接',
    connected: '已连接',
    disconnected: '未连接',
    notConfigured: '未配置',
    versionUptime: 'ClickHouse {version} · 已运行 {uptime}',
    uptimeDays: '{d} 天 {h} 小时',
    uptimeHours: '{h} 小时 {m} 分钟',
    uptimeMinutes: '{m} 分钟',
    disk: '磁盘使用',
    diskOf: '{used} / {total}',
    platformData: '平台数据',
    rowsTotal: '共 {rows} 行',
    lastCleanup: '最近清理',
    noCleanup: '暂无',
    freed: '释放 {size}',
    nothingTaken: '没有删除数据',
    test: '测试连接',
    edit: '修改连接',
    source: '来源',
    sourceConsole: '控制台设置',
    sourceFile: '配置文件',
    resetToFile: '恢复为配置文件的连接',
    resetConfirm: '恢复后改用配置文件（control.yaml 或环境变量）中的连接：{addr}。确定吗？',
    resetDone: '已恢复为配置文件的连接',
    addr: '地址',
    database: '数据库',
    username: '用户',
    password: '密码',
    passwordSet: '已设置',
    passwordEmpty: '未设置',
    on: '开启',
    off: '关闭',
    status: '状态',
    connectedSince: '自 {time}',
    failingSince: '自 {time} 起无法连接',
    version: '版本',
    timezone: '时区',
    schemaMissing: '表结构不完整，缺少：{items}',
    andMore: ' 等 {n} 项',
    initSchema: '初始化表结构',
    schemaDone: '表结构已初始化（执行了 {n} 条语句）',
    passwordPlain: '未配置 secrets.encryption_key，控制台保存的密码以明文存放在数据库中',
    passwordUnreadable: '无法解密控制台保存的密码：{error}',
    testOkLine: '连接成功 · ClickHouse {version} · 延迟 {ms} ms',
    testFailLine: '连接失败：{error}',
    tables: '数据表',
    cleanNow: '立即清理',
    cleanConfirm: '按当前保存的设置清理：删除超过保留天数的数据；磁盘超过清理阈值时，还会从最旧的一天删起，直到降到清理目标。删除后无法恢复。',
    cleaned: '清理完成：{what}',
    nothingToClean: '没有需要清理的数据',
    runSize: '{what}，释放 {size}',
    runDays: '删除 {n} 天的数据',
    runLogs: '清空 {n} 张系统日志表',
    listSep: '、',
    noTables: '数据库里还没有表，请先初始化表结构',
    connectFirst: '连接 ClickHouse 后才能查看',
    colTable: '数据',
    colKeep: '保留',
    colRange: '数据范围',
    colRows: '行数',
    colSize: '占用空间',
    days: '天',
    defaultDays: '默认 {n} 天',
    dayCount: '共 {n} 天',
    noData: '暂无数据',
    compressed: '压缩比 {ratio}×',
    ttlPending: '原 TTL 待移除',
    ttlPendingHint: '保留天数改由主控按天清理。这张表建表时自带的 TTL 会在下一次清理（最多 5 分钟）时移除，在那之前它仍会按原来的天数删除数据。',
    minuteStatsShort: '低于 60 天时，数据分析「近 30 天」的同期对比会不完整',
    table_edge_access_log: '访问日志',
    table_edge_security_log: '安全日志',
    table_node_metrics: '节点监控',
    table_edge_url_stats: 'URL 小时汇总',
    table_edge_ip_risk_stats: 'IP 风险汇总',
    table_edge_domain_minute_stats: '分钟级汇总',
    tableHint_edge_access_log: '每个请求一行。访问日志、访问统计、回源统计和数据分析的排行都查它，保留天数也决定这几个页面最多能查多少天。',
    tableHint_edge_security_log: 'WAF、CC、访问控制等的拦截记录，安全事件页面查它。',
    tableHint_node_metrics: '每个节点每分钟一行的 CPU、内存、带宽、连接数等，节点详情的历史曲线查它。',
    tableHint_edge_url_stats: '按小时汇总的各 URL 请求量和流量。',
    tableHint_edge_ip_risk_stats: '按 5 分钟汇总的各 IP 拦截次数。',
    tableHint_edge_domain_minute_stats: '按分钟汇总的请求数、流量、状态码和响应时间，仪表盘和数据分析的趋势图查它。',
    systemLogs: 'ClickHouse 系统日志',
    usageLine: '{n} 张表 · {size}',
    truncate: '清空',
    truncateConfirm: '清空 ClickHouse 自身的日志表（query_log、trace_log 等）。这些日志只用于排查 ClickHouse 本身的问题，不影响平台数据。',
    truncated: '已清空 {n} 张系统日志表，释放 {size}',
    otherDatabases: '其他数据库',
    autoCleanup: '磁盘自动清理',
    autoCleanupSwitch: '磁盘空间不足时自动删除最旧的数据',
    thresholdLine: '使用率超过',
    thresholdThen: '时开始清理，清理到',
    thresholdEnd: '为止',
    keepLine: '始终保留最近',
    keepEnd: '的数据（自动清理不会删除）',
    systemLogsFirst: '先清空 ClickHouse 系统日志',
    systemLogsFirstHint: 'query_log、trace_log 等只用于排查 ClickHouse 自身，默认安装下最常把磁盘写满',
    order: '清理顺序：ClickHouse 系统日志 → 访问日志 → 安全日志 → 节点监控、URL 汇总、IP 风险汇总 → 分钟级汇总。每类都从最旧的一天删起，降到清理目标就停止。超过保留天数的数据不受这里的开关影响，每 5 分钟检查一次并删除。',
    markHigh: '开始清理 {pct}%',
    markLow: '清理到 {pct}%',
    diskLine: '已用 {used} / 共 {total} · 可用 {free}',
    pendingLine: ' · 待释放 {size}',
    history: '清理记录',
    noHistory: '暂无清理记录',
    colTime: '时间',
    colTrigger: '方式',
    colWhat: '删除内容',
    colFreed: '释放',
    colDisk: '磁盘使用',
    colResult: '结果',
    trigger_auto: '自动',
    trigger_manual: '手动',
    trigger_policy: '保存设置',
    trigger_system_logs: '清空系统日志',
    whatDays: '{table} {n} 天（{from} ~ {to}）',
    whatDay: '{table} {day}',
    whatLogs: '系统日志 {n} 张表',
    resultOk: '完成',
    resultShort: '仍高于清理目标',
    resultShortHint: '剩下的数据都在始终保留的最近 {n} 天内，或者磁盘被其他数据占用',
    policySaved: '设置已保存',
    policySavedCleaned: '设置已保存，并按新设置清理：{what}',
    problem: '读取失败：{error}',
    connTitle: '修改 ClickHouse 连接',
    addrHelp: '主机:端口，多台用逗号分隔。填原生协议端口（默认 9000，TLS 一般为 9440），不是 HTTP 的 8123',
    databaseHelp: '平台数据所在的库，默认 cdnx_logs',
    passwordKeep: '留空则沿用当前密码',
    tls: '使用 TLS 加密连接',
    tlsHelp: '连接云厂商托管的 ClickHouse 时一般需要开启；端口为 9440 时自动开启',
    initOnSave: '保存时初始化表结构',
    initHelp: '数据库或表不存在时自动创建，已有的表和数据不受影响',
    testFail: '连接失败',
    testOk: '连接成功 · ClickHouse {version} · 延迟 {ms} ms',
    testNoDatabase: '服务器上还没有数据库 {database}，勾选「保存时初始化表结构」即可创建',
    testMissing: '表结构缺少 {n} 项，勾选「保存时初始化表结构」即可补齐',
    testSchemaOk: '表结构完整',
    connSaved: '已切换到新的 ClickHouse 连接',
    savedNotConnected: '设置已保存，但暂时连不上：{error}。系统会在后台继续重试',
  },
  controlTLS: {
    title: '主控通信',
    intro: '为节点与主控之间的通信配置一个通信域名和 SSL 证书后，可以让节点改用 HTTPS 与主控通信。节点拉取的配置包里有所有站点的证书私钥，走明文 HTTP 时会在公网上被窥探。是否开启由你决定，默认关闭，关闭时与之前完全一样。前台和后台的访问域名在「主控域名」页面设置。',
    domainSection: '通信域名',
    domain: '通信域名',
    domainPlaceholder: '例如 ctl.example.com',
    domainHelp: '只用于节点连接主控，需要解析到主控服务器的 IP。申请证书时，证书颁发机构会访问 http://域名/.well-known/acme-challenge/ 来验证，主控的 80 端口必须能从公网访问。',
    port: '节点连接端口',
    portHelp: '节点通过 https://域名:端口 连接主控。主控在 18443 端口提供 HTTPS（docker-compose 已映射）；如果前面有端口转发，填对外的端口。',
    email: '证书联系邮箱',
    emailHelp: '证书颁发机构用于发送到期提醒；自动续期也使用这个邮箱。',
    ca: '证书颁发机构',
    unsavedDomain: '通信域名有改动，请先保存，再申请或上传证书',
    certSection: '证书',
    noCert: '还没有证书。可以免费申请，也可以上传已有的证书。',
    issue: '免费申请证书',
    reissue: '重新申请',
    upload: '上传证书',
    replace: '上传替换',
    remove: '删除证书',
    removeConfirm: '确定删除主控证书吗？删除后 HTTPS 端口将无法握手。',
    removeBlocked: '节点正在使用这张证书，请先把节点通信方式改为「关闭」再删除',
    removed: '证书已删除',
    issueQueued: '已提交申请，通常一分钟内完成，可以在「系统任务」中查看过程',
    issuing: '正在申请证书…',
    issueFailed: '证书申请失败',
    cancelIssue: '取消申请',
    issueCancelled: '已取消申请',
    nextRetry: '{time} 自动重试（第 {attempt}/{max} 次）',
    source: '来源',
    sourceAcme: '自动申请（到期前 30 天自动续期）',
    sourceUpload: '手动上传（需要自己在到期前替换）',
    names: '证书域名',
    issuer: '颁发者',
    validity: '有效期',
    daysLeft: '剩余 {days} 天',
    status: '状态',
    stateUsable: '可用',
    stateExpired: '已过期或尚未生效',
    stateMismatch: '证书不包含域名 {domain}',
    trust: '信任',
    trusted: '由公共 CA 签发，节点可以直接验证',
    untrusted: '不是公共 CA 签发的证书',
    untrustedHelp: '节点只信任公共 CA。使用私有 CA 时，需要在每个节点的 /etc/cdnx/agent.json 中设置 control_ca_file 指向该 CA 证书，否则节点会继续使用 HTTP 并在下方报告原因。',
    keyEncrypted: '证书私钥（包括所有站点的证书）已使用 AES-256-GCM 加密存储在数据库中。',
    keyPlain: '主控未配置 secrets.encryption_key（CDNX_SECRETS_ENCRYPTION_KEY），证书私钥以明文存储在数据库中。配置后重启主控，已有的私钥会被自动加密。',
    uploadTitle: '上传主控证书',
    certPem: '证书（PEM，含中间证书）',
    keyPem: '私钥（PEM）',
    uploaded: '证书已保存',
    modeSection: '节点通信方式',
    mode: '节点通信方式',
    modeOff: '关闭',
    modeOffHint: '节点继续使用安装时的地址（通常是 http://IP:18080）。',
    modePrefer: 'HTTPS 优先',
    modePreferHint: '节点测试 HTTPS 地址可用后自动切换；HTTPS 暂时连不上时临时回到安装地址，保证节点不失联。',
    modeRequire: '仅 HTTPS',
    modeRequireHint: '节点只用 HTTPS，不会回退；主控拒绝所有明文 HTTP 的节点请求。最安全，但主控证书失效会导致节点失联，需要确保证书能自动续期。',
    needCert: '需要先有一张对该域名有效的证书，才能开启 HTTPS',
    endpointNow: '节点当前收到的地址',
    endpointNone: '未下发（节点使用安装时的地址）',
    requireConfirmTitle: '仍有节点在使用 HTTP',
    requireConfirm: '{message}。开启「仅 HTTPS」后这些节点将无法连接主控，需要在节点上排查后手动恢复。确定开启吗？',
    requireConfirmOk: '仍然开启',
    nodesSection: '节点状态',
    nodesIntro: '每个节点最近一次心跳使用的通信方式。切换在节点收到新配置后几秒内完成。',
    nodesSummary: '共 {total} 个节点：HTTPS {https} 个，HTTP {http} 个',
    colNode: '节点',
    colTransport: '通信方式',
    colOnline: '在线',
    colProblem: '问题',
    transportUnknown: '未知',
    online: '在线',
    offline: '离线',
    recoverHint: '「仅 HTTPS」下节点失联时，可以在节点上执行 rm /var/lib/cdnx/control-endpoint.json && systemctl restart cdnx-agent，让节点回到安装地址重新拉取配置。',
    saved: '已保存',
    saveFailed: '保存失败',
  },
  firewall: {
    title: '防火墙',
    intro: '设置节点防火墙（nftables）对被内核级封禁的 IP 丢弃哪些流量。保存后自动发布到所有节点，节点收到配置后立即重建防火墙规则，已有的封禁条目不受影响。',
    scopeSection: '内核封禁范围',
    scope: '封禁范围',
    scopePorts: '指定端口（推荐）',
    scopePortsHint: '只丢弃被封 IP 访问这些端口的流量',
    scopeAll: '全部端口',
    scopeAllHint: '丢弃被封 IP 的全部流量，放行端口除外',
    tcpPorts: 'TCP 端口',
    udpPorts: 'UDP 端口',
    portsHelp: '节点的 HTTP/HTTPS 服务监听在 80 和 443。',
    udpHelp: 'UDP 443 对应 HTTP/3（QUIC）。',
    exemptTcp: '始终放行的 TCP 端口',
    exemptUdp: '始终放行的 UDP 端口',
    exemptHelp: '这些端口不受封禁影响，通常填 SSH 端口，避免误封后无法登录节点。',
    portsPlaceholder: '输入端口或范围后回车，如 443、8000-8100',
    summaryPorts: '被封禁的 IP 访问 {ports} 的流量会在内核直接丢弃，访问其他端口不受影响。',
    summaryAll: '被封禁的 IP 发往本节点的所有流量都会在内核直接丢弃，{exempt} 除外。',
    summaryAllNoExempt: '被封禁的 IP 发往本节点的所有流量都会在内核直接丢弃，没有任何例外。',
    invalidPorts: '这些不是有效的端口或端口范围：{ports}。端口范围是 1-65535，范围写作 8000-8100。',
    noPorts: '指定端口模式下至少要填一个端口，否则内核封禁不会拦截任何流量。',
    warnEdgePorts: '没有包含 TCP 80 和 443：被封禁的 IP 仍然可以访问节点上的站点。',
    warnAllPorts: '全部端口模式会丢弃被封 IP 发来的任何数据包，包括节点主动连接对方时的回包：如果被封的恰好是某个源站或 DNS 服务器的地址，节点将无法回源或解析域名。主控地址会自动放行，不受影响。',
    warnNoSsh: '没有放行 TCP 22：被封禁的 IP 将无法 SSH 登录节点。如果 SSH 用的是其他端口，请填写实际端口。',
    sync: '全网联动封禁',
    syncHelp: '一台节点在内核封禁的 IP，几秒内同步到其他所有节点，封禁剩余时长不变。在封禁日志里解封时，所有节点一起解封。',
    trustSection: '始终放行',
    trustControl: '主控地址',
    trustControlDesc: '节点自动解析主控地址并加入信任列表，任何封禁都不会切断节点与主控的连接。',
    trustLoopback: '本机回环',
    trustLoopbackDesc: '节点访问自身的流量（例如缓存预热）始终放行。',
    trustOps: '运维 / 办公 IP',
    trustOpsDesc: '加入 IP 名单的白名单即可，白名单会同时写入每台节点的内核放行列表。',
    trustOpsLink: '前往 IP 名单',
    blockSection: '拉黑方式',
    blockMode: '默认拉黑方式',
    blockPage: '返回拉黑页面',
    blockPageHint: '页面内容在「系统管理 → 默认页面 → 拉黑页面」中设置',
    blockDrop: '丢弃连接',
    blockDropHint: '直接断开，不返回任何内容（444）',
    blockKernel: '内核级封禁',
    blockKernelHint: '交给节点防火墙，之后的数据包在内核里直接丢弃，最省资源',
    kernelBan: '内核封禁时长',
    kernelBanHelp: '内核级封禁、以及下面两个条件自动转内核时，封禁持续的时间。可以在「封禁日志」中提前解封。',
    escalate: '单 IP 自动转内核',
    escalateHelp: '同一个 IP 在周期内被拉黑拦截的次数超过设定值，转为内核级封禁：一直撞墙的地址没必要每次都在边缘处理。',
    blockedOver: '拉黑超过',
    surge: '遭受攻击时自动转内核',
    surgeHelp: '整个节点每秒被拉黑的请求超过设定值时，在接下来的时间里，所有被拉黑的 IP 都直接转内核级封禁，不再逐个在边缘处理。',
    perSecondOver: '每秒超过',
    lasting: '持续',
    blockScopeNote: '这里的「拉黑」指平台黑名单和节点上的临时封禁（CC 封禁、验证失败封禁等）。客户自己设置的黑名单只对他的站点生效，而内核级封禁会作用于整台节点上的所有站点，所以客户黑名单只会返回拉黑页面或丢弃连接，不会转内核。',
    guardSection: '节点防护',
    guardIntro: '在请求到达任何站点之前，按来源 IP 计数。超过限制的 IP 会被内核封禁，可以在「封禁日志」中查看和解封。平台白名单中的地址不受这些限制。',
    guardBanLogs: '查看封禁日志',
    limit_conn_rate: '连接速率限制',
    limit_conn_rate_help: '单个 IP 新建的 TCP 连接数（80 与 443 合计），在 TLS 握手之前统计。每个 HTTPS 连接对应一次握手，所以这也是 TLS 握手洪水的限制。被封的 IP 在握手前就会被断开。',
    limit_tls_fail: 'TLS 握手失败',
    limit_tls_fail_help: '不带 SNI（直接用 IP 访问 HTTPS）、SNI 不是平台上的域名、发送非 TLS 数据、握手中途断开，都计为一次失败。这类握手本身始终直接失败，不会出示任何证书。',
    limit_error_pages: '默认页面触发次数',
    limit_error_pages_help: '单个 IP 被回应默认页面的次数：403、WAF 拦截、区域屏蔽、请求数超限、400、域名未绑定、节点 IP 访问（选了直接断开也算）。拉黑的次数由上面的「拉黑方式」单独处理。同一 IP 频繁触发通常是在扫描或攻击，超过次数后封禁。源站故障（502/504/500）、连接数超限和站点暂停的页面不计入——那是网站的问题，不是访问者的。',
    openDefaultPages: '设置默认页面',
    windowPrefix: '周期',
    secondsSuffix: '秒',
    thresholdPrefix: '超过',
    timesSuffix: '次',
    banPrefix: '封禁',
    minutesSuffix: '分钟',
    handshake: '握手速率上限',
    handshakeHelp: '整个节点每秒接受的新连接数上限，对付来自大量不同 IP 的握手洪水（单个 IP 的限制看不出这种攻击）。超过上限时，最近访问过的正常访客照常放行，新出现的地址在这一秒内被拒绝。「固定上限」为 0 时按「每核」乘以节点的 CPU 核数自动计算，各节点按自己的核数算。新签发的免费证书已改用 ECDSA，握手开销约为 RSA 的十分之一。',
    handshakePerCore: '每核',
    handshakeFixed: '固定上限（0=按核数）',
    handshakeKnown: '访客记忆',
    perSecondSuffix: '次/秒',
    crossSite: '跨站请求拦截',
    crossSiteHelp: 'HTTPS 连接的 SNI 是一个客户的域名，请求的 Host 却是另一个客户的站点时（域前置），返回 421。同一客户的站点之间不受影响：浏览器会在证书覆盖的多个域名之间复用连接。',
    resetDefaults: '恢复默认设置',
    saved: '已保存，正在发布到所有节点',
    saveFailed: '保存失败',
    confirmAllTitle: '切换为全部端口封禁？',
    confirmAll: '被封禁的 IP 发往节点的所有流量都会被丢弃（放行端口除外），包括源站和 DNS 服务器的回包。确定发布到所有节点吗？',
    confirmAllNoSsh: '没有放行 SSH 端口：一旦误封你自己的 IP，将无法 SSH 登录节点。被封禁的 IP 发往节点的所有流量都会被丢弃，包括源站和 DNS 服务器的回包。确定发布到所有节点吗？',
    confirmAllOk: '确定发布',
  },
  ipLists: {
    title: 'IP 名单',
    introAdmin: '全系统黑白名单，对所有节点上的所有站点生效。',
    introUser: '账号级黑白名单。这里的条目对您名下所有站点生效。',
    searchPlaceholder: '搜索地址或备注',
    checkEmpty: '不能为空',
    checkBadAddress: '不是有效的 IP 地址',
    checkBadCidr: '网段格式不正确',
    checkTooBroad: '/{bits} 太宽，最小 /{min}',
    checkDuplicate: '与上面重复',
    problemsHead: '有 {n} 处需要修改，修改后才能提交：',
    lineNo: '第 {n} 行',
    fixProblemsFirst: '请先修正标出的问题',
    batchAddedSkipped: '已添加 {n} 条，{s} 条已存在已跳过',
    modeSingle: '单个',
    modeBatch: '批量',
    bulkPlaceholder: '一行一个，例如：\n1.2.3.4\n10.0.0.0/8\n2001:db8::/32',
    bulkHelp: '已识别 {n} 条，单次最多 {max} 条。逗号分隔也可以。',
    batchAdded: '已添加 {n} 条',
    addDeny: '添加黑名单',
    addAllow: '添加白名单',
    targetRequired: '请填写 IP 或网段',
    noMatch: '没有匹配的记录',
    empty: '暂无记录',
    tabDeny: '黑名单',
    tabAllow: '白名单',
    enforceKernel: '内核级封禁',
    enforceEdge: '普通封禁',
    enforcementCol: '封禁方式',
    enforcementNote: '内核级封禁在 nftables 里直接丢包，攻击流量不消耗节点的 TLS 握手和 CPU，但对整个节点生效（内核不知道包是发给哪个站点的）。只拦截访问 80/443 端口的流量，SSH 和节点与主控的通信不受影响。普通封禁在边缘拒绝，请求仍要走完握手。',
    userKernelHint: '账号级黑名单只能是普通封禁：内核丢包对整台节点生效，会影响到节点上其他客户。',
    tabAuto: '自动封禁',
    allowNote: '白名单优先级最高：命中白名单的地址不会被任何黑名单、CC 封禁、WAF 或人机验证拦下。适合用于监控探测、支付回调这类不能误伤的来源。',
    autoNote: 'CC 防护自动封禁的地址，已下发到节点内核并带有效期。到期内核会自己清除；提前解封会同时下发一个任务通知对应节点移除。',
    activeOnly: '只看生效中',
    add: '添加',
    added: '已添加',
    addFailed: '添加失败',
    targetPlaceholder: 'IP 或网段，如 1.2.3.4 或 10.0.0.0/8',
    notePlaceholder: '备注（可选）',
    targetCol: '地址',
    noteCol: '备注',
    addedCol: '添加时间',
    ipCol: 'IP',
    nodeCol: '节点',
    domainCol: '域名',
    ruleCol: '触发规则',
    bannedAtCol: '封禁时间',
    expiresCol: '到期时间',
    release: '解封',
    released: '已解封',
    releaseQueued: '已解封，正在通知节点移除',
    releaseRecorded: '已记录解封，但未能通知节点，内核封禁将在到期后自动清除',
    releaseFailed: '解封失败',
    confirmDeleteTitle: '删除这条记录？',
    confirmDelete: '将从名单中移除 {target}，配置会重新下发到节点。',
    statTotal: '名单条目',
    statCap: '上限 {n} 条',
    statKernel: '内核级 {n} 条',
    statToday: '今日新增',
    listCount: '共 {n} 条',
    typeCol: '类型',
    typeIp: 'IP',
    typeCidr: '网段',
    denyHint: '内核级封禁在 nftables 里直接丢包、不消耗握手，对整台节点的 80/443 生效；普通封禁由边缘拒绝请求。',
    filterAllLevels: '全部封禁方式',
  },
  cacheJobs: {
    targetsCount: '{n} 条',
    progress: '{done}/{total} 个节点',
    historyCount: '共 {n} 条',
    section: '缓存刷新',
    intro: '刷新会让节点丢弃已缓存的内容，下次访问重新回源；预热则提前把内容拉到节点，让首次访问就命中。任务会下发到所有节点，某个节点离线时任务会排队，等它回来再执行。',
    kind: '类型',
    sectionPurge: '缓存刷新',
    sectionPrefetch: '缓存预热',
    prefetchIntro: '提前把内容拉到各节点，让首次访问就命中缓存。适合在版本发布或活动开始前把新资源预先铺开。',
    modeNow: '即时预热',
    modeScheduled: '定时预热',
    scheduledAt: '执行时间',
    scheduledHint: '任务会在这个时间自动下发到所有节点，最多可提前 30 天安排。',
    scheduledRequired: '请选择执行时间',
    prefetchHistory: '预热记录',
    purgeHistory: '刷新记录',
    status_scheduled: '等待执行',
    scheduledFor: '计划于 {t}',
    emptyPrefetch: '暂无预热任务',
    kindPurgeUrl: '刷新 URL',
    kindPurgeDir: '刷新目录',
    kindPurgeAll: '刷新全站',
    kindPrefetch: '预热 URL',
    kind_purge_url: '刷新 URL',
    kind_purge_dir: '刷新目录',
    kind_purge_all: '刷新全站',
    kind_prefetch: '预热',
    targets: '目标',
    targetsPlaceholder: '一行一个，例如：\n/index.html\n/assets/app.js\nhttps://example.com/logo.png',
    targetsDirPlaceholder: '一行一个目录，例如：\n/assets/\n/static/img/',
    targetsHelp: '已识别 {n} 条，单次最多 1000 条。可以填路径或完整 URL，URL 的域名必须是本站点。',
    purgeAllWarning: '将丢弃本站点在所有节点上的全部缓存。之后一段时间内所有请求都会回源，源站负载会明显上升，请避开业务高峰。',
    submit: '提交',
    scheduledOk: '已排期，到时间会自动下发到各节点',
    submitted: '已提交，正在下发到各节点',
    submitFailed: '提交失败',
    history: '任务记录',
    nodes: '节点进度',
    failedN: '{n} 失败',
    status_pending: '等待中',
    status_running: '执行中',
    status_done: '已完成',
    status_failed: '部分失败',
    createdAt: '提交时间',
    wholeSite: '（全站）',
    empty: '暂无任务',
  },
  audit: {
    title: '审计日志',
    intro: '所有控制台操作 + Agent / Open API 的写操作都会被记录。',
    timeCol: '时间',
    actorTypeCol: '主体',
    actorCol: '账号',
    actionCol: '动作',
    resourceCol: '对象',
    ipCol: 'IP',
    detailCol: '详情',
    filterActorType: '主体类型',
    filterResourceType: '对象类型',
    filterAction: '动作',
    filterRange: '时间范围',
    actorUser: '用户',
    actorSystem: '系统',
    actorAgent: 'Agent',
    actorApiKey: 'API Key',
    refresh: '刷新',
    detailModalTitle: '操作详情',
    before: '修改前',
    after: '修改后',
    empty: '当前条件下没有审计记录',
  },
  license: {
    title: '系统授权',
    sectionTitle: '授权信息',
    stateNone: '未激活',
    stateActive: '已授权',
    stateExpired: '已过期',
    stateRefused: '已停用',
    stateDev: '开发构建',
    stateOverdue: '续期逾期',
    noneTitle: '主控还没有激活授权',
    noneBody: '授权只能从授权站取得：在下方输入授权码激活。激活前用户控制台只能查看、不能修改，也不能添加节点和站点；管理后台不受影响。',
    expiredTitle: '授权已过期',
    expiredBody: '租约或合同期已结束，用户控制台只能查看、不能修改。授权站可以访问时会自动续期；合同期已结束的，请在授权站续费后点「立即续期」。',
    refusedTitle: '授权站拒绝续期',
    refusedBody: '{reason}。用户控制台已变为只读。授权站恢复这份授权后，主控每小时重试一次，会自动恢复。',
    devTitle: '开发构建',
    devBody: '这个程序没有内置授权公钥（不是正式发布的版本），不校验授权，也不做任何限制。正式版本由发布流程构建。',
    overdueTitle: '授权已经很久没有续期',
    overdueBody: '租期已过半仍没有续上，到 {at} 还续不上，用户控制台会变为只读。上次失败原因：{reason}',
    licenseId: '授权编号',
    issuedTo: '授权对象',
    edition: '授权版本',
    kind: '授权方式',
    kindOnline: '在线（自动续期）',
    kindOffline: '离线授权文件',
    termEndsAt: '授权到期',
    leaseEndsAt: '租约到期',
    noLease: '离线授权没有租约',
    nodesLimit: '节点上限',
    domainsLimit: '站点上限',
    unlimited: '不限',
    renewedAt: '上次续期',
    nextTry: '下次续期',
    never: '尚未续期',
    channel: '更新渠道',
    channel_stable: '稳定版',
    channel_beta: '测试版',
    features: '授权功能',
    feature_waf: 'WAF',
    feature_cc: 'CC 防护',
    feature_cache: '缓存加速',
    renewNow: '立即续期',
    renewed: '已续期',
    instanceTitle: '本实例',
    instanceIntro: '授权站按实例 ID 识别这台主控。实例密钥在主控的状态卷里，首次启动时生成；重装或换机后实例 ID 会变，需要重新激活。授权站的实例列表里也显示实例 ID 和机器指纹，可以和这里对照；签发离线授权时，在授权站填写这里的实例 ID。',
    instanceId: '实例 ID',
    fingerprint: '机器指纹',
    portal: '授权站',
    release: '释放实例',
    releaseTitle: '释放这台主控的授权？',
    releaseBody: '授权站会收回这台主控占用的实例名额，主控立即变为未激活：用户控制台只能查看，不能添加节点和站点。用于把授权换到另一台主控。',
    releaseOk: '释放',
    released: '已释放，这台主控现在未激活',
    activateTitle: '激活授权',
    activateAnother: '更换授权',
    activateIntro: '在授权站的控制台里找到授权码。主控用实例密钥签名后向授权站激活，取回绑定本实例的授权、租约和版本仓库的下载令牌。',
    code: '授权码',
    codeHelp: '格式为 CDNX-XXXX-XXXX-XXXX-XXXX，大小写均可',
    activate: '激活',
    activated: '已激活授权 {id}',
    offlineTitle: '离线授权文件',
    offlineIntro: '主控无法访问授权站时使用：在授权站为本实例 ID 签发离线授权，下载 .cdnx 文件后上传到这里。离线授权不会自动续期，到期前需要重新签发。',
    offlineUpload: '上传授权文件',
    uploaded: '已安装离线授权 {id}',
  },
  dashboard: {
    welcome: '欢迎回来，{name}',
    sites: '站点数量',
    nodes: '节点数量',
    users: '用户数量',
    subscriptions: '套餐数量',
    unitSites: '个',
    unitNodes: '台',
    unitUsers: '位',
    unitSubs: '份',
    unitCurrency: '元',
    today: '今日',
    recharge: '累计充值',
    certs: 'SSL 证书',
    unitCerts: '张',
    certsDue: '{n} 张待续期',
    nodesLost: '{n} 台失联',
    trend: '增长趋势',
    trendTotal: '近 {days} 天 · 共 {n} {unit}',
    metric_sites: '站点',
    metric_users: '用户',
    metric_subscriptions: '套餐',
    series_sites: '新增站点',
    series_users: '新增用户',
    series_subscriptions: '新售套餐',
    last7: '近 7 天',
    last30: '近 30 天',
    viewMore: '查看更多',
    topSites: 'TOP10 数据',
    topUnavailable: '未配置日志存储（ClickHouse），无法统计站点访问排行',
    siteStatus: '站点状态',
    siteActive: '正常',
    siteDraft: '配置中',
    siteSuspended: '已暂停',
    siteDisabled: '已禁用',
    certStatus: '证书状态',
    certValid: '有效',
    certExpiring: '即将到期',
    certExpired: '已过期',
    subStatus: '套餐状态',
    subsSold: '已售套餐',
    subActive: '正常',
    subExpiring: '即将到期',
    subExpired: '已过期',
    subCancelled: '已取消',
    quick: '快捷操作',
    attention: '待处理',
    allClear: '一切正常，没有需要处理的事项',
    tag_node: '节点',
    tag_cert: '证书',
    tag_site: '站点',
    tag_sub: '套餐',
    tag_task: '任务',
    lostNodes: '{n} 台节点失联（5 分钟无心跳）',
    servingAlerts: '{n} 台节点服务异常',
    pendingNodes: '{n} 台节点待初始化',
    certsExpired: '{n} 张证书已过期',
    certsExpiring: '{n} 张证书 14 天内到期',
    sitesSuspended: '{n} 个站点已暂停',
    sitesDraft: '{n} 个站点 CNAME 未生效',
    subsExpiring: '{n} 份套餐 7 天内到期',
    tasksFailed: '{n} 个任务近 24 小时失败',
    tag_ticket: '工单',
    ticketsOpen: '{n} 个工单待处理',
    tag_license: '授权',
    licenseNone: '主控还没有激活授权',
    licenseExpired: '授权已过期，用户控制台只读',
    licenseRefused: '授权站拒绝续期，用户控制台只读',
    licenseOverdue: '授权租期过半仍未续期',
  },
  layout: {
    navbarHeight: '导航栏高度',
    menuWidth: '菜单宽度',
    colorWeak: '色弱模式',
    grayscale: '灰色模式',
  },
  custom: {
    notify: '消息提醒',
    sound: '新消息提示音',
    soundDesc: '工单收到新回复时播放提示音',
    speech: '语音播报',
    speechDesc: '收到新回复时朗读“您有一条新的工单消息”',
    title: '自定义设置',
    theme: '主题',
    theme_light: '浅色模式',
    theme_dark: '深色模式',
    theme_twotone: '双色模式',
    navbar: '顶部导航',
    navbar_on: '显示导航栏',
    navbar_onDesc: '顶部显示搜索、消息通知与账号',
    navbar_off: '隐藏导航栏',
    navbar_offDesc: '内容区更大，从右下角按钮打开本设置',
    menu: '侧边菜单',
    menu_on: '显示菜单',
    menu_onDesc: '在页面左侧显示导航菜单',
    menu_off: '隐藏菜单',
    menu_offDesc: '隐藏左侧菜单，内容占满宽度',
    pageTitle: '页面标题',
    pageTitle_on: '显示页面标题',
    pageTitle_onDesc: '在内容区顶部显示当前页面名称',
    pageTitle_off: '隐藏页面标题',
    pageTitle_offDesc: '不显示页面名称，内容更紧凑',
    access: '辅助功能',
    fullscreenDesc: '控制台占满整个屏幕，按 Esc 退出',
    colorWeakDesc: '反转色彩，便于色弱用户分辨',
    grayscaleDesc: '以灰度显示整个控制台',
    reset: '恢复默认设置',
  },
  skin: {
    ultra: '极致蓝',
    tech: '科技蓝',
    sea: '海蔚蓝',
    haze: '雾霾蓝',
    starry: '星空紫',
    night: '暗夜紫',
    youth: '青春紫',
    magenta: '品红',
    romantic: '浪漫红',
    china: '中国红',
    autumn: '晚秋红',
    vibrant: '活力橙',
    dusk: '黄昏',
    meadow: '仙野绿',
    forest: '墨绿',
    turquoise: '松石绿',
    wave: '碧涛青',
    slate: '石板灰',
    custom: '自定义颜色',
    inUse: '当前使用',
  },
  monitor: {
    title: '监控趋势',
    bandwidth: '峰值带宽',
    requests: '请求数',
    traffic: '流量',
    bans: '拉黑次数',
    banIps: '拉黑 IP 数',
    hits: '缓存命中',
    range_1h: '1 小时',
    range_today: '今日',
    range_yesterday: '昨日',
    range_7d: '7 天',
    range_30d: '30 天',
    window_1h: '近 1 小时',
    window_today: '今日',
    window_yesterday: '昨日',
    window_7d: '近 7 天',
    window_30d: '近 30 天',
    vs_1h: '较上一小时',
    vs_today: '较昨日同时段',
    vs_yesterday: '较前日',
    vs_7d: '较前 7 天',
    vs_30d: '较前 30 天',
    unitTimes: '次',
    unitIps: '个',
    loadFailed: '监控数据加载失败',
    noLogs: '未配置日志存储（ClickHouse），无法统计带宽、请求数、流量和缓存命中',
  },
  top: {
    dim_domain: '域名',
    dim_url: 'URL',
    dim_ip: 'IP',
    dim_country: '国家',
    dim_status: '状态码',
    dim_isp: '运营商',
    dim_referer: '来源',
    dim_node: '节点',
    direct: '直接访问',
    nodeId: '节点 #{id}',
    unknown: '未知',
    requests: '请求',
    traffic: '流量',
  },
  nodePanel: {
    title: '节点概况',
    summary: '{online} / {total} 在线',
    justNow: '刚刚',
    secondsAgo: '{n} 秒前',
    minutesAgo: '{n} 分钟前',
    hoursAgo: '{n} 小时前',
    daysAgo: '{n} 天前',
    lost: '失联',
    cpu: 'CPU',
    mem: '内存',
    tx: '出口',
    empty: '还没有节点。',
    add: '添加节点',
  },
  stats: {
    title: '数据统计',
    hostnames: '域名总数',
    l4Forwards: '应用加速',
    lineGroups: '线路组',
    nodeIps: '节点 IP',
    denyIps: 'IP 黑名单',
    allowIps: 'IP 白名单',
    activeBans: '当前封禁',
    pendingTasks: '待执行任务',
    unitItems: '个',
    unitRules: '条',
    unitEntries: '条',
  },
  licenseCard: {
    title: '系统授权',
    paid: '正式版',
    edition_trial: '试用版',
    edition_standard: '标准版',
    edition_enterprise: '企业版',
    expired: '已过期',
    nodes: '授权节点',
    sites: '授权站点',
    unlimited: '不限',
    expiresAt: '到期时间',
    daysLeft: '剩 {n} 天',
    dueToday: '今日到期',
    expiredShort: '已到期',
    holder: '授权对象',
    readOnly: '授权已过期：用户控制台只能查看、不能修改（管理后台不受影响），续期后恢复',
    unavailable: '无法读取授权信息',
    none: '未激活',
    noneBody: '主控还没有激活授权：用户控制台只能查看，不能添加节点和站点。',
    activate: '去激活',
    refused: '已停用',
    refusedBody: '授权站拒绝续期：用户控制台只能查看、不能修改。',
    dev: '开发构建',
    overdue: '续期逾期',
  },
  // 工单管理.
  tickets: {
    vipFirstTip: 'VIP{n} 客户 · 工单优先',
    confidential: '保密发送',
    confidentialHelp: '用于发送密码、密钥等敏感信息：消息默认打码显示，不会出现在邮件和站内信里；工单关闭时内容和附件会被销毁。',
    confidentialNoClose: '保密消息会在工单关闭时销毁，不能和关闭工单一起发送',
    title: '工单列表',
    detailTitle: '工单详情',
    unit: '个',
    statOpen: '待处理',
    statProcessing: '处理中',
    statReplied: '待客户回复',
    statRating: '满意度',
    ratingUnit: '分 · {n} 条评价',
    listTitle: '工单',
    count: '共 {n} 个',
    searchPlaceholder: '搜索问题描述或工单编号',
    filter_active: '未关闭',
    filter_open: '待处理',
    filter_processing: '处理中',
    filter_replied: '待客户回复',
    filter_closed: '已关闭',
    filter_all: '全部状态',
    allAssignees: '全部处理人',
    mine: '我负责的（{n}）',
    unassigned: '未分配（{n}）',
    allCategories: '全部分类',
    allPriorities: '全部优先级',
    noMatch: '没有符合条件的工单',
    empty: '还没有工单',
    nobody: '未分配',
    handle: '处理',
    colTicket: '工单',
    colNo: '工单编号',
    colPriority: '优先级',
    colAssignee: '处理人',
    colUpdated: '最近更新',
    status_open: '待处理',
    status_processing: '处理中',
    status_replied: '待客户回复',
    status_closed: '已关闭',
    priority_normal: '一般',
    priority_high: '较高',
    priority_urgent: '紧急',
    missing: '工单不存在',
    toList: '返回工单列表',
    category: '问题分类',
    site: '相关站点',
    filedAt: '提交时间',
    accept: '受理工单',
    accepted: '已受理，客户会看到工单处理中',
    closeTicket: '关闭工单',
    closeTitle: '关闭工单',
    closeContent: '确定关闭工单「{title}」吗？关闭后客户不能再回复，但可以对本次服务进行评价。',
    close: '关闭',
    closedDone: '工单已关闭',
    modeReply: '回复客户',
    modeNote: '内部备注',
    insertTemplate: '插入快捷回复',
    manageTemplates: '管理快捷回复',
    closedNoteOnly: '工单已关闭，只能添加内部备注。',
    replyPlaceholder: '回复客户，图片支持粘贴及拖拽；Ctrl / ⌘ + Enter 发送',
    notePlaceholder: '内部备注仅客服可见，客户看不到；Ctrl / ⌘ + Enter 添加',
    send: '发送回复',
    sendClose: '发送并关闭',
    addNote: '添加备注',
    bodyRequired: '请填写内容',
    replied: '回复已发送',
    repliedClosed: '回复已发送，工单已关闭',
    noted: '备注已添加',
    handling: '处理',
    takeIt: '分配给我',
    meTag: '（我）',
    priority: '优先级',
    assigned: '已分配给 {name}',
    unassignedDone: '已取消分配',
    prioritySet: '优先级已改为「{priority}」',
    customerTitle: '客户信息',
    username: '用户名',
    email: '邮箱',
    phone: '手机',
    realname: '实名认证',
    account: '账号状态',
    allOfCustomer: '查看该客户的全部工单',
    infoTitle: '相关信息',
    staffReplyAt: '最近回复',
    closedAt: '关闭时间',
    closedBy_customer: '客户关闭',
    closedBy_staff: '客服关闭',
    closedBy_auto: '超时自动关闭',
    rating: '服务评价',
    notRated: '客户未评价',
  },
  ticketTemplates: {
    title: '快捷回复',
    count: '共 {n} 条，最多 {max} 条',
    add: '新建快捷回复',
    editTitle: '编辑快捷回复',
    intro: '处理工单时可以一键插入回复框。内容中的 {u} 会替换为客户的用户名，{n} 会替换为工单编号。',
    empty: '还没有快捷回复',
    colTitle: '名称',
    colBody: '回复内容',
    colUpdated: '更新时间',
    titlePlaceholder: '例如：请提供源站信息',
    bodyHelp: '{u}：客户的用户名；{n}：工单编号。插入时自动替换。',
    bodyPlaceholder: '您好 {u}，……',
    saved: '快捷回复已保存',
    added: '快捷回复已添加',
    deleteTitle: '删除快捷回复',
    deleteContent: '确定删除快捷回复「{title}」吗？',
    deleted: '已删除',
  },
  ticketSettings: {
    title: '工单设置',
    filingTitle: '在线提交工单',
    filingIntro: '关闭后，客户不能再提交新工单；已提交的工单仍可查看和回复。',
    notice: '提交须知',
    noticeHelp: '显示在客户提交工单页面的顶部，例如客服的服务时间、紧急问题的联系方式。',
    noticePlaceholder: '例如：工单受理时间为每天 9:00–21:00，紧急问题请拨打 400-000-0000',
    supportTitle: '客服名称',
    supportIntro: '客户在工单对话和服务助手消息中看到的客服称呼，中英文界面分别设置。邮件和站内信的文案请在消息模板中修改。',
    supportName: '中文名称',
    supportNameHelp: '中文界面使用，留空显示「客服」。',
    supportNameEn: '英文名称',
    supportNameEnHelp: '英文界面使用，留空显示「Support」。',
    categoriesTitle: '问题分类',
    categoriesCount: '启用 {on} 个，共 {n} 个，最多 {max} 个',
    categoriesIntro: '客户提交工单时从中选择，按这里的顺序排列。不再使用的分类建议停用：停用后不会出现在提交页面，已有工单仍显示原名称。',
    colNo: '序号',
    colName: '名称',
    colEnabled: '启用',
    categoryPlaceholder: '分类名称，最多 20 个字',
    moveUp: '上移',
    moveDown: '下移',
    addCategory: '添加分类',
    autoCloseTitle: '自动关闭',
    autoCloseIntro: '客服回复后，如果客户在设定的天数内没有再回复，工单会自动关闭，并通知客户。',
    autoCloseDays: '等待客户回复',
    autoCloseHelp: '0 到 90 天，设为 0 表示不自动关闭。',
    days: '天',
    notifyTitle: '通知',
    notifyIntro: '站内提醒始终开启：有新回复时，客户和客服的菜单与右上角消息通知都会提醒。邮件通知需要先配置邮件服务。',
    mailNotReady: '邮件服务尚未配置，邮件通知不会发送。',
    mailReady: '邮件服务已启用，通知从 {from} 发出。',
    toMail: '邮件服务设置',
    notifyCustomer: '邮件通知客户',
    notifyCustomerHelp: '客服回复或关闭工单时，发邮件到客户账号的邮箱。',
    notifyStaff: '邮件通知客服',
    notifyStaffHelp: '有新工单或客户回复时，发邮件给工单的处理人；还没有处理人的工单，发给下面的通知邮箱。',
    staffEmails: '客服通知邮箱',
    staffEmailsHelp: '未分配的工单通知这些邮箱，最多 {max} 个。',
    staffEmailsPlaceholder: '输入邮箱后按回车',
    saved: '工单设置已保存',
  },
  assistantSettings: {
    animated: '动态效果',
    animatedHelp: '开启后图标带轻微动画：星芒闪烁、风车转动，云宝等吉祥物的眼睛会跟着鼠标看并时不时眨眼；回答生成中动画会加快。客户系统设置了「减少动态效果」时不播放。',
    icon: '图标',
    icon_bubble: '泡泡',
    icon_cloud: '云宝',
    icon_cube: '方糖',
    icon_orb: '小球',
    icon_pinwheel: '风车',
    icon_spark: '星芒',
    iconHelp: '用户控制台里助手按钮、面板标题和欢迎语使用的图标。',
    inputGlow: '输入框边框流光',
    inputGlowHelp: '输入框边框上有一道彩色光带循环流动。客户系统设置了「减少动态效果」时只显示静态彩色边框。',
    inputHints: '输入框提示词轮播',
    inputHintsHelp: '输入框为空时，推荐问题会在框内轮流滚动显示，客户直接按回车或点发送即可提问当前这一条。',
    launcher: '悬浮按钮样式',
    launcher_capsule: '竖向胶囊',
    launcher_circle: '圆形',
    launcherHelp: '竖向胶囊在图标下方竖排显示助手名称。',
    navLabel: '菜单栏显示名称',
    navLabelHelp: '开启时顶部菜单栏显示「图标 + 名称」，关闭则只显示图标，鼠标移上去显示名称。手机上始终只显示图标。',
    placement: '显示位置',
    placement_both: '两处都显示',
    placement_float: '右下角',
    placement_navbar: '顶部菜单栏',
    placementHelp_both: '右下角悬浮按钮和顶部菜单栏入口同时显示，打开的是同一个面板。',
    placementHelp_float: '在页面右下角显示悬浮按钮，面板从右下角打开。',
    placementHelp_navbar: '在顶部菜单栏搜索框右侧显示入口，面板在菜单栏下方打开。',
    title: 'AI 助手',
    mainTitle: 'AI 助手',
    mainIntro: '开启后，用户控制台会出现 AI 助手（位置见下方「显示位置」），客户可以就站点接入、故障排查、套餐与费用等问题提问。回答由下方配置的大模型生成。',
    stateOff: '未开启',
    stateReady: '已生效',
    stateIncomplete: '配置不完整',
    name: '中文名称',
    nameHelp: '中文界面的助手标题和问候语，留空显示「智能助手」。',
    nameEn: '英文名称',
    nameEnHelp: '英文界面使用，留空显示「AI Assistant」。',
    modelTitle: '模型',
    modelIntro: '支持兼容 OpenAI Chat Completions 接口的大模型服务，默认对接 DeepSeek。选择服务商会自动填入 API 地址和推荐模型。',
    provider: '服务商',
    provider_deepseek: 'DeepSeek',
    provider_qwen: '通义千问',
    provider_ark: '火山方舟',
    provider_openai: 'OpenAI',
    provider_custom: '自定义',
    baseUrl: 'API 地址',
    baseUrlHelp: '请求发往「API 地址/chat/completions」。',
    model: '模型',
    modelHelp_deepseek: 'deepseek-chat 回答快；deepseek-reasoner 会先推理再回答，更慢也更贵。',
    modelHelp_qwen: '例如 qwen-plus、qwen-max。',
    modelHelp_ark: '填写方舟控制台里的推理接入点 ID（ep- 开头）或模型名称。',
    modelHelp_openai: '例如 gpt-4o-mini、gpt-4o。',
    modelHelp_custom: '填写服务商提供的模型名称。',
    apiKey: 'API Key',
    keyHelp: '加密保存，保存后不再显示。',
    keyKept: '已保存，留空则保持不变。',
    keyAgain: 'API 地址已修改，请重新填写 API Key。原密钥不会发往新的地址。',
    keySet: '已设置，留空不修改',
    temperature: '温度',
    temperatureHelp: '0 到 2，越低回答越稳定，越高越发散。客服场景建议 0.3 到 0.8。',
    maxTokens: '单次回答上限',
    maxTokensHelp: '256 到 8192 tokens，超出后回答会被截断。',
    answerTitle: '回答方式',
    answerIntro: '控制助手能看到什么、每位客户能问多少次，以及补充给模型的说明。',
    accountContext: '读取客户账户信息',
    accountContextHelp: '开启后，每次提问会把该客户自己的站点及状态、套餐到期时间、余额和工单数量一并发给模型服务商，以便回答「我的站点为什么暂停了」这类问题。不会发送密钥、手机号或邮箱。',
    dailyLimit: '每人每日提问次数',
    dailyLimitHelp: '按北京时间零点重置，0 表示不限。',
    unitTimes: '次',
    prompt: '补充说明',
    promptHelp: '附加在平台内置说明之后，例如客服联系方式、促销活动、需要特别强调的规则。',
    promptPlaceholder: '例如：遇到无法解决的问题时，请引导客户提交工单，或拨打客服电话 400-000-0000。',
    suggestions: '推荐问题',
    suggestionsHelp: '显示在助手首页的「你可能想问」，最多 {max} 条，每条不超过 60 字。',
    suggestionPlaceholder: '例如：CNAME 一直没有生效怎么办？',
    suggLangZh: '中文控制台',
    suggLangEn: '英文控制台',
    suggestionPlaceholderEn: '例如：How do I put my website on the CDN?',
    addSuggestion: '添加问题',
    testTitle: '连接测试',
    testIntro: '使用已保存的配置向模型发送一条简短的消息，检查地址、模型和 API Key 是否可用。',
    testRun: '测试连接',
    testUnsaved: '有未保存的修改，测试使用的是已保存的配置。',
    testNoKey: '请先填写并保存 API Key。',
    testOk: '连接成功：{model} 用时 {ms} ms 回复「{reply}」',
    usageTitle: '使用情况',
    usageToday: '今日提问',
    usageUsers: '今日提问客户',
    usage30: '近 30 天提问',
    usageTokens: '近 30 天消耗 tokens',
    usageQuestions: '提问',
    usageFailed: '近 30 天有 {n} 次回答失败，可在模型服务商的控制台查看原因。',
    saved: '已保存',
  },
  identityReveal: {
    title: '完整证件号码',
    note: '本次查看已记入审计日志。请仅在配合公安机关调查等必要时查看，不要截图外传。',
    account: '账号',
    name: '姓名',
    idCard: '身份证号码',
    creditCode: '统一社会信用代码',
    open: '查看完整号码',
    openShort: '查看',
    close: '关闭',
  },
  memberModal: {
    title: '会员等级 · {user}',
    tabVip: 'VIP 成长值',
    tabExp: '经验',
    notVip: '不是 VIP',
    notVipShort: '非 VIP',
    growthUnit: '成长值',
    expUnit: '经验',
    toNextVip: '距 VIP{lv} 还需 {n} 成长值',
    vipTop: '已是最高 VIP 等级',
    toNextLv: '距 LV{lv} 还需 {n} 经验',
    lvTop: '已满级',
    adjustGrowth: '调整成长值',
    adjustExp: '调整经验',
    add: '增加',
    sub: '减少',
    amount: '数量',
    notePlaceholder: '调整说明（客户会在记录里看到）',
    apply: '确认调整',
    previewGrowth: '调整后 {n} 成长值 · {level}',
    previewExp: '调整后 {n} 经验 · LV{lv}',
    confirmGrowthAdd: '确认给 {user} 增加 {n} 成长值？',
    confirmGrowthSub: '确认将 {user} 的成长值减少 {n}？',
    confirmExpAdd: '确认给 {user} 增加 {n} 经验？',
    confirmExpSub: '确认将 {user} 的经验减少 {n}？',
    growthHelp: 'VIP 等级按成长值自动计算，门槛在「会员等级」中设置；每次调整都会记入成长值记录。',
    expHelp: '等级按经验自动计算；每次调整都会记入客户的经验记录。',
    doneGrowth: '已调整成长值',
    doneExp: '已调整经验',
    recordsGrowth: '成长值记录',
    recordsExp: '经验记录',
    recordsSub: '最近 {n} 条',
    after: '调整后 {n}',
    colTime: '时间',
    colChange: '变动',
    colAfter: '调整后',
    colNote: '说明',
    colSource: '来源',
    colActor: '操作人',
    system: '系统',
    source_daily: '每日登录',
    source_task: '新手任务 · {task}',
    source_adjust: '平台调整',
    empty: '还没有记录',
  },
  memberSettings: {
    title: '会员等级',
    saved: '已保存',
    saveFailed: '保存失败',
    vipTitle: 'VIP 会员',
    vipIntro: '客户的 VIP 等级（VIP1–VIP10）由成长值决定，成长值在客户列表中调整，每次调整都有记录。',
    toUsers: '查看 VIP 客户',
    thresholds: 'VIP 成长值门槛',
    thresholdsHelp: '成长值达到门槛即为该 VIP 等级，需逐级递增。保存后所有客户的 VIP 等级立即按新门槛重算，等级的变化会记入客户的成长值记录。',
    thresholdsBad: '每一级的门槛都要高于上一级',
    badge: 'VIP 标志',
    badgeHelp: '显示在 VIP 客户的名字旁，用户台和管理台一致。',
    badge_standard: '标准盾标',
    badge_facet: '棱面盾标',
    badge_holo: '黑卡炫彩',
    badge_capsule: '流光胶囊',
    badge_tiered: '进阶套系',
    ticketFirst: '工单优先',
    ticketFirstHelp: '开启后，VIP 客户未关闭的工单排在工单列表最前面，VIP 等级高的在前。',
    expTitle: '经验获取',
    expIntro: '客户靠经验从 LV1 升到 LV100。每项 0 到 {max} 经验，设为 0 则不奖励。',
    daily: '每日登录',
    dailyHelp: '客户每天第一次打开控制台时获得，按北京时间计日。',
    expUnit: '经验',
    tasks: '新手任务',
    tasksHelp: '每项只奖励一次；已经完成的客户，下次打开控制台时补发。设为 0 则不提供该任务。',
    task_realname: '实名认证',
    task_phone: '绑定手机',
    task_guard: '开启登录保护',
    task_site: '添加第一个站点',
    taskHelp_realname: '通过个人或企业实名认证。',
    taskHelp_phone: '用短信验证码验证手机号。',
    taskHelp_guard: '绑定 MFA 设备，或开启短信登录保护。',
    taskHelp_site: '添加第一个站点。',
    curveTitle: '等级曲线',
    curveIntro: '升到下一级所需经验 = 5 × 当前等级。下面是各等级的起点经验，以及只靠每日登录大约需要的时间。',
    stepExp: '{n} 经验',
    paceDays: '约 {n} 天',
    paceYears: '约 {n} 年',
    paceNote: '按每日登录 {daily} 经验计，满级（LV100）{top}；新手任务会让前几级升得更快。',
    paceOff: '每日登录未开启，客户只能靠新手任务获得经验。',
  },
  realnameSettings: {
    title: '实名认证',
    stateOff: '未开启',
    stateReady: '已就绪',
    stateIncomplete: '配置不完整',
    listTitle: '实名认证列表',
    listIntro: '开启后，客户在控制台按此列表的顺序选择认证方式完成个人实名认证，核验通过即为已实名。国内和国际各有一份列表：中国大陆的账号看到国内认证，其他国家和地区的账号看到国际认证；只有接口已配置的方式才会显示给客户。',
    listDrag: '拖动行首的把手可调整顺序。',
    addMethod: '添加认证方式',
    listEmpty: '还没有认证方式',
    listEmptySub: '先在下方「实名配置」中配置接口，再添加认证方式',
    colProvider: '认证接口',
    colReady: '接口状态',
    colShown: '显示',
    colActions: '操作',
    statusOk: '可用',
    region_cn: '国内认证',
    region_intl: '国际认证',
    regionHint_cn: '中国大陆的账号使用这些认证方式（按客户「账户资料」中的所属国家/地区区分）',
    regionHint_intl: '中国大陆以外的账号使用这些认证方式：在服务商页面拍摄证件并进行人脸核验',
    configRegion_cn: '国内接口',
    configRegion_intl: '国际接口',
    provider_sumsub: 'Sumsub',
    provider_veriff: 'Veriff',
    providerShort_sumsub: 'Sumsub',
    providerShort_veriff: 'Veriff',
    providerHint_sumsub: '使用 Sumsub 应用的 App Token 和 Secret Key；要求哪些证件和核验项由所填的认证级别决定',
    providerHint_veriff: '使用 Veriff 集成的 API Key 和 Shared Secret Key',
    method_SUMSUB_IDV: '证件与人脸核验',
    method_VERIFF_IDV: '证件与人脸核验',
    methodHint_SUMSUB_IDV: '在 Sumsub 页面拍摄护照、身份证件或驾驶证，再进行人脸活体检测，支持全球大多数国家和地区',
    methodHint_VERIFF_IDV: '在 Veriff 页面拍摄护照、身份证件或驾驶证，再进行人脸活体检测，支持全球大多数国家和地区',
    appTokenHelp: '在 Sumsub 控制台「Developers → App Tokens」创建，prd: 开头为正式环境',
    sumsubSecretPlaceholder: 'Sumsub Secret Key',
    levelName: '认证级别（Level）',
    levelNameHelp: '在 Sumsub 控制台创建的认证级别名称，决定要求的证件与核验项',
    veriffKeyHelp: '在 Veriff 控制台的集成（Integrations）页面查看',
    veriffSecretPlaceholder: 'Veriff Shared Secret Key',
    why_level: '未填写认证级别',
    whyHint_level: '在「实名配置 → 国际接口 → Sumsub」中填写认证级别名称',
    addTitle_cn: '添加国内认证方式',
    addTitle_intl: '添加国际认证方式',
    doc_PASSPORT: '护照',
    doc_ID_CARD: '身份证件',
    doc_DRIVERS: '驾驶证',
    doc_RESIDENCE_PERMIT: '居留许可',
    why_account: '接口未配置',
    why_rule: '未填写 RuleId',
    why_authCode: '未填写授权码',
    why_baseUrl: '缺少回跳地址',
    whyHint_account: '在下方「实名配置」中填写该接口的账号',
    whyHint_rule: '微信人脸核身需要业务规则 RuleId，在「实名配置 → 腾讯云人脸核身」中填写',
    whyHint_authCode: '在「实名配置 → 阿里云号码百科」中填写该方式的授权码',
    whyHint_baseUrl: '核验后需跳回用户控制台：请在「主控域名」中设置用户控制台域名',
    isDefault: '默认',
    setDefault: '设为默认',
    remove: '移除',
    moveUp: '上移',
    moveDown: '下移',
    addIntro: '勾选要添加到列表的方式，只能添加已配置接口的方式。',
    addOk: '添加',
    added: '已添加',
    configured: '已配置',
    notConfigured: '未配置',
    notConfiguredNote: '请先在「实名配置」中填写该接口的账号并保存。',
    configTitle: '实名配置',
    configIntro: '各认证接口的账号，彼此独立，也和「支付配置」互不相干；使用前需在对应平台开通实名核验相关产品。',
    method_SMART_FACE: '快捷认证',
    method_FACE: '人脸认证',
    method_CERT_PHOTO: '证照认证',
    method_CERT_PHOTO_FACE: '证照+人脸认证',
    methodHint_SMART_FACE: '支付宝按账户情况自动选择核验方式，体验最好',
    methodHint_FACE: '人脸识别，与身份证照片比对',
    methodHint_CERT_PHOTO: '拍摄身份证正反面',
    methodHint_CERT_PHOTO_FACE: '拍摄身份证后再人脸识别，最严格',
    limitsTitle: '认证限制与费用',
    limitsIntro: '限制每个账号每天的认证次数和同一身份证可认证的账号数。免费次数用完后，每次认证从客户余额扣费；接口未能发起或核验服务异常时自动退回。',
    daily: '每个账号每日认证次数',
    maxAccounts: '同一身份证可认证账号数',
    unitTimes: '次',
    unitAccounts: '个',
    saved: '实名认证设置已保存',
    recordsTitle: '认证记录',
    recordsCount: '共 {n} 条',
    recordsEmpty: '暂无认证记录',
    filterAccount: '用户名 / 邮箱 / 手机号',
    filterName: '姓名',
    filterMethod: '认证方式',
    filterStatus: '状态',
    colTime: '发起时间',
    colAccount: '账号',
    colName: '姓名',
    colCertNo: '证件号码',
    colMethod: '认证方式',
    colState: '状态',
    colIp: 'IP',
    state_passed: '已通过',
    state_pending: '认证中',
    state_failed: '未通过',
    state_expired: '已超时',
    state_init: '发起中',
    provider_alipay: '支付宝身份验证',
    provider_tencent: '腾讯云人脸核身',
    provider_aliyun: '阿里云号码百科',
    providerShort_alipay: '支付宝',
    providerShort_tencent: '腾讯云',
    providerShort_aliyun: '阿里云',
    providerHint_alipay: '使用支付宝开放平台的应用，需为该应用签约「身份验证」产品',
    providerHint_tencent: '使用腾讯云 API 密钥，需在腾讯云开通「人脸核身」服务',
    providerHint_aliyun: '使用阿里云 AccessKey；需在号码百科控制台「标签广场」申请所需标签，审批通过后在「我的申请」获取授权码',
    secretIdHelp: '在腾讯云「访问管理 → API 密钥管理」获取，建议使用只授权了人脸核身的子账号密钥',
    secretKeyKeep: '已保存，留空则不修改',
    secretKeyPlaceholder: '腾讯云 SecretKey',
    secretKeySet: '已加密保存',
    secretKeyHelp: '保存后加密存储，不再显示',
    accessKeyIdHelp: '在阿里云「AccessKey 管理」获取，建议使用只授权了号码百科的 RAM 用户',
    accessKeySecretPlaceholder: '阿里云 AccessKey Secret',
    authCodeID2: '身份证二要素授权码',
    authCodeHelpID2: '标签「身份证二要素核验」的授权 ID，列表中显示该方式时必填',
    authCodePhone3: '手机号三要素授权码',
    authCodeHelpPhone3: '标签「手机号三要素核验」的授权 ID，列表中显示该方式时必填',
    ruleId: '业务规则 RuleId',
    ruleIdHelp: '在人脸核身控制台「自助接入」创建业务规则后获得，微信人脸核身需要',
    region: '地域',
    regionHelp: '可不填，例如 ap-guangzhou',
    method_TC_FACE: '微信人脸核身',
    method_TC_ID2: '身份证二要素核验',
    method_TC_PHONE3: '手机号三要素核验',
    methodHint_TC_FACE: '用微信扫码打开核身页面，活体检测后与公安权威照片比对',
    methodHint_TC_ID2: '核验姓名与身份证号是否一致，即时出结果，无需刷脸',
    methodHint_TC_PHONE3: '核验姓名、身份证号与手机号是否属于同一人，即时出结果',
    method_ALI_ID2: '身份证二要素核验',
    method_ALI_PHONE3: '手机号三要素核验',
    methodHint_ALI_ID2: '核验姓名与身份证号是否一致，即时出结果，无需刷脸',
    methodHint_ALI_PHONE3: '按运营商实名登记核验姓名、身份证号与手机号是否属于同一人，即时出结果',
    freeAttempts: '每个账号免费认证次数',
    freeHelp: '按账号累计，接口成功受理才计入',
    fee: '超出后每次费用',
    feeHelp: '从客户余额扣除，0 表示一直免费',
    unitPerTime: '/ 次',
    colFee: '费用',
    free: '免费',
    notBilled: '不计费',
  },
  messageTemplates: {
    title: '消息模板',
    intro: '平台发出的每一封邮件、每一条站内信和短信说什么，都在这里定。邮件共用同一套版式，事件的明细表和引用的消息由系统自动填写；关闭某个事件，它就不再发送。',
    mailTab: '邮件模板',
    smsTab: '短信模板',
    inboxTab: '站内信模板',
    inboxIntro: '站内信显示在控制台右上角的消息通知和消息中心里，按查看者的界面语言显示，中文、英文各有一套。引用的工单内容、告警明细等由系统自动附在正文之后。',
    colInboxTitle: '标题',
    inboxLang: '编辑语言',
    inboxLangHelp: '界面是中文的人看到中文这套，英文的人看到英文这套；两套都要填写',
    langZh: '中文',
    langEn: 'English',
    inboxBodyHelp: '换行会原样保留；引用内容和明细会自动排在正文之后',
    inboxEnabledHelp: '关闭后，这个事件不再发送站内信',
    inboxPreviewNote: '预览使用示例数据；实际显示时按查看者的语言替换为真实的值，引用内容和明细附在正文之后',
    smsIntro: '通用模板用于所有验证码短信，各场景也可单独指定，留空即沿用通用模板。阿里云填写审核通过的模板 CODE，短信宝填写短信内容。',
    colEvent: '消息',
    colTo: '接收人',
    colSubject: '邮件标题',
    colEnabled: '发送',
    colActions: '操作',
    colScene: '场景',
    colAliyun: '阿里云模板 CODE',
    colSmsbao: '短信宝内容',
    to_staff: '客服',
    to_customer: '客户',
    to_ops: '运维',
    custom: '已自定义',
    edit: '编辑',
    save: '保存',
    saved: '已保存',
    turnedOn: '已开启发送',
    turnedOff: '已关闭发送',
    cn: '国内',
    intl: '国际',
    inheritedSample: '灰色',
    inheritedNote: '为沿用通用模板',
    inUse: '使用中',
    vars: '变量',
    varsHelp: '点击变量，插入到光标所在的位置；发送时替换为实际的值',
    subject: '邮件标题',
    heading: '正文标题',
    body: '正文',
    bodyHelp: '换行会原样保留；明细表与按钮会自动排在正文之后',
    button: '按钮文字',
    enabledHelp: '关闭后，这个事件不再发送邮件',
    restore: '恢复默认内容',
    preview: '预览',
    previewNote: '预览使用示例数据，实际发送时替换为真实的值',
    aliyunCn: '国内号码模板 CODE',
    aliyunIntl: '国际号码模板 CODE',
    smsbaoCn: '国内号码短信内容',
    smsbaoIntl: '国际号码短信内容',
    generalNote: '短信宝内容留空即恢复默认内容；阿里云模板需先在阿里云控制台审核通过。',
    smsEmptyNote: '留空的项沿用通用模板；阿里云模板需先在阿里云控制台审核通过。',
    event_ticket_new_staff: '新工单通知',
    event_ticket_reply_staff: '客户回复通知',
    event_ticket_reply_customer: '客服回复通知',
    event_ticket_resolved: '工单处理完毕',
    event_ticket_closed: '工单关闭',
    event_ticket_auto_closed: '工单自动关闭',
    event_autorenew_ok: '自动续费成功',
    event_autorenew_failed: '自动续费失败',
    event_serving_alert: '节点服务异常',
    event_serving_recovered: '节点服务恢复',
    eventHint_ticket_new_staff: '客户提交新工单时，发给客服',
    eventHint_ticket_reply_staff: '客户在工单中回复时，发给客服',
    eventHint_ticket_reply_customer: '客服回复工单时，发给客户',
    eventHint_ticket_resolved: '客服回复并关闭工单时，发给客户',
    eventHint_ticket_closed: '工单被关闭时，发给客户',
    eventHint_ticket_auto_closed: '工单长时间无回复被自动关闭时，发给客户',
    eventHint_autorenew_ok: '套餐用余额自动续费成功后，发给客户',
    eventHint_autorenew_failed: '套餐自动续费未能完成时，发给客户',
    eventHint_serving_alert: '节点未按发布的配置服务时，发给每位管理员和运维',
    eventHint_serving_recovered: '节点恢复正常时，发给每位管理员和运维',
    scene_default: '通用模板',
    scene_bind_phone: '绑定手机号',
    scene_login: '登录验证',
    scene_reset_password: '找回密码',
    sceneHint_default: '场景未单独设置时使用',
    sceneHint_bind_phone: '安全中心绑定或更换手机号时',
    sceneHint_login: '登录两步验证选择短信，或短信验证码登录时',
    sceneHint_reset_password: '用手机号找回密码时',
    var_system: '平台名称',
    var_ticket_no: '工单编号',
    var_ticket_title: '工单标题',
    var_customer: '客户用户名',
    var_category: '工单分类',
    var_priority: '优先级',
    var_days: '自动关闭天数',
    var_package: '套餐名称',
    var_period: '续费时长',
    var_amount: '扣费金额',
    var_expires_at: '到期时间',
    var_order_no: '订单号',
    var_reason: '失败原因',
    var_node: '节点名称',
    var_problem: '问题',
    var_detail: '问题说明',
    var_duration: '持续时长',
    to_visitor: '填写的邮箱',
    event_register_code: '注册验证码',
    eventHint_register_code: '用户注册时，发到所填写的邮箱（注册验证邮箱开启时）',
    var_code: '验证码',
    var_minutes: '有效分钟数',
    scene_register: '注册验证',
    sceneHint_register: '注册时验证手机号（注册验证手机开启时）',
    alwaysOn: '始终发送',
    event_login_code: '登录验证码',
    eventHint_login_code: '用户用邮箱验证码登录时，发到账号的邮箱（邮箱验证码登录开启时）',
  },
  captchaSettings: {
    title: '人机验证',
    serviceTitle: '验证服务',
    stateOn: '已开启',
    stateOff: '未开启',
    serviceIntro: '在获取验证码、注册和登录等操作前，先让访问者完成一次人机验证，防止脚本批量刷取短信、邮件和账号。同一时间只启用一家服务，两个控制台共用。',
    provider: '服务商',
    provider_local: '本地验证码',
    provider_tencent: '腾讯云验证码',
    provider_geetest: '极验',
    provider_google: 'Google reCAPTCHA',
    providerShort_local: '本地',
    providerShort_tencent: '腾讯云',
    providerShort_geetest: '极验',
    providerShort_google: 'Google',
    providerHint_local: '主控自己出题、自己核验的滑动拼图，不依赖第三方服务，也不用填写账号；识别机器的能力不及第三方服务的风控。',
    providerHint_tencent: '国内外都能使用。',
    providerHint_geetest: '极验 4.0（行为验证），国内外都能使用。',
    providerHint_google: 'reCAPTCHA v2 复选框，适合以海外用户为主的平台。中国大陆的访客要从 www.recaptcha.net 加载，速度可能较慢。',
    onError: '服务异常时',
    onErrorAllow: '放行并记录',
    onErrorAllowHint: '照常放行，并记录在下方',
    onErrorDeny: '拒绝操作',
    onErrorDenyHint: '提示访问者稍后再试',
    onErrorHelp: '服务异常指主控向服务商核验时超时、报错或密钥失效。访客的浏览器加载不了验证码时，无法通过验证。',
    adminShutTitle: '管理员也可能无法登录',
    adminShut: '管理后台登录也要验证，验证服务出现异常时同样会被拦下。遇到这种情况，在主控机上执行下面的命令关闭人机验证即可：',
    recordTitle: '验证服务异常记录',
    recordText: '自 {since} 起共 {n} 次，放行 {allowed} 次，拒绝 {denied} 次。最近一次在 {last}（{provider}，{scene}）：{error}',
    recordClear: '清除记录',
    accountsTitle: '服务账号',
    localNoAccount: '本地验证码不需要账号。下面是第三方服务的账号，换用时再填写。',
    accountIntro_tencent: '在腾讯云验证码控制台新建验证，复制 CaptchaAppId 和 AppSecretKey。SecretId 和 SecretKey 是腾讯云 API 密钥（访问管理 → API 密钥管理），主控用它向腾讯云核验票据。',
    accountIntro_geetest: '在极验后台的行为验证 4.0 中新建业务，复制验证 ID 和验证 KEY。',
    accountIntro_google: '在 reCAPTCHA 管理后台新建 reCAPTCHA v2「进行人机身份验证」复选框类型的网站，加入控制台的域名，复制网站密钥和密钥。',
    geetestId: '验证 ID',
    geetestKey: '验证 KEY',
    siteKey: '网站密钥',
    googleSecret: '密钥',
    googleHost: '加载地址',
    googleHostHelp: 'www.recaptcha.net 是同一服务的另一个地址，中国大陆也能访问，推荐使用。',
    secretSet: '已设置',
    secretKept: '已保存，留空则不修改',
    scenesTitle: '需要验证的操作',
    scenesIntro: '选择哪些操作要先完成人机验证。发送验证码仍受短信服务的频率限制。',
    scene_send_code: '获取验证码',
    scene_register: '注册账号',
    scene_login: '用户控制台登录',
    scene_admin_login: '管理后台登录',
    sendCodeHelp: '注册、验证码登录、找回密码、换绑手机号时，发送短信或邮件验证码之前。',
    registerHelp: '在用户控制台提交注册时。',
    login_off: '不验证',
    login_failed: '密码输错后',
    login_always: '每次登录',
    failures: '输错几次后验证',
    failuresUnit: '次',
    failuresHelp: '同一账号或同一 IP 在 15 分钟内输错密码达到这个次数后，再登录要先完成人机验证。',
    testTitle: '测试验证',
    testIntro: '用已保存的配置弹出一次验证，并由主控向服务商核验结果，确认密钥填写正确。',
    testIntroLocal: '用已保存的配置弹出一次本地验证码，并由主控核验结果，确认可以正常使用。',
    testRun: '测试验证',
    testUnsaved: '有未保存的修改，保存后再测试。',
    testNotReady: '请先填写所选服务的全部密钥并保存。',
    testPass: '验证通过：服务商确认了这次验证，配置正确。',
    testPassLocal: '验证通过：本地验证码可以正常使用。',
    testRejected: '服务商判定未通过：{detail}',
    testRejectedBare: '服务商判定未通过。',
    tencentFailed: '腾讯云验证码出错，错误码 {code}。',
    tencent1006: '这表示拉取验证码配置失败：请确认 CaptchaAppId 和 AppSecretKey 填写正确，腾讯云验证码已开通且没有欠费。',
    tencentLoad: '这多半是网络问题：请确认浏览器能访问腾讯云验证码（turing.captcha.qcloud.com）。',
    testUnavailable: '无法完成核验：{detail}',
    saved: '人机验证设置已保存',
  },
  smsSettings: {
    title: '短信服务',
    providerTitle: '短信渠道',
    providerIntro: '平台通过短信给用户发送验证码：验证手机号、短信登录保护、找回密码。中国大陆手机号走国内渠道，其他国家和地区的手机号走国际渠道，各自选择阿里云短信或短信宝。',
    stateOff: '未开启',
    stateReady: '可以发送',
    stateIncomplete: '配置不完整',
    provider: '服务商',
    provider_aliyun: '阿里云短信',
    provider_smsbao: '短信宝',
    channelCn: '国内渠道',
    channelCnHelp: '向中国大陆手机号发送验证码的服务商',
    channelIntl: '国际渠道',
    channelIntlHelp: '向中国大陆以外（含港澳台）的手机号发送验证码；不开通时，用户只能绑定中国大陆手机号',
    channelOff: '不开通',
    accountsTitle: '渠道账号',
    templatesMoved: '短信内容与模板 CODE 在消息模板中设置。',
    templatesLink: '前往消息模板',
    accountsIntro: '各服务商的账号，被选为渠道的才会使用；密钥加密保存，保存后不再显示。',
    intlSignName: '国际短信签名',
    intlSignHelp: '可不填，默认使用中国大陆短信的签名',
    intlTemplateHelp: '在阿里云「短信服务 › 国际/港澳台消息」申请的验证码模板',
    smsbaoUser: '用户名',
    smsbaoUserHelp: '短信宝的登录用户名',
    smsbaoKeyType: '认证方式',
    smsbaoPassword: '密码',
    smsbaoSecretHelp: '加密保存，保存后不再显示；密码按短信宝的要求以 MD5 发送',
    smsbaoSignHelp: '短信开头的【签名】，需先在短信宝后台报备，不含【】',
    smsbaoTemplateHelp: "{'{'}code{'}'} 为验证码，{'{'}minutes{'}'} 为有效分钟数；签名会自动加在开头",
    accessKeyId: 'AccessKey ID',
    accessKeySecret: 'AccessKey Secret',
    secretHelp: '加密保存，保存后不再显示',
    secretKept: '已保存，留空则不修改',
    secretSet: '已设置',
    secretPlaceholder: '请输入 AccessKey Secret',
    signName: '短信签名',
    signHelp: '审核通过的签名名称，不含【】',
    signPlaceholder: '例如：云加速',
    templateHelp: '审核通过的验证码模板',
    templateParam: '模板变量',
    templateParamHelp: "模板内容中验证码的变量名。模板写的是 ${'{'}code{'}'}，这里就填 code",
    limitsTitle: '发送限制',
    limitsIntro: '同一 IP 每小时最多获取 20 条；同一条验证码输错 5 次即失效。',
    ttl: '验证码有效期',
    interval: '同号码发送间隔',
    daily: '每号码每日上限',
    unitMinutes: '分钟',
    unitSeconds: '秒',
    unitTexts: '条',
    saved: '短信服务已保存',
    testTitle: '测试发送',
    testIntro: '用已保存的配置给一个手机号发送一条验证码短信，确认签名和模板都能正常使用。',
    testPlaceholder: '手机号',
    testSend: '发送测试短信',
    testSent: '测试短信已发送至 {phone}，请留意手机',
    testUnsaved: '配置有修改，请先保存再测试',
    testNotReady: '请先开启并填写完整配置后再测试',
    recordsTitle: '发送记录',
    recordsCount: '共 {n} 条',
    recordsEmpty: '暂无发送记录',
    filterPhone: '搜索手机号',
    filterPurpose: '用途',
    filterStatus: '发送结果',
    purpose_bind_phone: '验证手机号',
    purpose_login: '登录验证',
    purpose_reset_password: '找回密码',
    purpose_test: '测试发送',
    status_sent: '已发送',
    status_failed: '发送失败',
    status_pending: '发送中',
    state_valid: '待使用',
    state_used: '已使用',
    state_expired: '已失效',
    state_failed: '发送失败',
    state_pending: '发送中',
    colTime: '时间',
    colPhone: '手机号',
    colPurpose: '用途',
    colAccount: '账号',
    colState: '状态',
    colNote: '说明',
    colIp: '请求 IP',
    attempts: '输错 {n} 次',
  },
  saveBar: {
    label: '保存操作',
    unsaved: '有未保存的修改',
    reset: '撤销修改',
    fixFirst: '有填写错误，请先修正',
  },
  mail: {
    title: '邮件服务',
    smtpTitle: 'SMTP 发信',
    smtpIntro: '平台通过这个 SMTP 账号发送系统邮件，目前用于工单通知。建议使用企业邮箱或邮件推送服务提供的 SMTP 账号。',
    stateOff: '未启用',
    stateReady: '可以发信',
    stateIncomplete: '配置不完整',
    host: 'SMTP 服务器',
    port: '端口',
    security: '加密方式',
    security_ssl: 'SSL/TLS',
    security_starttls: 'STARTTLS',
    security_none: '不加密',
    securityHelp_ssl: '连接即加密，常用端口 465。',
    securityHelp_starttls: '先明文连接，再升级为加密连接，常用端口 587。',
    securityHelp_none: '全程不加密，密码和邮件内容以明文传输，只建议在内网使用，常用端口 25。',
    username: '用户名',
    usernameHelp: '通常是完整的发信邮箱地址；服务器不需要登录时留空。',
    usernamePlaceholder: "noreply{'@'}example.com",
    password: '密码',
    passwordHelp: 'SMTP 密码或授权码，加密保存。',
    passwordKept: '已保存密码，留空则不修改。',
    passwordSet: '已设置（留空不修改）',
    passwordPlaceholder: 'SMTP 密码或授权码',
    from: '发件人地址',
    fromName: '发件人名称',
    fromNameHelp: '收件人看到的发件人，留空则使用系统名称。',
    fromNamePlaceholder: '例如：cdnX 客服',
    linksTitle: '邮件中的链接',
    linksIntro: '通知邮件中「查看工单」按钮打开的控制台地址。',
    customerURL: '用户控制台地址',
    adminURL: '管理控制台地址',
    urlFallback: '留空则使用主控域名中的地址：{url}',
    urlNone: '留空且未配置主控域名时，邮件中不附带链接。',
    toConsoleDomains: '主控域名设置',
    testTitle: '发送测试邮件',
    testIntro: '使用已保存的设置立即发送一封测试邮件，检查配置是否正确。',
    testPlaceholder: '收件邮箱',
    testSend: '发送测试邮件',
    testSent: '测试邮件已发送到 {to}，请查收（也可能在垃圾邮件中）。',
    testUnsaved: '有未保存的修改，测试使用的是已保存的设置。',
    testNotReady: '请先启用邮件服务，填写服务器和发件人地址并保存。',
    saved: '邮件服务设置已保存',
  },
  // A message's files and the conversation: components/tickets, the same
  // files in both consoles, so the same keys.
  ticketFiles: {
    add: '添加附件',
    tip: '单个不超过 {mb} MB，最多 {max} 个，截图可直接粘贴',
    uploading: '附件上传中…',
    tooMany: '最多添加 {max} 个附件',
    tooLarge: '「{name}」超过 {max} MB，无法上传',
    empty: '「{name}」是空文件',
    failed: '「{name}」上传失败',
    downloadFailed: '下载失败',
  },
  // ---- 投诉管理 ----
  l4: {
    title: '加速规则',
    unit: '条',
    statAll: '全部规则',
    statActive: '运行中',
    statDisabled: '已停用',
    statSuspended: '已暂停',
    listTitle: '加速规则',
    listCount: '共 {n} 条',
    filterAll: '全部状态',
    resetFilters: '重置',
    state_active: '运行中',
    state_disabled: '已停用',
    state_suspended: '已暂停',
    reason_plan_expired: '套餐已到期',
    reason_traffic_exceeded: '流量超限',
    reason_requests_exceeded: '请求数超限',
    reason_no_feature: '套餐不含应用加速',
    colName: '规则名称',
    colAccess: '接入地址',
    colOrigins: '源站',
    noAccessHost: '套餐未配置线路',
    proto_tcp: 'TCP',
    proto_udp: 'UDP',
    proto_tcp_udp: 'TCP+UDP',
    stats: '统计',
    more: '更多',
    enable: '启用',
    disable: '停用',
    enabled: '已启用',
    disabled: '已停用',
    deleted: '已删除',
    disableTitle: '停用加速规则',
    disableContent: '停用「{name}」后，端口 {port} 立即关闭，正在进行的连接会断开。',
    deleteTitle: '删除加速规则',
    deleteContent: '删除「{name}」后，端口 {port} 立即关闭并释放，正在进行的连接会断开，删除后无法恢复。',
    noMatch: '没有符合条件的规则',
    searchPlaceholder: '搜索名称、端口或源站',
    filterCustomer: '全部客户',
    colOwner: '所属客户',
    colPort: '监听端口',
    portRange: '端口范围',
    settingsTitle: '应用加速端口范围',
    settingsIntro: '客户新建或修改规则时只能使用该范围内的端口，已有规则保留原端口。节点防火墙的封禁会覆盖该范围。',
    settingsHint: '端口需大于 1024；建议避开 32768 以上的系统临时端口段。云服务器的安全组需放行该范围的 TCP 和 UDP。',
    portMin: '起始端口',
    portMax: '结束端口',
    settingsSaved: '端口范围已保存',
    rangeNow: '当前 {min}–{max}',
    empty: '客户还没有加速规则',
  },
  l4stats: {
    title: '{name} · 统计',
    range_1h: '1 小时',
    range_today: '今日',
    range_yesterday: '昨日',
    range_7d: '7 天',
    range_30d: '30 天',
    loadFailed: '统计加载失败',
    noLogs: '未接入日志存储，暂无应用加速统计',
    fig_trafficOut: '下行流量',
    fig_peakOut: '下行峰值带宽',
    fig_conns: '新建连接',
    fig_active: '峰值并发',
    upNote: '上行 {v}',
    connsNote: '源站无响应 {failed} · 拒绝 {refused}',
    activeNote: '同一时刻打开的连接',
    tab_bandwidth: '带宽',
    tab_traffic: '流量',
    tab_conns: '连接数',
    tab_active: '并发',
    down: '下行',
    up: '上行',
    newConns: '新建连接',
    failed: '源站无响应',
    refused: '被拒绝',
    activeLine: '并发连接',
    clientsTitle: '访客排行',
    colIp: '访客 IP',
    colConns: '连接数',
    noClients: '这段时间没有访客',
  },
  complaints: {
    title: '投诉管理',
    unit: '条',
    statPending: '待处理',
    statProcessing: '处理中',
    statResolved: '已处理',
    statWithdrawn: '已撤销',
    listTitle: '投诉列表',
    count: '共 {n} 条',
    searchPlaceholder: '搜索投诉编号或内容',
    filter_open: '待处理与处理中',
    filter_pending: '待处理',
    filter_processing: '处理中',
    filter_resolved: '已处理',
    filter_withdrawn: '已撤销',
    filter_all: '全部投诉',
    noMatch: '没有符合条件的投诉',
    empty: '暂无需要处理的投诉',
    cat_attitude: '服务态度',
    cat_speed: '响应速度',
    cat_result: '处理结果',
    cat_outage: '服务故障',
    cat_billing: '计费问题',
    cat_other: '其他',
    status_pending: '待处理',
    status_processing: '处理中',
    status_resolved: '已处理',
    status_withdrawn: '已撤销',
    colComplaint: '投诉',
    colTicket: '关联工单',
    colHandler: '处理人',
    colNo: '投诉编号',
    noTicket: '未关联',
    nobody: '未受理',
    handle: '处理',
    detailTitle: '投诉详情',
    category: '投诉类型',
    content: '投诉内容',
    filedAt: '提交时间',
    result: '处理结果',
    handledAt: '处理于 {time}',
    resultPlaceholder: '写明核实情况和处理方式，客户会在「我的投诉」中看到。',
    accept: '受理',
    accepted: '已受理',
    resolve: '提交处理结果',
    resolved: '处理结果已提交',
    withdrawnNote: '客户已撤销这条投诉。',
    pendingNote: '这条投诉还没有人受理。可以先受理，也可以直接提交处理结果。',
    close: '关闭',
  },
  richEditor: {
    image: '插入图片',
    bold: '加粗',
    italic: '斜体',
    underline: '下划线',
    bulletList: '无序列表',
    numberList: '有序列表',
    link: '插入链接',
    unlink: '取消链接',
    attach: '添加附件',
    linkPlaceholder: '输入链接地址',
    linkApply: '确定',
    badLink: '链接地址不正确',
  },
  ticketThread: {
    secretTag: '保密消息',
    secretReveal: '点击查看',
    secretHide: '隐藏',
    secretPurged: '保密内容已在工单关闭时销毁',
    newMessages: '收到新消息，点击查看',
    newSpoken: '您有一条新的工单消息',
    infoBody: '问题描述',
    infoFiles: '附件',
    infoSite: '相关站点',
    stage_filed: '已建单',
    stage_processing: '处理中',
    stage_closed: '已结单',
    me: '我',
    support: '客服',
    roleCustomer: '客户',
    roleStaff: '客服',
    note: '内部备注',
    ev_accepted: '{actor} 受理了工单',
    ev_assigned: '{actor} 将工单分配给 {name}',
    ev_assignedSelf: '{name} 接手了工单',
    ev_unassigned: '{actor} 取消了 {name} 的分配',
    ev_priority: '{actor} 将优先级改为「{priority}」',
    ev_closed_customer: '客户关闭了工单',
    ev_closed_staff: '{actor} 关闭了工单',
    ev_closed_auto: '客户超时未回复，工单已自动关闭',
    assistant: '服务助手',
    as_filed: '工单已提交',
    as_filedText: '我们已经收到你的问题，{support}会尽快处理，进展都会在这里告诉你。如需补充信息，可以继续留言。',
    as_accepted: '{support}已受理工单',
    as_acceptedText: '{support}正在处理你的问题，有进展会第一时间在这里回复你。',
    as_closed_customer: '你关闭了工单',
    as_closed_customerText: '感谢你的反馈。如果问题还没有解决，可以重新提交工单。',
    as_closed_staff: '{support}关闭了工单',
    as_closed_staffText: '问题已经处理完毕。如果还有疑问，可以重新提交工单。',
    as_closed_auto: '工单已自动关闭',
    as_closed_autoText: '工单长时间没有新的回复，系统已自动关闭。如果还有疑问，可以重新提交工单。',
  },
  menu: {
    grpNodes: '节点管理',
    grpSites: '站点管理',
    grpL4: '应用加速',
    grpDns: 'DNS 调度',
    grpSecurity: '安全防护',
    grpObserve: '日志与分析',
    grpCustomers: '客户与套餐',
    grpSystem: '系统管理',
    grpMessages: '消息通知',
    grpFinance: '财务管理',
    grpTickets: '工单管理',
  },
  // Messages the control plane produced, keyed by the stable code it ships
  // alongside the English text. The console looks the code up here so an
  // operator reads guidance in their own language; anything missing falls
  // back to the server's English rather than showing a bare key.
  quota: {
    usageCol: '本周期用量',
    traffic: '流量',
    requests: '请求数',
    bandwidth: '带宽',
    connections: '连接数',
    unlimited: '不限',
    withBonus: '含加量',
    resetsAt: '{time} 重置',
    exceeded_traffic_exceeded: '流量已用完',
    exceeded_requests_exceeded: '请求数已用完',
    exceededAlert_traffic_exceeded: '套餐「{pkg}」本周期的流量已用完，相关站点已暂停，访问者看到的是「流量超限」页面。{time} 进入下个周期后自动恢复，也可以联系管理员加量或升级套餐。',
    exceededAlert_requests_exceeded: '套餐「{pkg}」本周期的请求数已用完，相关站点已暂停，访问者看到的是「请求数超限」页面。{time} 进入下个周期后自动恢复，也可以联系管理员加量或升级套餐。',
    topUp: '加量',
    reset: '重置用量',
    topUpTitle: '本周期加量',
    topUpIntro: '给 {user} 的「{pkg}」本周期额外增加流量或请求数，下个周期自动失效。因超额暂停的站点会在一分钟内恢复。',
    millionSuffix: '百万次',
    topUpDone: '已加量',
    resetTitle: '重置本周期用量',
    resetConfirm: '把 {user} 的「{pkg}」本周期已用的流量和请求数清零重新计算？因超额暂停的站点会在一分钟内恢复。',
    resetDone: '已重置',
  },
  entitlements: {
    feature_waf: 'WAF',
    feature_custom_cc: '自定义 CC 规则',
    feature_websocket: 'WebSocket',
    feature_http3: 'HTTP/3',
    feature_custom_cert: '自定义证书',
    feature_openapi: 'OpenAPI',
    feature_l4: '应用加速',
  },
  // 人机验证 in the pages (utils/captcha.ts).
  captcha: {
    title: '安全验证',
    googleHint: '请勾选下方的验证框，完成后会自动继续。',
    loadFailed: '人机验证加载失败，请检查网络后重试',
    localTip: '向右拖动滑块完成拼图',
    localPassed: '验证通过',
    localMissed: '没有对准，请再试一次',
    localRefresh: '换一张',
    localRetry: '重试',
    tencentError: '腾讯云验证码出错（错误码 {code}），请稍后再试',
  },
  smsCode: {
    send: '获取验证码',
    resend: '重新获取',
    wait: '{n} 秒后重新获取',
    placeholder: '6 位验证码',
    sent: '验证码已发送至 {phone}',
    failed: '验证码发送失败',
    required: '请输入 6 位短信验证码',
  },
  securityCenter: {
    title: '安全中心',
    accountId: '账号 ID：{id}',
    level: '安全等级',
    level_low: '低',
    level_medium: '中',
    level_high: '高',
    tipMfa: '绑定 MFA 设备后，即使密码泄露，账号也不会被盗用',
    tipPassword: '密码已超过 {days} 天没有修改，建议更换',
    tipGood: '账号已开启全部安全防护',
    recentFails: '最近 {days} 天有 {n} 次登录失败。如果不是您本人操作，请立即修改密码并绑定 MFA 设备。',
    email: '邮箱',
    phone: '手机号',
    registered: '注册时间',
    lastLogin: '上次登录',
    unbound: '未绑定',
    settingsTitle: '安全设置',
    password: '登录密码',
    passwordDesc: '建议定期更换，不要与其他网站使用相同的密码。',
    passwordChanged: '上次修改于 {time}。',
    mfa: 'MFA 设备',
    mfaOnDesc: '已绑定，登录时需要输入身份验证器上的 6 位动态码。绑定于 {time}。',
    mfaOffDesc: '未绑定。绑定后，登录时除了密码还需要输入手机身份验证器上的动态码。',
    emailDesc: '{email}，用于接收工单回复和平台通知。',
    sessions: '其他登录',
    sessionsDesc: '在别人的电脑上登录过，或者怀疑账号被盗用时，可以让当前浏览器以外的所有登录立即失效。',
    change: '修改',
    bind: '绑定',
    unbind: '解绑',
    endOthers: '退出其他设备',
    logsTitle: '登录记录',
    logsSub: '最近 {n} 次',
    colTime: '时间',
    colResult: '结果',
    colIp: 'IP 地址',
    colDevice: '设备',
    colMethod: '登录方式',
    method_password: '密码',
    method_code: '验证码',
    method_passkey: '通行密钥',
    method_sub_user: '子用户 {name}',
    passkeys: '通行密钥',
    passkeysOnDesc: '已添加 {n} 个通行密钥，可使用指纹、面容或设备密码直接登录，无需输入密码。',
    passkeysOffDesc: '添加后可使用指纹、面容或设备密码直接登录，无需输入密码，私钥只保存在你的设备中。',
    manage: '管理',
    add: '添加',
    result_success: '登录成功',
    result_bad_password: '密码错误',
    result_bad_mfa: '动态码错误',
    result_inactive: '账号已停用',
    unknownDevice: '未知设备',
    logsEmpty: '暂无登录记录',
    saveFailed: '保存失败',
    passwordTitle: '修改登录密码',
    currentPassword: '当前密码',
    newPassword: '新密码',
    confirmPassword: '确认新密码',
    currentRequired: '请输入当前密码',
    newRequired: '请输入新密码',
    confirmRequired: '请再次输入新密码',
    passwordRule: '{min}–{max} 位，至少包含字母、数字、符号中的两种',
    passwordSame: '新密码不能与当前密码相同',
    passwordMismatch: '两次输入的密码不一致',
    passwordNote: '修改后，其他设备上的登录会立即失效，当前浏览器保持登录。',
    strength: '强度',
    strength_1: '弱',
    strength_2: '中',
    strength_3: '强',
    passwordDone: '密码已修改，其他设备上的登录已失效',
    emailTitle: '修改邮箱',
    phoneTitle: '修改手机号',
    phoneBindTitle: '绑定手机号',
    emailHint: '工单回复和平台通知会发到这个邮箱',
    emailRequired: '请输入邮箱',
    emailInvalid: '请输入正确的邮箱地址',
    loginPassword: '登录密码',
    passwordRequired: '请输入登录密码',
    confirmWithPassword: '为确认是您本人操作，请输入登录密码',
    contactDone: '已保存',
    mfaTitle: '绑定 MFA 设备',
    mfaStep1: '在手机上安装身份验证器应用，例如腾讯身份验证器、Google Authenticator 或 Microsoft Authenticator。',
    mfaStep2: '用应用扫描下面的二维码，添加账号。',
    mfaManual: '无法扫码时，在应用中手动输入密钥：',
    mfaStep3: '输入应用里显示的 6 位动态码和登录密码，完成绑定。',
    mfaCode: '动态码',
    mfaCodeHint: '打开身份验证器应用，输入当前显示的 6 位数字',
    mfaCodeRequired: '请输入 6 位动态码',
    mfaDone: 'MFA 设备已绑定，下次登录时需要输入动态码',
    mfaUnbindTitle: '解绑 MFA 设备',
    mfaUnbindWarn: '解绑后，登录只需要密码，账号安全等级会降低。设备丢失、无法获取动态码时，请联系平台管理员重置。',
    mfaUnbindDone: 'MFA 设备已解绑',
    endOthersTitle: '退出其他设备',
    endOthersConfirm: '账号在当前浏览器以外的所有登录都会立即失效，需要重新登录。确定继续吗？',
    endOthersDone: '其他设备上的登录已失效',
    tipSecondStep: '绑定 MFA 设备或开启短信登录保护后，即使密码泄露，账号也不会被盗用',
    loginSms: '登录保护',
    loginSmsOnDesc: '已开启，登录时需要输入发送到 {phone} 的短信验证码。',
    loginSmsOffDesc: '未开启。开启后，登录时除了密码，还需要输入发送到已验证手机号的短信验证码。',
    loginSmsNeedsPhone: '未开启。需要先验证手机号，开启后登录时需要输入短信验证码。',
    loginSmsNeedsPhoneFirst: '请先验证手机号',
    turnOn: '开启',
    turnOff: '关闭',
    verify: '验证',
    phoneOffSmsDesc: '未绑定。绑定并验证后，可用于短信登录保护和找回密码。',
    phoneProvedDesc: '{phone}，已验证，可用于短信登录保护和找回密码。',
    phoneUnprovedDesc: '{phone}，未验证。验证后可用于短信登录保护和找回密码。',
    phoneInvalid: '请输入正确的手机号',
    phoneVerifyTitle: '验证手机号',
    phoneSmsHint: '先选择国家或地区的区号，再填写手机号。清空后保存，即解除绑定',
    phoneDone: '手机号已验证',
    phoneRemoved: '手机号已解除绑定',
    loginSmsOnTitle: '开启登录保护',
    loginSmsOffTitle: '关闭登录保护',
    loginSmsOnNote: '开启后，每次登录除了密码，还需要输入发送到 {phone} 的短信验证码。',
    loginSmsOffWarn: '关闭后，登录只需要密码，账号安全等级会降低。',
    loginSmsOnDone: '登录保护已开启',
    loginSmsOffDone: '登录保护已关闭',
    result_bad_sms: '短信验证码错误',
    result_bad_email_code: '邮箱验证码错误',
    result_password_reset: '通过短信重置密码',
    phoneNoSmsDesc: '未绑定。平台开通短信服务后，可以通过短信验证码绑定。',
    phoneUnprovedNoSmsDesc: '{phone}，未验证。平台开通短信服务后，可以通过短信验证码验证。',
  },
  passkeys: {
    title: '通行密钥',
    addTitle: '添加通行密钥',
    intro: '通行密钥让你使用指纹、面容或设备密码登录，无需输入密码。私钥只保存在你的设备中，平台只保存公钥，无法被钓鱼网站盗用。',
    blocked_browser: '当前浏览器不支持通行密钥，请升级浏览器后再添加',
    blocked_domain: '通行密钥需要通过 HTTPS 域名访问控制台，当前地址无法添加或使用',
    colName: '名称',
    colAdded: '添加时间',
    colUsed: '最近使用',
    rename: '重命名',
    deleteConfirm: '删除后将无法再用它登录。设备中保存的通行密钥需在设备的密码管理中自行移除。',
    empty: '还没有添加通行密钥',
    count: '已添加 {n} / {max} 个',
    add: '添加通行密钥',
    close: '关闭',
    name: '名称',
    nameHint: '用于区分不同设备，例如「办公室 MacBook」',
    nameRequired: '请填写名称',
    nameTooLong: '名称最多 {max} 个字符',
    addNote: '点击「继续」后，请按浏览器提示完成指纹、面容或设备密码验证。',
    continue: '继续',
    added: '已添加通行密钥「{name}」',
    deleted: '已删除通行密钥「{name}」',
    cancelled: '已取消添加通行密钥',
    deviceHasOne: '这台设备已经为该账号保存过通行密钥了',
    addFailed: '添加通行密钥失败',
    renameFailed: '重命名失败',
    deleteFailed: '删除失败',
  },
  inbox: {
    title: '消息中心',
    settings: '消息接收配置',
    settingsTitle: '消息接收配置',
    settingsIntro: '选择每类消息的接收方式：站内信显示在右上角的消息通知和消息中心，邮件发送到账号绑定的邮箱。修改后立即生效。',
    settingsIntroStaff: '选择每类消息是否以站内信接收：站内信显示在右上角的消息通知和消息中心。工单邮件通知发送到工单设置中的通知邮箱（已分配处理人的工单发给处理人）。',
    prefSaved: '已保存',
    unreadCount: '{n} 条未读',
    readAll: '全部已读',
    allRead: '已全部标为已读',
    more: '查看更多',
    empty: '暂无消息',
    emptyUnread: '没有未读消息',
    attention: '{n} 项待处理',
    tabAll: '全部消息',
    tabUnread: '未读消息',
    categoryAll: '全部类型',
    category_ticket: '工单通知',
    category_billing: '财务通知',
    category_node: '节点通知',
    markRead: '标为已读',
    delete: '删除',
    deleted: '已删除',
    deleteTitle: '删除 {n} 条消息？',
    deleteContent: '删除后不可恢复。',
    view: '查看',
    detail: '消息详情',
    follow: '前往查看',
    close: '关闭',
    colTitle: '消息标题',
    colCategory: '类型',
    colTime: '时间',
    colActions: '操作',
    colEvent: '消息',
    channelInbox: '站内信',
    channelMail: '邮件',
    event_ticket_new_staff: '新工单',
    event_ticket_reply_staff: '客户回复工单',
    event_ticket_reply_customer: '工单有新回复',
    event_ticket_resolved: '工单处理完毕',
    event_ticket_closed: '工单关闭',
    event_ticket_auto_closed: '工单自动关闭',
    event_autorenew_ok: '自动续费成功',
    event_autorenew_failed: '自动续费失败',
    event_serving_alert: '节点服务异常',
    event_serving_recovered: '节点服务恢复',
    eventHint_ticket_new_staff: '客户提交新工单时；已分配处理人的工单只通知处理人',
    eventHint_ticket_reply_staff: '客户在工单中回复时；已分配处理人的工单只通知处理人',
    eventHint_ticket_reply_customer: '客服回复您的工单时',
    eventHint_ticket_resolved: '客服回复并关闭您的工单时',
    eventHint_ticket_closed: '您的工单被关闭时',
    eventHint_ticket_auto_closed: '工单长时间没有回复被自动关闭时',
    eventHint_autorenew_ok: '套餐用账户余额自动续费成功后',
    eventHint_autorenew_failed: '套餐自动续费未能完成时',
    eventHint_serving_alert: '节点未按发布的配置提供服务时，例如配置未生效、站点探测失败',
    eventHint_serving_recovered: '节点恢复正常时',
  },
  serverErrors: {
    emailCode: {
      unavailable: '平台还没有开启邮件服务，暂时无法发送邮箱验证码',
      badEmail: '请填写正确的邮箱地址',
      tooMany: '获取验证码过于频繁，请稍后再试',
      wrong: '邮箱验证码不正确',
      expired: '邮箱验证码已失效，请重新获取',
      tooSoon: '请 {seconds} 秒后再获取验证码',
      dailyLimit: '这个邮箱今天获取验证码的次数已达上限（{max} 次），请明天再试',
    },
    assistant: {
      badBaseURL: 'API 地址需以 http:// 或 https:// 开头',
      badDailyLimit: '每人每日次数为 0（不限）到 1000',
      badIcon: '不支持的图标：{value}',
      badKey: '模型服务拒绝了 API Key，请检查是否填写正确',
      badLauncher: '不支持的按钮样式：{value}',
      badMaxTokens: '单次回答上限为 256 到 8192 tokens',
      badModel: "模型名称只能包含字母、数字和 . _ : / {'@'} -",
      badName: '名称最多 {max} 个字',
      badPlacement: '不支持的显示位置：{value}',
      badProvider: '不支持的服务商：{value}',
      badSuggestion: '每条推荐问题最多 {max} 个字',
      badTemperature: '温度为 0 到 2',
      baseURLRequired: '请填写 API 地址',
      busy: '上一个回答还在生成，请稍候或先停止',
      dailyLimit: '今天的 {limit} 次提问已用完，明天再来吧',
      emptyAnswer: '模型没有给出回答，请重试',
      emptyQuestion: '请输入问题',
      encryptionKeyMissing: '请先在 control.yaml 中配置 secrets.encryption_key，才能保存 API Key',
      keyRequired: '请填写 API Key',
      modelRequired: '请填写模型',
      promptTooLong: '补充说明最多 {max} 个字',
      providerBalance: '模型服务账户余额不足，请联系平台管理员',
      questionTooLong: '问题最多 {max} 个字',
      rateLimited: '模型服务繁忙，请稍后再试',
      timeout: '模型响应超时，请重试',
      tooManySuggestions: '推荐问题最多 {max} 条',
      unavailable: 'AI 助手暂未开启',
      unreachable: '无法连接模型服务，请稍后再试',
      upstream: '模型服务返回错误（{status}）：{message}',
    },
    profile: {
      badNickname: '昵称最多 {max} 个字',
      badBackupName: '联系人姓名最多 {max} 个字',
      badCompany: '公司名称最多 {max} 个字',
      badAddress: '详细地址最多 {max} 个字',
      badSiteUsage: '网站用途最多 {max} 个字',
      badRegion: '请选择所在省份和城市',
      badQQ: 'QQ 号为 5～12 位数字',
      badWeChat: '微信号为 6～20 位字母、数字、- 或 _，以字母开头；也可以填绑定的手机号',
      badBackupPhone: '请填写正确的联系电话，可包含数字、+、-、括号和空格',
      badIndustry: '不支持的行业：{value}',
      badTeamSize: '不支持的团队规模：{value}',
      badPostcode: '邮政编码为 6 位数字',
      badCountry: '不支持的国家或地区：{value}',
      countryLocked: '已完成实名认证，所属国家/地区不可修改',
      avatarBadImage: '请上传 PNG、JPEG 或 GIF 图片，宽高至少 64 像素',
      avatarTooLarge: '图片不能超过 {max} MB',
    },
    systemUpdate: {
      noReleaseKey: '当前版本没有内置发布公钥，无法校验更新',
      upToDate: '主控已是最新版本',
      noUpdater: '主控机尚未安装更新服务（cdnx-updater）',
      busy: '正在更新中，请等待完成',
      notChecked: '请先检查更新',
      badReleaseUrl: '版本仓库的地址不是 http(s) 地址',
      checkFailed: '无法读取版本仓库：{detail}',
      badComponent: '组件只能是节点程序或边缘程序',
      succeeded: '主控已从 {from} 更新到 {to}',
      rolled_back: '更新到 {to} 失败，已恢复到 {from}',
      failed: '更新到 {to} 失败',
      artifactsPreparing: '主控正在下载节点要用的新版本，请稍等一分钟再试',
      artifactsFailed: '主控没能下载节点要用的新版本（正在重试）：{detail}',
    },
    realname: {
      badFee: '每次认证费用最多 {max}',
      badFree: '免费认证次数为 0～100 次',
      badPhone: '请填写本人名下的中国大陆手机号',
      badProvider: '不支持的认证接口：{value}',
      badRegion: '{value} 不是有效的地域，例如 ap-guangzhou',
      badRuleId: 'RuleId 只能是数字',
      badSecretId: 'SecretId 为 16～64 位字母和数字',
      badSecretKey: 'SecretKey 格式不正确',
      insufficientBalance: '本次认证费用 {fee}，账户余额 {balance}，请先充值',
      numberGone: '这条记录没有保留证件号码',
      ruleRequired: '微信人脸核身需要填写业务规则 RuleId',
      tencentKeyRequired: '请填写腾讯云 SecretId 和 SecretKey',
      aliyunKeyRequired: '请填写阿里云 AccessKey ID 和 AccessKey Secret',
      authCodeRequired: '{method}需要填写对应标签的授权码',
      badAccessKeyId: 'AccessKey ID 应为 12–64 位字母和数字',
      badAccessKeySecret: '这不是有效的 AccessKey Secret',
      badAuthCode: '授权码应为 4–64 个字符，不能含空格',
      unavailable: '平台暂未开放在线实名认证',
      already: '账号已完成实名认证',
      badMethod: '请选择平台提供的认证方式',
      badName: '请填写与身份证一致的姓名',
      badCertNo: '请填写正确的 18 位居民身份证号码',
      startFailed: '认证服务暂时无法发起，请稍后再试',
      notFound: '认证记录不存在',
      tooMany: '今天已发起 {max} 次认证，已达上限，请明天再试',
      identityTaken: '该身份证已认证 {max} 个账号，已达上限',
      unknownMethod: '不支持的认证方式：{value}',
      noMethods: '实名认证列表中请至少显示一种认证方式',
      badDefault: '默认认证方式须为列表中显示的方式',
      duplicateMethod: '{method}已在实名认证列表中',
      sumsubKeyRequired: '请填写 Sumsub 的 App Token 和 Secret Key',
      levelRequired: '请填写 Sumsub 的认证级别名称',
      veriffKeyRequired: '请填写 Veriff 的 API Key 和 Shared Secret Key',
      badAppToken: 'App Token 格式不正确',
      badLevelName: '认证级别名称只能包含字母、数字、空格、. _ -',
      badVeriffKey: 'API Key 格式不正确',
      badSumsubSecret: 'Secret Key 格式不正确',
      badVeriffSecret: 'Shared Secret Key 格式不正确',
      badDaily: '每日认证次数为 1～20 次',
      badMaxAccounts: '同一身份证可认证 1～10 个账号',
      encryptionKeyMissing: '请先在 control.yaml 中配置 secrets.encryption_key，再开启实名认证',
    },
    notify: {
      unknownEvent: '没有这类消息',
    },
    msgtpl: {
      badSubject: '邮件标题为 1～200 个字',
      badTitle: '正文标题为 1～100 个字',
      badBody: '正文最多 2000 个字',
      badButton: '按钮文字为 1～20 个字',
      badInboxTitle: '站内信标题为 1～100 个字，中文和英文都要填写',
      badInboxBody: '站内信正文最多 1000 个字（中文和英文各自计算）',
      unknownVar: "这封邮件没有变量 {name}",
      unknownEvent: '没有这个消息：{value}',
    },
    captcha: {
      required: '请先完成人机验证',
      failed: '人机验证未通过，请重试',
      unavailable: '人机验证服务暂时不可用，请稍后再试',
      changed: '验证方式已更换，请重新验证',
      busy: '验证请求太频繁，请稍后再试',
      incomplete: '请先填写所选验证码服务的全部密钥，再开启人机验证',
      unknownProvider: '不支持的验证码服务：{value}',
      unknownOnError: '不支持的异常处理方式：{value}',
      unknownLoginMode: '登录验证只能选关闭、密码输错后或每次登录',
      failuresRange: '输错次数须在 {min} 到 {max} 之间',
      badTencentAppId: 'CaptchaAppId 只能是数字',
      badSecretId: 'SecretId 为 16 到 64 位字母和数字',
      badGeeTestId: '极验 ID 为 16 到 64 位字母和数字',
      badSiteKey: 'reCAPTCHA 网站密钥为 20 到 64 位字母、数字、- 或 _',
      badHost: 'reCAPTCHA 加载地址只能是 www.recaptcha.net 或 www.google.com',
      badSecret: '密钥格式不正确',
      encryptionKeyMissing: '请先在 control.yaml 中设置 secrets.encryption_key，才能保存密钥',
    },
    sms: {
      unavailable: '平台还没有开启短信服务',
      badPhone: '请填写正确的手机号',
      intlUnavailable: '暂不支持向中国大陆以外的手机号发送验证码',
      intlTemplateRequired: '请先在 消息模板 → 短信模板 → 通用模板 中填写国际号码的阿里云模板 CODE',
      smsbaoKeyRequired: '请填写短信宝的用户名和密码（或 ApiKey）',
      badSmsbaoUser: "短信宝用户名只能包含字母、数字、_ . {'@'} -",
      badSmsbaoTemplate: "短信内容须包含 {'{'}code{'}'}（验证码的位置），且不能过长",
      tooSoon: '请 {seconds} 秒后再获取验证码',
      dailyLimit: '这个手机号今天获取验证码的次数已达上限（{max} 次），请明天再试',
      tooMany: '获取验证码过于频繁，请稍后再试',
      sendFailed: '短信发送失败，请稍后再试',
      codeWrong: '短信验证码不正确',
      codeExpired: '短信验证码已失效，请重新获取',
      providerError: '阿里云短信返回 {code}：{message}',
      unreachable: '无法连接短信服务商：{reason}',
      badProvider: '不支持的短信服务商：{value}',
      badAccessKey: 'AccessKey ID 只能包含字母和数字',
      badTemplate: '{value} 不是有效的模板 CODE，格式如 SMS_123456789',
      badTemplateParam: '{value} 不是有效的模板变量名',
      badSign: '短信签名最多 32 个字符',
      badTTL: '验证码有效期为 1–30 分钟',
      badInterval: '同号码发送间隔为 30–600 秒',
      badDaily: '每号码每日上限为 1–100 条',
      encryptionKeyMissing: '主控未配置加密密钥（control.yaml 的 secrets.encryption_key），暂时不能保存 AccessKey Secret',
      accessKeyRequired: '请填写 AccessKey ID',
      secretRequired: '请填写 AccessKey Secret',
      signRequired: '请填写短信签名',
      templateRequired: '请先在 消息模板 → 短信模板 → 通用模板 中填写国内号码的阿里云模板 CODE',
    },
    account: {
      wrongPassword: '登录密码不正确',
      passwordSame: '新密码不能与当前密码相同',
      passwordWeak: '密码需要 {min}–{max} 位，并且至少包含字母、数字、符号中的两种',
      emailInvalid: '邮箱格式不正确',
      emailTaken: '这个邮箱已被其他账号使用',
      phoneInvalid: '手机号格式不正确',
      mfaUnavailable: '平台还没有配置加密密钥，暂时不能绑定 MFA 设备，请联系平台管理员',
      mfaBound: '已经绑定了 MFA 设备',
      mfaNotBound: '还没有绑定 MFA 设备',
      mfaSecretInvalid: '密钥无效，请关闭窗口后重新绑定',
      phoneNeedsCode: '绑定或修改手机号需要短信验证码',
      phoneNotVerified: '请先验证手机号',
    },
    finance: {
      accountExists: '这个支付宝账号已经添加过了',
      accountFormat: '支付宝账号是邮箱或 11 位手机号',
      accountIncomplete: '第 {n} 个收款账户需要填写户名、开户行和账号',
      accountName: '请填写支付宝账号的实名姓名',
      accountTooLong: '第 {n} 个收款账户有内容过长',
      approveAmount: '通过金额需在 ¥0.01 到 ¥{max} 之间',
      autoRenewCancelled: '已退订的套餐不能自动续费',
      badFee: '手续费率需在 0‰ 到 1000‰ 之间，最低手续费不能为负',
      badMin: '最低金额需在 ¥0.01 到 ¥{max} 之间',
      badRefundDays: '可退款天数需在 0 到 {max} 天之间',
      badUpload: '没有找到附件，请重新上传',
      badUploadPurpose: '不支持的上传类型',
      badUploadType: '只支持 PNG、JPEG、WebP 图片和 PDF 文件',
      badWithdrawRange: '单笔提现最低 ¥0.10，最高不超过 ¥{max}，且不低于最低金额',
      email: '邮箱格式不正确',
      emailRequired: '电子发票需要接收邮箱，请先在发票信息中填写',
      emptyUpload: '文件是空的',
      expressRequired: '请填写快递公司和快递单号',
      feeOverMin: '按最低提现金额计算，扣除手续费后不足 ¥0.10，请调低手续费或提高最低金额',
      insufficientBalance: '账户余额 ¥{balance}，需支付 ¥{amount}，请先充值',
      invoiceBadProfile: '请选择一个发票抬头',
      invoiceClosed: '暂不支持申请发票',
      invoiceFileRequired: '请上传电子发票文件',
      invoiceMedium: '不支持这种开票方式',
      invoiceMin: '单张发票金额不能低于 ¥{min}',
      invoiceNoKind: '至少开放一种发票类型和一种开票方式',
      invoiceNumber: '请填写发票号码（8–24 位数字或字母）',
      invoiceType: '不支持这种发票类型',
      labelTooLong: '备注最多 {max} 个字',
      mailIncomplete: '纸质发票需要收件人、联系电话和邮寄地址，请先在发票信息中填写',
      noteRequired: '请填写原因',
      noteTooLong: '说明最多 {max} 个字',
      overCashable: '最多可提现或退款 ¥{max}：已开票的金额不能提现或退款',
      overInvoiceable: '最多可开票 ¥{max}',
      packageNotOnSale: '这个套餐暂未出售',
      periodUnavailable: '套餐「{package}」不出售这个购买时长',
      refundAmount: '请填写退款金额',
      refundBadOrder: '请选择一笔已支付的订单',
      refundClosed: '暂不支持申请退款',
      refundExpired: '这笔订单已超过可退款期限',
      refundNoWindow: '开启退款前，请至少为充值或套餐订单设置可退款天数',
      refundOver: '这笔订单最多可退 ¥{max}',
      refundReason: '请填写退款原因，最多 {max} 个字',
      refundUnavailable: '支付宝未配置，无法原路退款',
      remitAmount: '汇款金额需在 ¥{min} 到 ¥{max} 之间',
      remitBadAccount: '请选择汇入的收款账户',
      remitBadDate: '汇款日期需在最近 90 天内',
      remitClosed: '暂不支持线下汇款',
      remitNoAccount: '开启线下汇款前，请先添加收款账户',
      remitPayerRequired: '请填写汇款户名',
      remitReceiptRequired: '请上传银行汇款凭证',
      remitTooLong: '有内容过长',
      renewConflict: '该套餐刚刚已续费，请刷新后查看',
      reviewNoteTooLong: '备注最多 {max} 个字',
      specialIncomplete: '专用发票需要企业抬头，并填写注册地址、注册电话、开户银行和银行账号',
      stale: '这笔单据已经变化，请刷新后再操作',
      storeClosed: '暂不支持在线购买套餐',
      taxNo: '企业抬头需要填写纳税人识别号（15–20 位数字或大写字母）',
      titleKind: '请选择个人或企业',
      titleRequired: '请填写发票抬头，最多 100 个字',
      titleTooLong: '有内容过长',
      tooManyAccounts: '收款账户最多 {max} 个',
      tooManyPending: '已有 {max} 笔申请在处理中，请等处理完再提交',
      tooManyProfiles: '发票抬头最多 {max} 个',
      tooManyWithdrawAccounts: '提现账户最多 {max} 个',
      transferUnavailable: '支付宝需要使用公钥证书加签方式才能自动转账',
      uploadTooLarge: '文件不能超过 {max} MB',
      withdrawAmount: '单笔提现金额需在 ¥{min} 到 ¥{max} 之间',
      withdrawBadAccount: '请选择一个提现账户',
      withdrawClosed: '暂不支持提现',
    },
    ticket: {
      confidentialClose: '保密消息会在工单关闭时销毁，不能和关闭工单一起发送',
      badAssignee: '请选择一位客服人员',
      badAttachment: '有附件已失效或不属于你，请重新上传',
      badAutoClose: '自动关闭天数需在 0 到 {max} 天之间',
      badCategory: '请选择问题分类',
      badDomain: '请选择你自己的站点',
      badEmail: '「{value}」不是有效的邮箱地址',
      badPriority: '请选择优先级',
      badRating: '请选择 1 到 5 星',
      badUploadType: '只支持图片、PDF、文本和压缩包文件',
      bodyRequired: '请填写内容',
      bodyTooLong: '内容最多 {max} 个字',
      categoryName: '第 {n} 个分类需要填写名称，最多 20 个字',
      categoryRequired: '允许提交工单时，至少要启用一个问题分类',
      closed: '工单已关闭，不能再回复；如有需要请提交新工单',
      closedAlready: '工单已经关闭了',
      closedForNew: '暂不支持在线提交工单，请联系客服',
      commentTooLong: '评价最多 {max} 个字',
      emptyUpload: '文件是空的',
      notClosed: '工单关闭后才能评价',
      notOpen: '只有待处理的工单可以受理',
      alreadyAccepted: '客服已接手这张工单，请直接回复',
      noticeTooLong: '提交须知最多 {max} 个字',
      supportNameTooLong: '客服名称最多 {max} 个字',
      rated: '这个工单已经评价过了',
      templateBody: '请填写回复内容，最多 {max} 个字',
      templateTitle: '请填写模板名称，最多 {max} 个字',
      titleLength: '标题需要 2 到 {max} 个字',
      tooManyCategories: '问题分类最多 {max} 个',
      tooManyEmails: '通知邮箱最多 {max} 个',
      tooManyFiles: '每条回复最多上传 {max} 个附件',
      tooManyOpen: '你已有 {max} 个未关闭的工单，请先关闭已解决的工单',
      tooManyTemplates: '快捷回复最多 {max} 条',
      tooManyUploads: '已有 {max} 个附件等待发送，请先提交或稍后再试',
      uploadTooLarge: '单个文件不能超过 {max} MB',
    },
    complaint: {
      ticketRequired: '投诉需要在相关工单的页面发起',
      badCategory: '请选择投诉类型',
      contentLength: '投诉内容需要 {min}–{max} 个字',
      badTicket: '请选择你自己的工单',
      openForTicket: '这个工单已有一条投诉正在处理，请等待处理结果',
      tooManyOpen: '已有 {max} 条投诉正在处理，请等待处理结果后再提交',
      done: '这条投诉已处理或已撤销',
      notPending: '只有待处理的投诉可以受理',
      resultLength: '请填写处理结果，最多 {max} 个字',
    },
    mail: {
      auth: 'SMTP 服务器拒绝了登录：{reason}',
      badFrom: '「{value}」不是有效的发件人地址',
      badHost: '「{value}」不是有效的服务器地址',
      badPort: '端口需在 1 到 65535 之间',
      badRecipient: '「{value}」不是有效的邮箱地址',
      badSecurity: '不支持的加密方式：{value}',
      badURL: '「{value}」不是有效的控制台地址，格式如 https://cdn.example.com',
      connect: '无法连接 SMTP 服务器：{reason}',
      encryptionKeyMissing: '请先在 control.yaml 中设置 secrets.encryption_key，再保存 SMTP 密码',
      failed: '发送失败：{reason}',
      fromRequired: '请填写发件人地址',
      hostRequired: '请填写 SMTP 服务器',
      notReady: '请先启用邮件服务，并填写服务器和发件人地址',
      passwordRequired: '填写了用户名时需要填写密码',
      rejected: 'SMTP 服务器拒收了邮件：{reason}',
      timeout: 'SMTP 服务器响应超时',
      tls: '加密连接失败：{reason}',
      tooLong: '有内容过长',
    },
    license: {
      readOnly: '平台当前只能查看，暂时无法修改，请联系平台管理员',
      notActive: '主控没有有效授权：请先在「系统授权」页激活',
      nodeQuota: '授权允许 {max} 台节点，现在已有 {used} 台',
      domainQuota: '授权允许 {max} 个站点，现在已有 {used} 个',
      noRepository: '版本仓库只对有授权的主控开放：请先激活授权',
      repoTokenExpired: '版本仓库的下载令牌已过期：授权很久没有续期了',
      noKey: '这个程序没有内置授权公钥，无法校验授权；正式发布的版本带有公钥',
      badPortalUrl: '授权站地址（license.portal_url）不是 http(s) 地址',
      notActivated: '主控还没有激活授权',
      codeInvalid: '授权码不存在，请核对后重新输入',
      revoked: '这份授权已被吊销',
      suspended: '这份授权已被暂停',
      expired: '这份授权的合同期已结束，请在授权站续费',
      notStarted: '这份授权还没到生效日期',
      instancesFull: '这份授权的实例名额已用完：先在授权站释放其他实例',
      instanceUnknown: '授权站不认识这台主控：请用授权码重新激活',
      instanceReleased: '这台主控已被授权站释放：请用授权码重新激活',
      offlineOnly: '这台主控在授权站上是离线授权：请上传新签发的离线授权文件',
      clockSkew: '主控的时钟与授权站相差超过 5 分钟，请校准时间（NTP）后重试',
      portalBusy: '授权站暂时繁忙，请稍后重试',
      portalError: '授权站返回错误（HTTP {status}）：{detail}',
      portalUnreachable: '无法连接授权站 {portal}：{detail}',
      portalBadAnswer: '授权站的回应无法使用：{detail}',
      stateUnwritable: '无法写入授权文件：{detail}',
      instanceCorrupt: '实例密钥文件 {path} 已损坏，请人工修复或删除（删除后是一个新实例）',
      noStateDir: '没有配置授权目录（license.dir）',
      fileInvalid: '这不是有效的授权文件，或签名校验失败',
      unbound: '这份授权没有绑定实例：授权现在只能从授权站取得，请用授权码激活',
      otherInstance: '这份授权属于实例 {instance}，不是本机（{self}）',
      notOffline: '这不是离线授权文件：在线授权请用授权码激活',
      fileExpired: '这份授权文件已经过期',
      offlineNoRenew: '离线授权不会自动续期：请上传授权站新签发的文件',
    },
    billing: {
      adjustTooLarge: '单次调整金额不能超过 ¥{max}',
      adjustZero: '调整金额不能为 0',
      amountRange: '充值金额需在 ¥{min} 到 ¥{max} 之间',
      channelError: '支付宝暂时无法发起支付：{reason}',
      insufficientBalance: '当前余额 ¥{balance}，扣减后不能低于 0',
      methodUnavailable: '该支付方式暂不可用，请换一种方式',
      noteRequired: '请填写调整原因',
      noteTooLong: '调整原因最多 {max} 个字',
      queryFailed: '向支付宝查询订单失败：{reason}',
      tooManyPending: '未支付的订单已有 {max} 笔，请等它们过期（{minutes} 分钟）后再充值',
      unavailable: '在线充值暂未开放',
    },
    payment: {
      alipayPublicKeyRequired: '请填写支付宝公钥',
      appIDRequired: '请填写 AppID',
      badAlipayCert: '支付宝公钥证书格式不正确，应为 RSA 证书',
      badAlipayPublicKey: '支付宝公钥格式不正确，应为 RSA 公钥',
      badAmountRange: '单笔最低金额不能小于 ¥0.01，最高金额不能超过 ¥{max}，且不能低于最低金额',
      badAppCert: '应用公钥证书格式不正确，应为 RSA 证书',
      badAppID: '「{value}」不是有效的支付宝 AppID',
      badBaseURL: '「{value}」不是有效的访问地址，格式如 https://cdn.example.com',
      badPrivateKey: '应用私钥格式不正确，应为 RSA 私钥',
      badRootCert: '支付宝根证书中没有 RSA 证书',
      badSignMode: '不支持的接口加签方式：{value}',
      baseURLRequired: '请先填写用户台访问地址，再启用支付宝',
      certKeyMismatch: '应用公钥证书与应用私钥不匹配',
      certsRequired: '公钥证书模式需要同时上传应用公钥证书、支付宝公钥证书和支付宝根证书',
      encryptionKeyMissing: '主控未配置加密密钥（control.yaml 的 secrets.encryption_key），无法保存应用私钥',
      noProduct: '请至少开启一种支付产品',
      presetOutOfRange: '快捷金额 ¥{value} 超出了单笔金额范围',
      privateKeyRequired: '请填写应用私钥',
      subjectTooLong: '订单标题最多 {max} 个字',
      tooManyPresets: '快捷金额最多 {max} 个',
    },
    credential: {
      nameTooLong: '备注最多 {max} 个字',
    },
    clickhouse: {
      addrRequired: '请填写服务器地址',
      badAddr: '「{addr}」不是「主机:端口」格式',
      badDatabase: '「{database}」不能用作数据库名（只能用字母、数字和下划线，且不能以数字开头）',
      badDays: '{table} 的保留天数必须在 {min} 到 {max} 天之间',
      badHigh: '清理阈值必须在 {min}% 到 {max}% 之间',
      badKeep: '始终保留的天数必须在 {min} 到 {max} 天之间',
      badLow: '清理目标必须在 {min}% 到 {max}% 之间（至少比清理阈值低 5%）',
      busy: '另一个主控实例正在清理，请稍后再试',
      connectFailed: '无法连接 ClickHouse：{error}',
      noDatabase: '服务器上没有数据库 {database}，勾选「初始化表结构」后保存即可自动创建',
      notConfigured: '还没有配置 ClickHouse 服务器',
      notConnected: 'ClickHouse 未连接',
      schemaFailed: '初始化表结构失败：{error}',
      unknownTable: '未知的数据表：{table}',
    },
    quota: {
      topUpEmpty: '请填写要增加的流量或请求数',
    },
    consoleTLS: {
      badSite: '未知的控制台',
      certInUse: '已开启 HTTP 自动跳转 HTTPS，请先关闭跳转再删除证书',
      domainRequired: '请先填写并保存该控制台的域名',
      lockFromOtherHost: '请先通过 {domain} 打开后台，再开启「只允许通过后台域名访问后台」（当前是 {host}）',
      noUsableCert: '{domain} 还没有有效的证书，请先申请或上传证书，再开启 HTTPS 跳转',
      sameDomain: '前台和后台不能使用同一个域名',
    },
    controlTLS: {
      badDomain: '「{value}」不是有效的域名（不能是 IP 或通配符）',
      badMode: '未知的通信方式：{value}',
      badPort: '端口必须在 1 到 65535 之间',
      certExpired: '证书当前无效（有效期至 {not_after}）',
      certInUse: '节点正在使用这张证书，请先把节点通信方式改为「关闭」',
      certNotForDomain: '这张证书只包含 {names}，不包含 {domain}',
      domainChanged: '证书申请期间域名被改成了其他值，请重新申请',
      domainRequired: '请先填写并保存通信域名',
      emailRequired: '申请证书需要填写联系邮箱',
      httpsRequired: '主控只接受 HTTPS 的节点请求',
      noUsableCert: '还没有对该域名有效的证书，请先申请或上传证书',
      nodesOnHTTP: '还有 {count} 个在线节点在使用 HTTP：{nodes}',
    },
    cert: {
      notYours: '这张证书属于其他账号',
      bindingUnavailable: '当前平台未启用按域名配置证书',
      expired: '这张证书已经在 {not_after} 过期了',
      invalidPEM: '证书内容不是有效的 PEM 格式 X.509 证书',
      keyMismatch: '私钥和证书不匹配',
      notCovering: '这张证书只覆盖 {names}，不包含 {host}',
      notUsable: '证书 #{id} 已过期或已吊销',
    },
    linePool: {
      lineRequired: '请选择解析线路',
      lineUnsupported: '该接入域名（{zone}）的 DNS 套餐不支持「{line}」线路，升级解析套餐后才能使用',
      wrongGroup: '这个线路池属于另一个线路组',
      roleInvalid: '主备类型只能是 primary 或 backup（收到 {value}）',
    },
    acme: {
      emailRequired: '申请证书需要填写邮箱',
      emailRequiredForZerossl: '使用 ZeroSSL 需要先填写邮箱才能获取 EAB 凭据',
      issuanceInFlight: '{domain} 已有一个签发任务正在进行，请等它结束',
      issuanceOnAnotherReplica: '另一个控制面实例正在签发这张证书',
      tosRequired: '需要先同意 CA 的服务条款',
      unknownCA: '不支持的证书颁发机构：{value}',
      zerosslNoStaging: 'ZeroSSL 没有测试环境；请用正式环境签发，或改用 Let\'s Encrypt 做测试',
      notConfigured: '平台还没有配置证书签发功能',
      challengeNotServed: '证书颁发机构访问 {domain} 的验证文件时返回 {status}（它访问的是 {ip}）。通常是验证文件还没同步到那台节点，或者那台节点不是解析指向的节点。',
      challengeUnreachable: '证书颁发机构连不上 {domain} 的 80 端口，检查节点防火墙和解析是否正确',
      rateLimited: '证书颁发机构对 {domain} 限流了，请稍后再试（失败次数过多也会触发）',
      dnsProblem: '证书颁发机构解析不了 {domain}，请先确认解析已经生效',
      caaForbids: '{domain} 的 CAA 记录不允许这家机构签发证书',
      issueFailed: '{domain} 的证书签发失败：{detail}',
    },
    auth: {
      badCredentials: '用户名或密码不正确',
      inactiveUser: '该账号已被停用',
      wrongPortal: '该账号不能从这个控制台登录',
      throttled: '尝试次数过多，请 {minutes} 分钟后再试',
      badMfaCode: '动态码不正确或已经用过，请输入新的动态码',
      mfaTicketExpired: '验证超时，请重新输入密码',
      resetUnavailable: '这个账号不能通过短信找回密码（没有已验证的手机号），请联系平台管理员',
      codeLoginOff: '当前未开放验证码登录',
      codeLoginUnavailable: '没有可用这个手机号或邮箱验证码登录的账号，请检查后重试，或使用密码登录',
      subBadCredentials: '主账号、子用户名或密码不正确',
      passkeyOff: '当前未开放通行密钥登录',
      mainAccountOnly: '仅主账号可以操作，子用户无此权限',
    },
    passkey: {
      needsDomain: '通行密钥需要通过 HTTPS 域名访问控制台（不支持 IP 地址）',
      originMismatch: '页面地址与控制台地址不一致，请刷新后重试',
      expired: '通行密钥验证已超时，请重试',
      failed: '通行密钥验证失败，请重试',
      unknown: '该通行密钥未在本平台登记，可能已被删除，请使用密码登录后重新添加',
      exists: '该通行密钥已经添加过了',
      limit: '每个账号最多添加 {max} 个通行密钥，请先删除不用的',
      nameInvalid: '请填写通行密钥名称，最多 {max} 个字符',
    },
    subUser: {
      nameInvalid: '子用户名为 3-32 位字母、数字或 _ . -，以字母或数字开头',
      nameTaken: '已有同名子用户',
      limit: '每个账号最多创建 {max} 个子用户',
      remarkTooLong: '备注最多 {max} 个字符',
      badStatus: '子用户状态只能是启用或停用',
    },
    cacheJob: {
      noNodes: '当前没有在线节点可以下发',
      noTargets: '请至少填写一个目标',
      quota: '最近一小时的缓存任务过多，请稍后再试',
      scheduleNotAllowed: '只有预热任务可以定时执行',
      scheduleTooFar: '预热最多只能提前 {days} 天安排',
      targetHasDotDot: '{value} 不能包含 ..',
      targetNotURL: '{value} 不是一个网址，也不是以 / 开头的路径',
      targetOffSite: '{value} 不属于 {host} —— 任务只能操作自己站点的资源',
      tooManyTargets: '每个任务最多 {max} 个目标，当前 {got} 个',
      unknownKind: '不支持的缓存任务类型：{value}',
    },
    cnameZone: {
      hasGroups: '该域名正被 {count} 个线路组使用，请先把它们指到别的域名',
      inUse: '有 {count} 个线路组正在使用 {domain}，请先把它们迁到别的域名',
      invalid: '请填写主域名，例如 example.com —— 不要带协议、路径、端口或开头的点',
      notApex: '只能填主域名（example.com），不能填它的子域名',
      providerRequired: '请选择一个 DNS 提供商',
      ttlRange: 'TTL 只能填 {min} 到 {max} 秒之间',
      ttlBelowPlan: '该接入域名的解析套餐（{plan}）最低只支持 {min} 秒的 TTL',
    },
    dns: {
      lineGroupNoResolveValue: '套餐绑定的线路组没有解析值，CNAME 无处可指',
      cnameDomainBound: '接入域名 {domain} 还绑定在套餐「{package}」上',
      encryptionKeyMissing: '没有配置加密密钥 —— 请先在 control.yaml 里设置 secrets.encryption_key，再保存 DNS 凭据',
      unsupportedProvider: '不支持的 DNS 提供商类型：{value}',
      cnameZoneMissing: '套餐「{package}」绑定的接入域名 #{id} 读取失败，可能已被删除',
      lineGroupMissing: '套餐「{package}」绑定的线路组 #{id} 读取失败，可能已被删除',
      providerUnavailable: 'DNS 服务商账号 #{id} 无法使用：{detail}',
      providerListFailed: '查询 {zone} 的解析记录失败：{detail}',
      providerWriteFailed: '写入解析记录 {name} 失败：{detail}',
      cnameNameTaken: '{name} 上已经有一条 {type} 记录（值 {value}，记录 ID {record_id}），CNAME 不能与其他记录同名',
      cnameNoZone: '{host} 不在平台的任何接入域名下，没有可用的 DNS 账号去删除它',
      lineGroupValueUnresolvable: '线路组解析值 {target} 在公网 DNS 查不到 IP，使用它的站点将无法访问',
      lineValueNameTaken: '{name} 上已经有一条 {type} 记录（值 {value}，记录 ID {record_id}），线路组的解析值必须用来放节点的 A 记录',
      lineNoActiveNodes: '线路组「{group}」里没有可用节点（需要状态正常且有公网 IPv4），{name} 解析不到任何 IP',
      lineNoDefaultFallback: '{name} 只在「{line}」线路上有记录。其他线路的访问者会走默认线路，而默认线路上没有记录，等于解析不到。',
      supportedLinesFailed: '读取 {zone} 可用解析线路失败：{detail}',
    },
    domain: {
      badCityName: "城市名称不合法：{value}（最多 64 个字，不能包含 {'|'} 或换行）",
      badOriginHost: '「{value}」不是合法的主机名',
      badRealIpHeader: '「{value}」不是合法的请求头名称，只能包含字母、数字和连字符',
      challengeDifficultyRange: '难度只能填 8 到 24 之间',
      challengeTTLRange: '有效期只能填 60 到 86400 秒之间',
      hostNotVerified: '{host} 还没有通过 CNAME 验证，验证通过后才能申请证书',
      siteNotServing: '站点已停用，{host} 暂时不能申请证书',
      cnameLookupFailed: '查询 {host} 的解析失败：{detail}',
      cnameNotFound: '{host} 还没有 CNAME 记录，请添加一条指向 {target}',
      cnamePointsElsewhere: '{host} 当前指向 {resolved}，而不是 {target}',
      cnameTargetMissing: '公网 DNS 查不到 {target}：平台的 CNAME 记录没有生效。请检查接入域名绑定的 DNS 账号是否就是该域名当前使用的解析服务商',
      exemptPathNotAbsolute: '放行路径 {value} 必须以 / 开头',
      exemptPathTooLong: '放行路径 {value} 太长了',
      failBanDurationRange: '封禁时长只能填 {min} 到 {max} 秒',
      failBanMaxRange: '失败次数只能填 {min} 到 {max} 次',
      failBanWindowRange: '统计周期只能填 {min} 到 {max} 秒',
      forbidden: '没有权限操作这个站点',
      geoBanDurationRange: '封禁时长只能填 {min} 到 {max} 秒',
      geoBlockNoRegions: '请至少选择一个国家或地区',
      hostNotInSite: '{host} 不是这个站点的域名',
      hostnameRequired: '请填写域名',
      nameRequired: '请填写名称',
      noCnameTarget: '该站点还没有 CNAME 目标 —— 它所属套餐没有绑定接入域名',
      originNotAHost: '回源地址只能填域名或 IP —— 不要带协议、端口、路径或空格',
      originNotPublic: '回源地址必须是公网地址 —— 不允许内网、回环和链路本地地址',
      packageNotActive: '套餐 {id} 不在该账号的有效套餐里',
      packageRequired: '请选择一个套餐',
      tooManyCities: '城市最多 {max} 个',
      tooManyExemptPaths: '最多只能配置 {max} 条放行路径',
      unknownCCLevel: '不支持的 CC 防护等级：{value}',
      unknownCCAutoLevel: '不支持的自适应 CC 灵敏度：{value}',
      unknownCCAutoMode: '不支持的自适应 CC 验证方式：{value}',
      unknownChallengeMode: '不支持的验证模式：{value}',
      unknownGeoBlockAction: '不支持的区域屏蔽处置方式：{value}',
      unknownGeoBlockMode: '不支持的区域屏蔽模式：{value}',
      unknownProxyMode: '不支持的代理模式：{value}',
      unknownRegion: '未知的国家或地区代码：{value}',
      unknownSslMode: '不支持的 SSL 模式：{value}',
      unknownSubdivision: '未知的省份代码：{value}',
      upstreamLimitRange: '回源并发上限只能填 0 到 {max} 之间',
    },
    firewall: {
      badPort: '「{value}」不是有效的端口或端口范围（1-65535，例如 443 或 8000-8100）',
      blockMode: '未知的拉黑方式：{mode}',
      noPorts: '指定端口模式下至少要填一个端口',
      limitRange: '数值超出范围：必须在 {min} 到 {max} 之间',
      tooManyPorts: '每个列表最多 {max} 个端口或端口范围',
      unknownScope: '未知的封禁范围：{scope}',
    },
    pages: {
      badMode: '页面「{key}」的模式无效：{mode}',
      dropNotAllowed: '页面「{key}」不能设置为直接断开连接',
      graceRange: '宽限期必须在 0 到 {max} 小时之间',
      htmlRequired: '页面「{key}」选择了自定义 HTML，但内容为空',
      htmlTooLarge: '页面「{key}」的 HTML 不能超过 {max} KB',
      messageTooLong: '页面「{key}」的说明文字不能超过 {max} 个字符',
      statusRange: '页面「{key}」的状态码必须在 400 到 599 之间',
      titleRequired: '页面「{key}」选择了自定义文字，需要填写标题',
      titleTooLong: '页面「{key}」的标题不能超过 {max} 个字符',
      unknownKey: '没有名为「{key}」的页面',
    },
    subscription: {
      daysRange: '时长必须在 {min} 到 {max} 天之间',
      expiryBeforeStart: '到期时间不能早于开始时间',
      expiryInPast: '到期时间必须晚于现在',
      notCancelled: '这个套餐没有被取消，不需要恢复',
      packageInactive: '套餐「{name}」已下架，不能分配',
      packageNotFound: '套餐不存在',
      resumeExpired: '这个套餐已经过期，请使用续期',
      userNotFound: '用户不存在',
    },
    ipList: {
      badEnforcement: '拦截方式只能是 {edge} 或 {kernel}',
      badKind: '名单类型只能是 {allow} 或 {deny}',
      batchTooLarge: '每批最多 {max} 个地址，当前 {got} 个',
      full: '名单已满',
      invalidTarget: '不是有效的 IP 地址或 CIDR 网段',
      noAddresses: '请至少填写一个地址',
      noteTooLong: '备注最多 {max} 个字符',
      targetTooBroad: '这个网段范围太大，不能封禁',
      unknownScope: '不支持的作用范围：{value}',
    },
    node: {
      aliasTooLong: '昵称最多 {max} 个字符',
      cannotInitFromStatus: '当前状态是「{status}」，不能激活',
      fingerprintTaken: '该机器指纹已经用另一个令牌注册过了',
      invalidRegisterToken: '注册令牌无效',
      ipNotPublic: '这不是一个公网可路由的地址',
      noActiveAgentToken: '节点 {id} 没有可用的 Agent 令牌',
      notAnIP: '{value} 不是一个 IP 地址',
      primaryIPImmutable: '主地址是节点心跳上报的，不能删除',
      regionNotRegistered: '地区代码 {region} 还没有登记 —— 请先到「地区管理」添加',
      registerFieldsRequired: '注册令牌和机器指纹都不能为空',
      tokenExpired: '注册令牌已过期',
      tokenUsed: '注册令牌已经用过了',
    },
    nodeGroup: {
      cnameZoneRequired: '请选择一个接入域名',
      hasMembers: '该线路组还有 {count} 个节点，请先把它们移到别的组',
      resolveValueNotUnderZone: '解析值 {value} 必须是 {zone} 的子域名',
      resolveValueRequired: '请填写解析值',
      lineInvalid: '解析线路代码 {value} 不合法（只能是小写字母、数字和下划线）',
    },
    l4: {
      badStatsRange: '不支持的统计时间范围：{range}',
      badBalance: '负载方式只能是轮询或源 IP 哈希',
      badProtocol: '转发协议只能是 TCP、UDP 或 TCP+UDP',
      badProxyProtocol: 'PROXY 协议只能是关闭、v1 或 v2',
      badRange: '端口范围需在 {min}–{max} 之间，起始端口不能大于结束端口',
      nameLength: '规则名称需为 1–{max} 个字符',
      noFreePort: '端口范围内已没有空闲端口，请联系客服',
      originFormat: '第 {n} 个源站「{value}」格式不正确，应为 地址:端口，IPv6 地址需加方括号',
      originNotPublic: '第 {n} 个源站「{value}」不是公网地址，内网、本机和链路本地地址不能作为源站',
      originRepeated: '第 {n} 个源站「{value}」重复了',
      originRequired: '请至少填写一个源站',
      packageNotActive: '所选套餐不是您当前有效的套餐',
      packageRequired: '请选择套餐',
      portRange: '监听端口需在 {min}–{max} 之间',
      portReserved: '端口 {port} 是系统保留端口，请换一个',
      portTaken: '端口 {port} 已被占用，请换一个或留空自动分配',
      remarkLength: '备注最多 {max} 个字符',
      tooManyOrigins: '最多填写 {max} 个源站',
    },
    package: {
      cnameBindingIncomplete: '接入域名、线路组、CNAME 解析值需要同时填写，或者都不填',
      cnameValueInvalid: 'CNAME 解析值 {value} 不合法，只能用字母、数字和短横线，多段用点分隔',
      cnameZoneNotFound: '接入域名 {id} 不存在',
      nodeGroupNoResolveValue: '线路组「{name}」没有解析值，请先给它设置解析值',
      nodeGroupNotFound: '线路组 {id} 不存在',
      descTooLong: '套餐描述最多 {max} 个字符',
      nameRequired: '请填写套餐名',
      unknownCnameMode: '不支持的 CNAME 生成模式：{value}',
      valueOutOfRange: '{field} 只能填 0 到 {max} 之间（0 表示不限）',
      groupNotFound: '套餐分组 {id} 不存在',
      noWaf: '当前套餐「{package}」不包含 WAF，升级套餐后才能使用',
      noCustomCc: '当前套餐「{package}」不包含自定义 CC 规则，可以使用 CC 防护等级',
      noWebsocket: '当前套餐「{package}」不包含 WebSocket',
      noHttp3: '当前套餐「{package}」不包含 HTTP/3',
      noCustomCert: '当前套餐「{package}」不支持上传证书，可以申请免费证书',
      noOpenapi: '您的套餐都不包含 OpenAPI，升级套餐后才能使用 API 密钥',
      noFeature: '当前套餐「{package}」不包含该功能',
      siteQuota: '套餐「{package}」最多 {max} 个站点，已达上限',
      domainQuota: '套餐「{package}」最多 {max} 个域名（含子域名），已达上限',
      apexQuota: '套餐「{package}」最多 {max} 个主域名，已达上限',
      ruleQuota: '套餐「{package}」每个站点最多 {max} 条规则，已达上限',
      noL4: '当前套餐「{package}」不包含应用加速，升级套餐后才能使用',
      l4Quota: '套餐「{package}」最多 {max} 条应用加速规则，已达上限',
    },
    packageGroup: {
      descTooLong: '分组描述最多 {max} 个字符',
      hasPackages: '该分组下还有 {count} 个套餐，请先把它们移到别的分组',
      nameRequired: '请填写分组名称',
      nameTaken: '已经有同名的套餐分组了',
      nameTooLong: '分组名称最多 {max} 个字符',
    },
    publish: {
      nothingToPublish: '没有可发布的内容：平台上还没有站点',
    },
    region: {
      codeInUse: '还有 {count} 个节点在用「{code}」—— 确认后会一并迁到新代码，或者只改名称、保留代码',
      codeInvalid: '地区代码只能包含字母、数字、短横线和下划线，长度 1-32',
      hasNodes: '该地区下还有 {count} 个节点，请先把它们移到别的地区',
      nameRequired: '请填写地区名称',
    },
    registration: {
      badUsername: '用户名为 3–32 位字母、数字或 _ . -，以字母或数字开头',
      usernameTaken: '该用户名已被注册',
      emailTaken: '该邮箱已注册，请直接登录',
      phoneTaken: '该手机号已绑定其他账号',
      agreeRequired: '请先阅读并同意用户协议',
      closed: '当前未开放注册',
      noDefaultPackage: '还没有配置默认套餐，无法开放注册',
      passwordTooShort: '密码至少 {min} 位',
      rateLimited: '该地址注册太频繁，请稍后再试',
    },
    rule: {
      aclBadHeader: '「{value}」不是合法的请求头名称',
      aclBadMatch: '匹配条件格式不正确',
      aclBadValue: '「{value}」不符合这种规则类型',
      aclNoValues: '规则没有任何匹配值，至少填一个',
      aclTooManyValues: '一条规则最多 {max} 个值，更多的请放进 IP 名单',
      aclUnknownAction: '不支持的访问控制动作：{value}',
      botBadSignature: '匹配方式格式不正确：正则和包含二选一',
      botUnknownAction: '不支持的机器人规则动作：{value}',
      browserTTLRange: '浏览器缓存时间只能填 -1（跟随）或 0 到 {max} 之间',
      ccBadConditions: '匹配条件格式不正确',
      ccBadCountStatus: '「{value}」不是合法的状态码，可填 404 或 5xx 这样的形式',
      ccBadEscalation: '阶梯处置格式不正确',
      ccBadParams: '处置参数格式不正确',
      ccDimensionsEmpty: 'CC 统计维度不能为空',
      ccPathNotAbsolute: '路径「{value}」必须以 / 开头',
      ccPathTooLong: '路径最多 512 个字符',
      ccStatusRange: '响应状态码只能是 4xx 或 5xx',
      ccTTLRange: '处置时长最多 {max} 秒',
      ccThresholdRange: '阈值只能填 1 到 1000000 之间',
      ccTooManyDimensions: '统计维度最多 {max} 个',
      ccTooManyTiers: '阶梯处置最多 {max} 级',
      ccUnknownAction: '不支持的处置动作：{value}',
      ccUnknownMethod: '不支持的请求方法：{value}',
      ccUnknownMitigation: '不支持的处置方式：{value}',
      ccUnknownPathMode: '不支持的路径匹配方式：{value}',
      ccWindowRange: '统计周期只能填 1 到 86400 秒',
      notAStatusCode: '{value} 不是一个 HTTP 状态码',
      patternEmpty: '匹配规则不能为空，否则会匹配所有请求',
      patternInvalid: '「{value}」不是合法的正则表达式',
      patternTooLong: '匹配规则最多 {max} 个字符',
      staleIfErrorRange: '回源失败时的宽限时间超出范围',
      staleWhileRevalidateRange: '后台revalidate的宽限时间超出范围',
      statusTTLRange: '状态码 {code} 的缓存时间超出范围',
      ttlRange: '缓存时间只能填 0 到 {max} 之间',
      unknownStatus: '不支持的规则状态：{value}',
      unsupportedAclType: '不支持的访问控制类型：{value}',
      unsupportedCcDimension: '不支持的 CC 统计维度：{value}',
      wafBadDefinition: 'WAF 规则格式不正确',
      wafNoTargets: '至少选择一个检测位置',
      wafScoreRange: '分值只能填 {min} 到 {max}',
      wafUnknownCategory: '不支持的 WAF 分类：{value}',
      wafUnknownTarget: '不支持的检测位置：{value}',
    },
    settings: {
      unknownLogo: '没有这个 LOGO 位置',
      logoEmpty: 'LOGO 文件是空的',
      logoTooLarge: 'LOGO 不能超过 {max} KB',
      logoBadSvg: 'SVG 文件无法解析，请导出为标准 SVG 后重试',
      unknownBackground: '没有这个背景图片位置',
      backgroundEmpty: '图片是空的',
      backgroundTooLarge: '背景图片不能超过 {max} MB',
      backgroundBadType: '背景图片支持 PNG、JPG、WebP 或 SVG 格式',
      logoBadType: 'LOGO 须为 PNG、JPG、WebP、GIF 或 SVG 图片',
      agreementTooLong: '协议内容最多 {max} KB',
      footerBadLinkKind: '不支持的页脚链接类型：{value}',
      footerBadLinkURL: '第 {n} 个页脚链接的地址须以 http:// 或 https:// 开头',
      footerCopyrightTooLong: '版权信息最多 {max} 个字符',
      footerLinkNoText: '第 {n} 个页脚链接还没有填写名称',
      footerLinkTextTooLong: '第 {n} 个页脚链接的名称最多 {max} 个字符',
      footerTooManyLinks: '页脚链接最多 {max} 个',
      loginNoticeEmpty: '登录页公告已开启，请填写公告内容',
      noticeTooLong: '公告内容最多 {max} KB',
      registerNoticeEmpty: '注册页公告已开启，请填写公告内容',
      badAgreementMode: '协议的提供方式不正确',
      badAgreementURL: '协议链接须以 http:// 或 https:// 开头',
      badWebsiteURL: '官网地址须以 http:// 或 https:// 开头',
      mailNotReady: '请先在 邮件服务 中启用并配置邮件，再开启注册验证邮箱',
      smsNotReady: '请先在 短信服务 中启用并配置短信，再开启注册验证手机',
      badNavbarHeight: '导航栏高度须在 {min}–{max} 像素之间',
      badMenuWidth: '菜单宽度须在 {min}–{max} 像素之间',
      badSkin: '{value} 不是可选的主题色',
      badLevelBadge: '没有这个 VIP 标志样式',
      defaultPackageRequired: '开放注册前需要先设置默认套餐',
      faviconEmpty: '图标文件是空的',
      faviconNotIco: '图标必须是 .ico 文件',
      faviconTooLarge: '图标最大 {max} KB',
      tooLong: '{field} 最多 {max} 个字符',
    },
    stats: {
      unavailable: '统计功能需要 ClickHouse，当前不可用',
    },
    task: {
      autoRenewed: '「{package}」已从余额自动续费 ¥{amount}，有效期至 {until}',
      autoRenewError: '续费未能完成：数据库出错，请稍后重试',
      autoRenewGone: '套餐 #{id} 已不存在',
      autoRenewNotDue: '无需续费：套餐有效期至 {until}',
      autoRenewOff: '客户已关闭自动续费，未扣费',
      badResultStatus: '任务结果状态只能是 success 或 failed，收到 {value}',
      certDeleted: '证书 #{cert_id} 已被删除',
      certIssued: '{domain} 的证书已由 {issuer} 签发',
      certRenewed: '{domain} 的证书已由 {issuer} 续期',
      clickhouseDroppedBoth: '删除了 {days} 天的数据，清空了 {logs} 张系统日志表，释放 {size}',
      clickhouseDroppedDays: '删除了 {days} 天的数据，释放 {size}',
      clickhouseDroppedLogs: '清空了 {logs} 张系统日志表，释放 {size}',
      clickhouseFailed: '清理失败：{error}',
      clickhouseNothing: '没有需要清理的数据',
      clickhouseStillFull: '清理后磁盘仍高于清理目标：剩下的数据都在始终保留的天数内，或者磁盘被其他数据占用',
      l4RuleDeleted: '应用加速规则 #{id} 已被删除',
      l4CnameNotBound: '规则所属套餐已不再分配 CNAME（接入域名、线路组或 CNAME 值未设置）',
      cnameNotBound: '站点所属套餐已不再分配 CNAME（接入域名、线路组或 CNAME 值未设置）',
      aliasActivated: '{host} 解析验证通过，节点开始加速',
      aliasAlreadyActive: '{host} 已经验证过，无需再验证',
      aliasDeleted: '别名 {host} 已被删除',
      cnamePublished: '已发布 {host} → {target}（{action}）',
      cnameRemoved: '站点已删除，已删除它的 CNAME 记录 {host}',
      cnameAlreadyGone: '{host} 已不存在，无需删除',
      cnameStillUsed: '{host} 仍在被 {user} 使用，保留不删',
      internal: '内部错误：{detail}',
      lineGroupDeleted: '线路组 #{id} 已被删除',
      lineNotBound: '该线路组还没有配置解析值和接入域名，没有可发布的记录',
      linePublished: '{host} 已指向 {count} 个节点 IP',
      linePublishedWithBackup: '{host} 已指向 {count} 个 IP，其中 {lines} 条线路启用了备用地址',
      lineUnchanged: '{host} 的解析已是最新：{count} 个节点 IP，无需改动',
      lineUnchangedWithBackup: '{host} 的解析已是最新：{count} 个 IP，{lines} 条线路仍在使用备用地址',
      notSystemTask: '只有系统任务可以重试',
      renewNoNames: '证书上的域名都已不属于 {domain}，无需续期',
      renewNoSite: '证书 #{cert_id} 不属于任何站点，无需续期',
      renewSuperseded: '已续期：证书 #{cert_id} 覆盖了相同的域名',
      running: '任务正在执行，请稍后再试',
      siteActivated: '{host} 解析验证通过，站点已生效',
      siteAlreadyActive: '站点当前状态为 {status}，无需验证',
      siteDeleted: '站点 #{id} 已被删除',
      unsupportedType: '不支持的任务类型：{value}',
      waitingForPublish: '等待站点的 CNAME 记录发布完成',
    },
    user: {
      encryptionKeyMissing: '没有配置加密密钥 —— 请先在 control.yaml 里设置 secrets.encryption_key，再保存证件号码',
      noIdentity: '该账号没有保存证件号码',
      passwordRequired: '创建用户必须设置密码',
      unknownRealNameStatus: '不支持的实名状态：{value}',
      unknownRealNameType: '不支持的实名类型：{value}',
      unknownStatus: '不支持的用户状态：{value}',
    },
    member: {
      badExp: '经验值为 0 到 {max}',
      badThresholds: '{n} 个 VIP 门槛需从 1 起逐级递增，最大 {max}',
      noteRequired: '请填写调整说明，客户会在记录里看到',
      noteTooLong: '说明最多 {max} 个字',
      badChange: '调整数量为 1 到 {max}',
      expBelowZero: '该客户只有 {n} 经验，不能扣得更多',
      noCustomer: '找不到这个客户，可能已被删除',
      growthBelowZero: '该客户只有 {n} 成长值，不能扣得更多',
    },
    userGroup: {
      hasMembers: '该用户组还有 {count} 个成员，请先把他们移到别的组',
    },
    deployment: {
      badResultStatus: '下发结果状态不合法：{value}',
    },
  },
}
